export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Cursor: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  EmailAddress: { input: any; output: any };
  JSON: { input: any; output: any };
  ObjectId: { input: any; output: any };
  URL: { input: any; output: any };
};

export enum IAboutContentType {
  Image = "IMAGE",
  Podcast = "PODCAST",
  Video = "VIDEO",
}

export type IAboutPage = {
  __typename: "AboutPage";
  sections: Array<IAboutPageSection>;
};

export type IAboutPageConfig = {
  __typename: "AboutPageConfig";
  _id: Scalars["ObjectId"]["output"];
  active: Scalars["Boolean"]["output"];
  config: IAboutPageConfigFields;
  createdAt: Scalars["DateTime"]["output"];
  createdBy: Maybe<IUser>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type IAboutPageConfigFields = {
  __typename: "AboutPageConfigFields";
  bannerBackgroundDescription: Maybe<Scalars["String"]["output"]>;
  bannerBackgroundSrc: Maybe<Scalars["String"]["output"]>;
  bannerContentDescription: Maybe<Scalars["String"]["output"]>;
  bannerContentSize: Maybe<Scalars["String"]["output"]>;
  bannerContentText: Scalars["String"]["output"];
  bannerContentType: IAboutContentType;
  boxesSectionBackgroundColor: Scalars["String"]["output"];
  headingText: Scalars["String"]["output"];
  headingTextFontColor: Scalars["String"]["output"];
  joinSectionBackground: Scalars["String"]["output"];
  joinSectionButtonColor: Scalars["String"]["output"];
  joinSectionButtonFontColor: Scalars["String"]["output"];
  joinSectionButtonHref: Scalars["String"]["output"];
  joinSectionButtonText: Maybe<Scalars["String"]["output"]>;
  joinSectionSubtitle: Maybe<Scalars["String"]["output"]>;
  joinSectionSubtitleFontColor: Scalars["String"]["output"];
  joinSectionTitle: Maybe<Scalars["String"]["output"]>;
  joinSectionTitleFontColor: Scalars["String"]["output"];
  leftBox: ISideContent;
  leftBoxIconDescription: Maybe<Scalars["String"]["output"]>;
  leftButtonBackgroundColor: Scalars["String"]["output"];
  leftButtonBorderColor: Maybe<Scalars["String"]["output"]>;
  leftButtonHoverColor: Maybe<Scalars["String"]["output"]>;
  leftButtonHref: Scalars["String"]["output"];
  leftButtonText: Scalars["String"]["output"];
  leftButtonTextColor: Scalars["String"]["output"];
  logoSectionBackgroundColor: Scalars["String"]["output"];
  logoUrls: Array<IAboutPageLogo>;
  rightBox: ISideContent;
  rightBoxIconDescription: Maybe<Scalars["String"]["output"]>;
  rightButtonBackgroundColor: Scalars["String"]["output"];
  rightButtonBorderColor: Maybe<Scalars["String"]["output"]>;
  rightButtonHoverColor: Maybe<Scalars["String"]["output"]>;
  rightButtonHref: Scalars["String"]["output"];
  rightButtonText: Scalars["String"]["output"];
  rightButtonTextColor: Scalars["String"]["output"];
  subtitleText: Scalars["String"]["output"];
  subtitleTextFontColor: Scalars["String"]["output"];
  videoSectionBackground: Scalars["String"]["output"];
  videoSectionContentText: Maybe<Scalars["String"]["output"]>;
  videoSectionContentType: IAboutContentType;
  videoSectionFontColor: Scalars["String"]["output"];
  videoSectionTitle: Maybe<Scalars["String"]["output"]>;
};

export type IAboutPageConfigInput = {
  bannerBackgroundDescription: InputMaybe<Scalars["String"]["input"]>;
  bannerBackgroundSrc: InputMaybe<Scalars["String"]["input"]>;
  bannerContentDescription: InputMaybe<Scalars["String"]["input"]>;
  bannerContentSize: InputMaybe<Scalars["String"]["input"]>;
  bannerContentText: Scalars["String"]["input"];
  bannerContentType: IAboutContentType;
  boxesSectionBackgroundColor: Scalars["String"]["input"];
  headingText: Scalars["String"]["input"];
  headingTextFontColor: Scalars["String"]["input"];
  joinSectionBackground: Scalars["String"]["input"];
  joinSectionButtonColor: Scalars["String"]["input"];
  joinSectionButtonFontColor: Scalars["String"]["input"];
  joinSectionButtonHref: Scalars["String"]["input"];
  joinSectionButtonText: InputMaybe<Scalars["String"]["input"]>;
  joinSectionSubtitle: InputMaybe<Scalars["String"]["input"]>;
  joinSectionSubtitleFontColor: Scalars["String"]["input"];
  joinSectionTitle: InputMaybe<Scalars["String"]["input"]>;
  joinSectionTitleFontColor: Scalars["String"]["input"];
  leftBox: ISideContentInput;
  leftButtonBackgroundColor: Scalars["String"]["input"];
  leftButtonBorderColor: InputMaybe<Scalars["String"]["input"]>;
  leftButtonHoverColor: InputMaybe<Scalars["String"]["input"]>;
  leftButtonHref: Scalars["String"]["input"];
  leftButtonText: Scalars["String"]["input"];
  leftButtonTextColor: Scalars["String"]["input"];
  logoSectionBackgroundColor: Scalars["String"]["input"];
  logoUrls: Array<IAboutPageLogoInput>;
  name: InputMaybe<Scalars["String"]["input"]>;
  rightBox: ISideContentInput;
  rightButtonBackgroundColor: Scalars["String"]["input"];
  rightButtonBorderColor: InputMaybe<Scalars["String"]["input"]>;
  rightButtonHoverColor: InputMaybe<Scalars["String"]["input"]>;
  rightButtonHref: Scalars["String"]["input"];
  rightButtonText: Scalars["String"]["input"];
  rightButtonTextColor: Scalars["String"]["input"];
  subtitleText: Scalars["String"]["input"];
  subtitleTextFontColor: Scalars["String"]["input"];
  videoSectionBackground: Scalars["String"]["input"];
  videoSectionContentText: InputMaybe<Scalars["String"]["input"]>;
  videoSectionContentType: IAboutContentType;
  videoSectionFontColor: Scalars["String"]["input"];
  videoSectionTitle: InputMaybe<Scalars["String"]["input"]>;
};

export type IAboutPageLogo = {
  __typename: "AboutPageLogo";
  description: Maybe<Scalars["String"]["output"]>;
  imageUrl: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type IAboutPageLogoInput = {
  description: InputMaybe<Scalars["String"]["input"]>;
  imageUrl: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type IAboutPageSection =
  | IDisruptorProductsAboutPageSection
  | ILatestGovernmentsAboutPageSection
  | IMostPopularProject
  | IProductsAboutPageSection
  | IProjectsAboutPageSection
  | IReportsAboutPageSection
  | IStoriesAboutPageSection
  | ITopFeaturedReport
  | ITopFeaturedStories;

export type IActiveSubscription = {
  __typename: "ActiveSubscription";
  _id: Scalars["ObjectId"]["output"];
  collectionMethod: Maybe<ICollectionMethod>;
  freeSubscription: Maybe<Scalars["Boolean"]["output"]>;
  lastCharge: Maybe<ICharge>;
  nextPaymentAmount: Maybe<Scalars["Int"]["output"]>;
  nextPaymentDate: Maybe<Scalars["DateTime"]["output"]>;
  pausePaymentCollection: Maybe<Scalars["Boolean"]["output"]>;
  stripeStatus: Maybe<Scalars["String"]["output"]>;
  subscribedAt: Scalars["DateTime"]["output"];
  trialPeriod: Maybe<Scalars["Int"]["output"]>;
};

export type IAddCollectionInput = {
  description: Scalars["String"]["input"];
  displayOptions: InputMaybe<ICollectionDisplayOptionsInput>;
  isFeatured: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  sponsoring: ICollectionSponsoring;
  sponsoringProducts: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  sponsoringVendors: Array<Scalars["ObjectId"]["input"]>;
  tags: Array<Scalars["ObjectId"]["input"]>;
};

export type IAddGovernmentInput = {
  awards: Array<Scalars["ObjectId"]["input"]>;
  budget: InputMaybe<Scalars["Float"]["input"]>;
  country: Scalars["String"]["input"];
  county: InputMaybe<Scalars["String"]["input"]>;
  currency: Scalars["String"]["input"];
  governmentType: Scalars["String"]["input"];
  logo: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  population: Scalars["Float"]["input"];
  resources: Array<IResourceInput>;
  site: InputMaybe<Scalars["String"]["input"]>;
  state: Scalars["String"]["input"];
  stateName: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  zipCode: Scalars["String"]["input"];
};

export type IAddPlanInput = {
  displayName: Scalars["String"]["input"];
  limits: ILimitsInput;
  name: Scalars["String"]["input"];
  stripePlanId: InputMaybe<Scalars["String"]["input"]>;
  tier: IPlanTier;
};

export type IAlgoliaKeys = {
  __typename: "AlgoliaKeys";
  default: Scalars["String"]["output"];
  projects: Scalars["String"]["output"];
};

export enum IAllSponsorshipsFilter {
  All = "ALL",
  Archived = "ARCHIVED",
}

export type IAllVendorsFilterInput = {
  active: InputMaybe<Scalars["Boolean"]["input"]>;
  hasCustomLimits: InputMaybe<Scalars["Boolean"]["input"]>;
  hasOwner: InputMaybe<Scalars["Boolean"]["input"]>;
  inTiers: InputMaybe<Array<Scalars["Int"]["input"]>>;
  plan: InputMaybe<Scalars["String"]["input"]>;
  planId: InputMaybe<Scalars["String"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sponsorships: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  stripeStatus: InputMaybe<Scalars["String"]["input"]>;
  tab: InputMaybe<Scalars["String"]["input"]>;
};

export type IAppStoreProductDeployment = {
  __typename: "AppStoreProductDeployment";
  linkHref: Scalars["String"]["output"];
};

export enum IAssistiveTechnology {
  AlternativeInputDevice = "ALTERNATIVE_INPUT_DEVICE",
  ScreenMagnification = "SCREEN_MAGNIFICATION",
  ScreenReader = "SCREEN_READER",
  SpeechInput = "SPEECH_INPUT",
  TextReader = "TEXT_READER",
}

export type IAttachmentInput = {
  filename: Scalars["String"]["input"];
  size: Scalars["Int"]["input"];
  type: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type IBatchGovernmentsUploadResult = {
  __typename: "BatchGovernmentsUploadResult";
  /** The number of Governments that were added to the system. */
  addedCount: Scalars["Int"]["output"];
  /** The number of Governments that were already in the system and were not added. */
  skippedCount: Scalars["Int"]["output"];
  /** The number of Governments that were submitted for addition. */
  totalCount: Scalars["Int"]["output"];
};

export type IBilling = {
  __typename: "Billing";
  card: Maybe<ICardSource>;
};

export type IBillingInformation = {
  addressLine1: Scalars["String"]["input"];
  addressLine2: Scalars["String"]["input"];
  city: Scalars["String"]["input"];
  country: Scalars["String"]["input"];
  email: Scalars["EmailAddress"]["input"];
  firstName: Scalars["String"]["input"];
  lastName: Scalars["String"]["input"];
  postalCode: Scalars["String"]["input"];
  region: InputMaybe<Scalars["String"]["input"]>;
  state: InputMaybe<Scalars["String"]["input"]>;
};

export type IBlockData = {
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
};

export enum IBlockLayoutType {
  Advertisement = "ADVERTISEMENT",
  EmptySpaceBlock = "EMPTY_SPACE_BLOCK",
  Events = "EVENTS",
  ExternalLinks = "EXTERNAL_LINKS",
  FeaturedStories = "FEATURED_STORIES",
  Image = "IMAGE",
  NewProjects = "NEW_PROJECTS",
  PlusBlock = "PLUS_BLOCK",
  Podcast = "PODCAST",
  StatCounters = "STAT_COUNTERS",
  TrendingCollections = "TRENDING_COLLECTIONS",
  TrendingGovernments = "TRENDING_GOVERNMENTS",
}

export type IBookmarkTarget =
  | ICollection
  | IGovernmentPost
  | IGovernmentProject
  | IGroupPost
  | IGroupProject
  | IProduct
  | IStory
  | IVendorPost
  | IVendorProject;

export enum IBookmarkType {
  Collection = "COLLECTION",
  Post = "POST",
  Product = "PRODUCT",
  Project = "PROJECT",
  Story = "STORY",
}

export enum IBulkTaggingEntityType {
  Project = "PROJECT",
}

export enum IBulkTaggingModifyStrategy {
  Add = "ADD",
  Overwrite = "OVERWRITE",
  Remove = "REMOVE",
}

export type ICardSource = {
  __typename: "CardSource";
  brand: Scalars["String"]["output"];
  expirationMonth: Scalars["Int"]["output"];
  expirationYear: Scalars["Int"]["output"];
  lastFourDigits: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type ICarouselImage = {
  __typename: "CarouselImage";
  alt: Maybe<Scalars["String"]["output"]>;
  src: Scalars["String"]["output"];
};

export type ICarouselImageInput = {
  alt: InputMaybe<Scalars["String"]["input"]>;
  src: Scalars["String"]["input"];
};

export type ICarouselSideContent = {
  __typename: "CarouselSideContent";
  buttonBackgroundColor: Maybe<Scalars["String"]["output"]>;
  buttonFontColor: Maybe<Scalars["String"]["output"]>;
  buttonHref: Maybe<Scalars["String"]["output"]>;
  buttonText: Maybe<Scalars["String"]["output"]>;
  images: Array<ICarouselImage>;
  text: Scalars["String"]["output"];
  textHref: Maybe<Scalars["String"]["output"]>;
  textHrefHoverColor: Maybe<Scalars["String"]["output"]>;
  type: Scalars["String"]["output"];
};

export type IChangeDetails = {
  __typename: "ChangeDetails";
  firstInvoiceAfterProrateDate: Maybe<Scalars["Date"]["output"]>;
  prorateCost: Maybe<Scalars["Int"]["output"]>;
  proratePaymentDueDate: Maybe<Scalars["Date"]["output"]>;
};

export type ICharge = {
  __typename: "Charge";
  amount: Scalars["Int"]["output"];
  amountRefunded: Scalars["Int"]["output"];
  card: Maybe<ICardSource>;
  currency: Scalars["String"]["output"];
  friendlyId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  paidAt: Maybe<Scalars["DateTime"]["output"]>;
  receiptUrl: Maybe<Scalars["String"]["output"]>;
  status: IChargeStatus;
};

export enum IChargeStatus {
  Failed = "FAILED",
  Pending = "PENDING",
  Succeeded = "SUCCEEDED",
}

export type ICity = {
  __typename: "City";
  _id: Scalars["ObjectId"]["output"];
  /** ISO 3166-2 country code */
  country: Scalars["String"]["output"];
  countryName: Scalars["String"]["output"];
  county: Maybe<Scalars["String"]["output"]>;
  governmentType: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
  population: Maybe<Scalars["Int"]["output"]>;
  state: Scalars["String"]["output"];
  stateName: Maybe<Scalars["String"]["output"]>;
  type: Maybe<Scalars["String"]["output"]>;
  zip: Maybe<Scalars["String"]["output"]>;
};

export type ICityStateArgs = {
  full: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type ICollection = {
  __typename: "Collection";
  _id: Scalars["ObjectId"]["output"];
  adminStats: ICollectionAdminStats;
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  content: ICollectionContent;
  contentCounters: ICollectionContentCounters;
  createdAt: Scalars["DateTime"]["output"];
  /**
   * The User who created the collection. It will be an Admin most likely. It also can be "null" since legacy
   * collections didn't have this field tracked in the database.
   */
  createdBy: Maybe<IUser>;
  description: Scalars["String"]["output"];
  displayOptions: Maybe<ICollectionDisplayOptions>;
  featuredAt: Maybe<Scalars["DateTime"]["output"]>;
  /** This will be true if a Collection Sponsoring Sale exists for that collection. */
  hasSponsoringSale: Scalars["Boolean"]["output"];
  /** This will be true if a Collection Sponsoring Sale is active for that collection. */
  isSponsoringSaleActive: Scalars["Boolean"]["output"];
  /** The User who last updated certain properties of the collection */
  lastUpdatedBy: Maybe<IUser>;
  name: Scalars["String"]["output"];
  newContentCounters: ICollectionContentCounters;
  packaging: ICollectionPackaging;
  position: Scalars["Int"]["output"];
  publicContentAvailable: Maybe<Scalars["Boolean"]["output"]>;
  publishedAt: Maybe<Scalars["DateTime"]["output"]>;
  slug: Scalars["String"]["output"];
  sponsoring: ICollectionSponsoring;
  sponsoringProducts: Array<IProduct>;
  sponsoringVendors: Array<ICompany>;
  status: ICollectionStatus;
  tags: Array<ITag>;
  updatedAt: Scalars["DateTime"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
};

export type ICollectionContentArgs = {
  cursor: InputMaybe<Scalars["String"]["input"]>;
  filterByCountry?: InputMaybe<Array<Scalars["String"]["input"]>>;
  filterByItemType: ICollectionItemType;
  filterByTagSlugs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ICollectionContentCountersArgs = {
  filterByCountry?: InputMaybe<Array<Scalars["String"]["input"]>>;
  filterByTagSlugs?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type ICollectionNewContentCountersArgs = {
  filterByCountry?: InputMaybe<Array<Scalars["String"]["input"]>>;
  filterByTagSlugs?: InputMaybe<Array<Scalars["String"]["input"]>>;
  lastVisitAnchor?: InputMaybe<ICollectionNewContentLastVisitAnchor>;
  lastVisitDate: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type ICollectionAdminStats = {
  __typename: "CollectionAdminStats";
  usersSavedCount: Scalars["Int"]["output"];
};

export enum ICollectionBookmarkStatus {
  Saved = "SAVED",
  Unsaved = "UNSAVED",
}

export type ICollectionContent = {
  __typename: "CollectionContent";
  items: Array<ICollectionContentItem>;
  pageInfo: IForwardOnlyPageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type ICollectionContentCounters = {
  __typename: "CollectionContentCounters";
  governmentsCount: Scalars["Int"]["output"];
  groupsCount: Scalars["Int"]["output"];
  productsCount: Scalars["Int"]["output"];
  projectsCount: Scalars["Int"]["output"];
  storiesCount: Scalars["Int"]["output"];
};

export type ICollectionContentItem =
  | IGovernment
  | IGovernmentProject
  | IGroup
  | IGroupProject
  | IProduct
  | IStory
  | IVendorProject;

export type ICollectionDisplayOptions = {
  __typename: "CollectionDisplayOptions";
  cardBackgroundColorHex: Scalars["String"]["output"];
  cardTitleFontColorHex: Scalars["String"]["output"];
};

export type ICollectionDisplayOptionsInput = {
  cardBackgroundColorHex: Scalars["String"]["input"];
};

export enum ICollectionFeaturedStatus {
  All = "ALL",
  FeaturedOnly = "FEATURED_ONLY",
  NotFeatured = "NOT_FEATURED",
}

export enum ICollectionItemType {
  Government = "GOVERNMENT",
  Group = "GROUP",
  Product = "PRODUCT",
  Project = "PROJECT",
  Story = "STORY",
}

export enum ICollectionMethod {
  ChargeAutomatically = "CHARGE_AUTOMATICALLY",
  SendInvoice = "SEND_INVOICE",
}

export enum ICollectionNewContentLastVisitAnchor {
  LastTrackedViewerVisit = "LAST_TRACKED_VIEWER_VISIT",
  LastVisitArgument = "LAST_VISIT_ARGUMENT",
}

export enum ICollectionPackaging {
  /** When a collection have more than two tags. */
  Bundle = "BUNDLE",
  /** When a collection is made of a single tag. */
  Single = "SINGLE",
}

export enum ICollectionPublishedStatus {
  Published = "PUBLISHED",
  Unpublished = "UNPUBLISHED",
}

export enum ICollectionSponsoring {
  None = "NONE",
  VendorCurated = "VENDOR_CURATED",
  VendorSponsored = "VENDOR_SPONSORED",
}

export enum ICollectionSponsoringPaymentSchedule {
  LumpSum = "LUMP_SUM",
  Monthly = "MONTHLY",
  Quarterly = "QUARTERLY",
  Yearly = "YEARLY",
}

export type ICollectionSponsoringSale = {
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  createdAt: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  includedCollections: Array<ICollection>;
  isActive: Scalars["Boolean"]["output"];
  paymentSchedule: ICollectionSponsoringPaymentSchedule;
  price: Scalars["Int"]["output"];
  sponsorshipLevel: ICollectionSponsoringSponsorshipLevel;
  stripeState: ICollectionSponsoringStripeState;
  type: ICollectionSponsoringType;
  updatedAt: Scalars["DateTime"]["output"];
  vendor: ICompany;
};

export type ICollectionSponsoringSaleCounts = {
  __typename: "CollectionSponsoringSaleCounts";
  activeCount: Scalars["Int"]["output"];
  allCounts: Scalars["Int"]["output"];
  archivedCount: Scalars["Int"]["output"];
  expiredCount: Scalars["Int"]["output"];
  pendingCount: Scalars["Int"]["output"];
};

export enum ICollectionSponsoringSponsorshipLevel {
  Product = "PRODUCT",
  Vendor = "VENDOR",
}

export type ICollectionSponsoringStripeState = {
  __typename: "CollectionSponsoringStripeState";
  latestInvoiceHostedPayUrl: Maybe<Scalars["String"]["output"]>;
  latestInvoiceId: Scalars["String"]["output"];
  latestInvoiceStatus: Scalars["String"]["output"];
};

export enum ICollectionSponsoringType {
  Curated = "CURATED",
  Sponsored = "SPONSORED",
}

export enum ICollectionStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Inactive = "INACTIVE",
}

export type ICollectionsBlockData = IBlockData & {
  __typename: "CollectionsBlockData";
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  displayAsTags: Scalars["Boolean"]["output"];
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  secondTitle: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
};

export type ICollectionsCounters = {
  __typename: "CollectionsCounters";
  activeCount: Scalars["Int"]["output"];
  allCount: Scalars["Int"]["output"];
  archivedCount: Scalars["Int"]["output"];
  bundlesCount: Scalars["Int"]["output"];
  curatedCount: Scalars["Int"]["output"];
  featuredCount: Scalars["Int"]["output"];
  inactiveCount: Scalars["Int"]["output"];
  singleCount: Scalars["Int"]["output"];
  sponsoredCount: Scalars["Int"]["output"];
  unpublishedCount: Scalars["Int"]["output"];
};

export type ICollectionsPagination = {
  __typename: "CollectionsPagination";
  items: Array<ICollection>;
  pageInfo: IForwardOnlyPageInfo;
  totalCount: Scalars["Int"]["output"];
};

export type IComment = {
  __typename: "Comment";
  _id: Scalars["ObjectId"]["output"];
  author: IUser;
  body: Scalars["JSON"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  isReply: Scalars["Boolean"]["output"];
  lastUpdatedAt: Scalars["DateTime"]["output"];
  replies: Array<IComment>;
  repliesCount: Scalars["Int"]["output"];
  upvotesCount: Scalars["Int"]["output"];
  viewerDidReply: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
};

export type ICommentRepliesArgs = {
  filter?: InputMaybe<ICommentRepliesFilter>;
};

export enum ICommentRepliesFilter {
  All = "ALL",
  Viewer = "VIEWER",
}

export enum ICommentTargetType {
  Post = "POST",
  Project = "PROJECT",
  Report = "REPORT",
  Story = "STORY",
}

export type IComments = {
  __typename: "Comments";
  items: Array<IComment>;
  pageInfo: Maybe<IPageInfo>;
};

export type ICompany = {
  __typename: "Company";
  _id: Scalars["ObjectId"]["output"];
  actions: Array<IVendorGroupRequest>;
  actionsCount: Scalars["Int"]["output"];
  activatedAt: Maybe<Scalars["DateTime"]["output"]>;
  address: Maybe<Scalars["String"]["output"]>;
  allProjectsCount: Maybe<Scalars["Int"]["output"]>;
  allStoriesCount: Maybe<Scalars["Int"]["output"]>;
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  balanceTransactions: Array<IVendorBalanceTransaction>;
  billing: IBilling;
  billingName: Maybe<Scalars["String"]["output"]>;
  businessEmail: Maybe<Scalars["String"]["output"]>;
  canAddGroups: Scalars["Boolean"]["output"];
  canAddProducts: Scalars["Boolean"]["output"];
  canAddProjects: Scalars["Boolean"]["output"];
  canBeDisruptor: Scalars["Boolean"]["output"];
  canEarnCreditsUntil: Maybe<Scalars["Date"]["output"]>;
  canInviteTeamMembers: Scalars["Boolean"]["output"];
  charges: Array<ICharge>;
  contactPage: Maybe<Scalars["URL"]["output"]>;
  cover: Maybe<ICover>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  customLimits: Maybe<IVendorCustomLimits>;
  description: Maybe<Scalars["String"]["output"]>;
  disruptorLogo: Maybe<Scalars["String"]["output"]>;
  disruptorMembers: Maybe<Array<IVendorUser>>;
  earnableCreditAmount: Maybe<Scalars["Float"]["output"]>;
  enabledSharing: Scalars["Boolean"]["output"];
  enrichedProfile: Scalars["Boolean"]["output"];
  feedCount: Scalars["Int"]["output"];
  governmentConnections: Maybe<IGovernments>;
  governmentConnectionsCount: Scalars["Int"]["output"];
  groups: Array<IGroup>;
  hasActiveSponsorships: Scalars["Boolean"]["output"];
  hasCustomLimits: Scalars["Boolean"]["output"];
  hasSponsoredCollections: Scalars["Boolean"]["output"];
  headquarters: Maybe<Scalars["String"]["output"]>;
  highlights: Array<Scalars["String"]["output"]>;
  highlightsCount: Scalars["Int"]["output"];
  invoices: Array<IInvoice>;
  isActive: Maybe<Scalars["Boolean"]["output"]>;
  isDisruptor: Maybe<Scalars["Boolean"]["output"]>;
  logo: Maybe<Scalars["String"]["output"]>;
  members: Maybe<Array<IVendorUser>>;
  membersCount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  newsworthy: Array<IVendorNewsworthyItem>;
  newsworthyCount: Scalars["Int"]["output"];
  numberOfEmployees: Maybe<Scalars["String"]["output"]>;
  originalPlan: IPlan;
  owner: Maybe<IVendorUser>;
  ownerless: Maybe<Scalars["Boolean"]["output"]>;
  pendingProductStackRequests: Array<IProductStackRequest>;
  plan: IPlan;
  planUsage: IPlanUsage;
  products: Maybe<Array<IProduct>>;
  productsCount: Maybe<Scalars["Int"]["output"]>;
  projects: IProjects;
  projectsCount: Maybe<Scalars["Int"]["output"]>;
  projectsPendingVerification: IProjects;
  publicProjects: Array<IProject>;
  relatedProjects: Array<IProject>;
  resources: Maybe<Array<IFlatResource>>;
  sharing: ICompanySharingOptions;
  site: Maybe<Scalars["String"]["output"]>;
  slogan: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  socialMedia: Maybe<IVendorSocialMediaLinks>;
  sponsoredCollections: Array<ICollection>;
  sponsoringSales: Array<ICollectionSponsoringSale>;
  sponsorships: Array<ISponsorship>;
  stories: IStories;
  storiesCount: Maybe<Scalars["Int"]["output"]>;
  stripeCustomerId: Maybe<Scalars["String"]["output"]>;
  stripePlan: Maybe<IStripePlan>;
  subscription: Maybe<IVendorSubscription>;
  tier: Scalars["Int"]["output"];
  usersCanAccessAccountPage: Scalars["Boolean"]["output"];
  usersCanRequestContentTranslation: Scalars["Boolean"]["output"];
  viewerCanCancelPlan: Scalars["Boolean"]["output"];
  viewerCanInviteMembers: Scalars["Boolean"]["output"];
  viewerCanRemoveMembers: Maybe<Scalars["Boolean"]["output"]>;
  viewerIsMember: Maybe<Scalars["Boolean"]["output"]>;
  yearFounded: Maybe<Scalars["Int"]["output"]>;
};

export type ICompanyGovernmentConnectionsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  product: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type ICompanyLogoArgs = {
  height: InputMaybe<Scalars["Int"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export type ICompanyProductsArgs = {
  status?: InputMaybe<IProductStatusFilter>;
};

export type ICompanyProjectsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ICompanyProjectsPendingVerificationArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ICompanySharingInput = {
  governments: Scalars["Boolean"]["input"];
  groups: Scalars["Boolean"]["input"];
  highlights: Scalars["Boolean"]["input"];
  newsworthy: Scalars["Boolean"]["input"];
  products: Scalars["Boolean"]["input"];
  projects: Scalars["Boolean"]["input"];
  resources: Scalars["Boolean"]["input"];
  stories: Scalars["Boolean"]["input"];
  team: Scalars["Boolean"]["input"];
};

export type ICompanySharingOptions = {
  __typename: "CompanySharingOptions";
  governments: Scalars["Boolean"]["output"];
  groups: Scalars["Boolean"]["output"];
  highlights: Scalars["Boolean"]["output"];
  newsworthy: Scalars["Boolean"]["output"];
  products: Scalars["Boolean"]["output"];
  projects: Scalars["Boolean"]["output"];
  resources: Scalars["Boolean"]["output"];
  stories: Scalars["Boolean"]["output"];
  team: Scalars["Boolean"]["output"];
};

export type IConnect = {
  __typename: "Connect";
  items: Array<IConnectItem>;
  totalCount: Scalars["Int"]["output"];
};

export type IConnectItem = {
  __typename: "ConnectItem";
  _id: Scalars["ObjectId"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  target: IConnectTarget;
};

export type IConnectTarget =
  | ICompany
  | IGovernment
  | IGovernmentPost
  | IGovernmentProject
  | IGovernmentUser
  | IGroupPost
  | IGroupProject
  | IPendingUser
  | IReport
  | IStory
  | IVendorPost
  | IVendorProject
  | IVendorUser;

export enum IConnectTargetType {
  Government = "GOVERNMENT",
  Group = "GROUP",
  User = "USER",
  Vendor = "VENDOR",
}

export type ICountryStateTuple = {
  __typename: "CountryStateTuple";
  country: Scalars["String"]["output"];
  friendlyStateName: Scalars["String"]["output"];
  state: Scalars["String"]["output"];
};

export type ICountryTimezone = {
  __typename: "CountryTimezone";
  _id: Scalars["ObjectId"]["output"];
  countryCode: Scalars["String"]["output"];
  countryName: Scalars["String"]["output"];
  regionCode: Maybe<Scalars["String"]["output"]>;
  timezone: Scalars["String"]["output"];
};

export type ICountryTimezoneInput = {
  countryCode: Scalars["String"]["input"];
  countryName: Scalars["String"]["input"];
  timezone: Scalars["String"]["input"];
};

export type ICountryTimezones = {
  __typename: "CountryTimezones";
  items: Maybe<Array<ICountryTimezone>>;
  pageInfo: Maybe<IPageInfo>;
};

export type ICover = {
  __typename: "Cover";
  original: Maybe<Scalars["String"]["output"]>;
  reposition: Maybe<IRepositionState>;
  repositioned: Maybe<Scalars["String"]["output"]>;
};

export type ICoverImageDimensions = {
  __typename: "CoverImageDimensions";
  height: Maybe<Scalars["Float"]["output"]>;
  width: Maybe<Scalars["Float"]["output"]>;
};

export type ICoverImageMetadataInput = {
  height: Scalars["Float"]["input"];
  width: Scalars["Float"]["input"];
};

export type ICoverInput = {
  original: InputMaybe<Scalars["String"]["input"]>;
  reposition: InputMaybe<ICoverRepositionStateInput>;
  repositioned: InputMaybe<Scalars["String"]["input"]>;
};

export type ICoverRepositionStateInput = {
  original: ICoverImageMetadataInput;
  proportional: ICoverImageMetadataInput;
  rect: ICoverImageMetadataInput;
  x: Scalars["Float"]["input"];
  y: Scalars["Float"]["input"];
};

export type ICreateSaleInput = {
  description: Scalars["String"]["input"];
  expirationDate: InputMaybe<Scalars["Date"]["input"]>;
  includedCollections: Array<Scalars["ObjectId"]["input"]>;
  paymentSchedule: ICollectionSponsoringPaymentSchedule;
  price: Scalars["Int"]["input"];
  sponsorshipLevel: ICollectionSponsoringSponsorshipLevel;
  type: ICollectionSponsoringType;
  vendorId: Scalars["ObjectId"]["input"];
};

export type IDesktopProductDeployment = {
  __typename: "DesktopProductDeployment";
  platforms: Array<Scalars["String"]["output"]>;
};

export type IDisruptor = ICompany | IProduct | IVendorUser;

export type IDisruptorProductsAboutPageSection = {
  __typename: "DisruptorProductsAboutPageSection";
  products: Array<IProduct>;
};

export type IDownloadResource = {
  __typename: "DownloadResource";
  addedAt: Maybe<Scalars["DateTime"]["output"]>;
  filename: Maybe<Scalars["String"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  type: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type IDuplicatedUser = {
  __typename: "DuplicatedUser";
  _id: Scalars["ObjectId"]["output"];
  avatar: Maybe<Scalars["String"]["output"]>;
  duplicatedUsers: Array<IDuplicatedUserBase>;
  email: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  intercomId: Maybe<Scalars["String"]["output"]>;
  role: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  userId: Scalars["ObjectId"]["output"];
  verified: Maybe<Scalars["Boolean"]["output"]>;
};

export type IDuplicatedUserBase = {
  __typename: "DuplicatedUserBase";
  avatar: Maybe<Scalars["String"]["output"]>;
  email: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  intercomId: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  userId: Scalars["ObjectId"]["output"];
};

export type IDuplicatedUsers = {
  __typename: "DuplicatedUsers";
  items: Maybe<Array<IDuplicatedUser>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IDynamicConfig = {
  __typename: "DynamicConfig";
  key: Scalars["String"]["output"];
  value: Scalars["JSON"]["output"];
};

export type IEditGovernmentInput = {
  awards: Array<Scalars["ObjectId"]["input"]>;
  budget: InputMaybe<Scalars["Float"]["input"]>;
  country: Scalars["String"]["input"];
  county: InputMaybe<Scalars["String"]["input"]>;
  currency: Scalars["String"]["input"];
  governmentType: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  population: InputMaybe<Scalars["Float"]["input"]>;
  resources: InputMaybe<Array<IResourceInput>>;
  site: InputMaybe<Scalars["String"]["input"]>;
  state: Scalars["String"]["input"];
  stateName: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  zipCode: InputMaybe<Scalars["String"]["input"]>;
};

export type IEditSaleInput = {
  description: Scalars["String"]["input"];
  includedCollections: Array<Scalars["ObjectId"]["input"]>;
  sponsorshipLevel: ICollectionSponsoringSponsorshipLevel;
  type: ICollectionSponsoringType;
};

export type IEditableOnboardingInput = {
  city: InputMaybe<Scalars["String"]["input"]>;
  country: InputMaybe<Scalars["String"]["input"]>;
  facebookUrl: InputMaybe<Scalars["String"]["input"]>;
  governmentId: InputMaybe<Scalars["ObjectId"]["input"]>;
  linkedInUrl: InputMaybe<Scalars["String"]["input"]>;
  processStatus: IProcessStatusType;
  state: InputMaybe<Scalars["String"]["input"]>;
  twitterUrl: InputMaybe<Scalars["String"]["input"]>;
  vendorName: InputMaybe<Scalars["String"]["input"]>;
  vendorWebsite: InputMaybe<Scalars["String"]["input"]>;
  whyYouWantToJoin: InputMaybe<Scalars["String"]["input"]>;
  workingFor: InputMaybe<IWorkPlaceType>;
  workplaceName: InputMaybe<Scalars["String"]["input"]>;
  workplaceWebsite: InputMaybe<Scalars["String"]["input"]>;
};

export type IEmptySpaceBlockData = IBlockData & {
  __typename: "EmptySpaceBlockData";
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
};

export type IEntity = ICompany | IGovernment | IGovernmentUser | IPendingUser | IVendorUser;

export enum IEntityType {
  Company = "COMPANY",
  Government = "GOVERNMENT",
}

export type IEventsBlockData = IBlockData & {
  __typename: "EventsBlockData";
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
};

export type IExternalLink = {
  __typename: "ExternalLink";
  _id: Scalars["ObjectId"]["output"];
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  source: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type IExternalLinkInput = {
  source: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type IExternalLinks = {
  __typename: "ExternalLinks";
  items: Maybe<Array<IExternalLink>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IFeaturedStoriesBlockData = IBlockData & {
  __typename: "FeaturedStoriesBlockData";
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  storyIds: Array<Scalars["ObjectId"]["output"]>;
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
};

export type IFeaturedTarget = IProduct | IReport | IStory;

export enum IFeaturedTargetType {
  Product = "PRODUCT",
  Report = "REPORT",
  Story = "STORY",
}

export type IFieldOrderSortInput = {
  sortField: Scalars["String"]["input"];
  sortOrder: Scalars["String"]["input"];
};

export type IFlatResource = IDownloadResource | ILinkResource | ITextResource;

export type IFollowTarget = IGovernment | IGovernmentUser | IPendingUser | IVendorUser;

export enum IFollowType {
  Government = "GOVERNMENT",
  User = "USER",
}

export type IForceSubscribeToPlanInput = {
  billingName: Scalars["String"]["input"];
  customerId: InputMaybe<Scalars["String"]["input"]>;
  daysUntilDue: InputMaybe<Scalars["Int"]["input"]>;
  email: Scalars["String"]["input"];
  freeSubscription: InputMaybe<Scalars["Boolean"]["input"]>;
  sendInvoice: InputMaybe<Scalars["Boolean"]["input"]>;
  stripePlanId: Scalars["String"]["input"];
  stripeSubscriptionId: InputMaybe<Scalars["String"]["input"]>;
  trialPeriodDays: InputMaybe<Scalars["Int"]["input"]>;
  vendorId: Scalars["ObjectId"]["input"];
};

export type IForwardOnlyPageInfo = {
  __typename: "ForwardOnlyPageInfo";
  cursor: Maybe<Scalars["String"]["output"]>;
  hasNextPage: Scalars["Boolean"]["output"];
};

export type IGetAllTimezonesInput = {
  search: Scalars["String"]["input"];
};

export type IGlobalSettings = {
  __typename: "GlobalSettings";
  _id: Scalars["ObjectId"]["output"];
  isOnboardingActive: Scalars["Boolean"]["output"];
};

export type IGovernment = {
  __typename: "Government";
  _id: Scalars["ObjectId"]["output"];
  actions: Array<IGovernmentAction>;
  actionsCount: Scalars["Int"]["output"];
  activatedAt: Maybe<Scalars["DateTime"]["output"]>;
  awards: Array<ITag>;
  budget: Maybe<Scalars["Float"]["output"]>;
  city: ICity;
  cover: Maybe<ICover>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  currency: Scalars["String"]["output"];
  enableSharing: Scalars["Boolean"]["output"];
  feedCount: Scalars["Int"]["output"];
  followers: Array<IUser>;
  groups: Array<IGroup>;
  invitedBy: Maybe<Scalars["ObjectId"]["output"]>;
  isFollowing: Scalars["Boolean"]["output"];
  isInnovator: Maybe<Scalars["Boolean"]["output"]>;
  logo: Maybe<Scalars["String"]["output"]>;
  members: Array<IGovernmentUser>;
  membersCount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  outsideProducts: Maybe<Array<IOutsideProduct>>;
  owner: Maybe<IGovernmentUser>;
  ownerless: Maybe<Scalars["Boolean"]["output"]>;
  posts: Array<IGovernmentPost>;
  postsCount: Scalars["Int"]["output"];
  productTags: Array<ITag>;
  products: Maybe<Array<IProduct>>;
  productsCount: Scalars["Int"]["output"];
  projects: Maybe<IProjects>;
  projectsCount: Scalars["Int"]["output"];
  relatedGovernments: Array<IGovernment>;
  relatedProjects: Array<IProject>;
  resources: Maybe<Array<IFlatResource>>;
  reviewsCount: Scalars["Int"]["output"];
  settings: IGovernmentSettings;
  sharing: IGovernmentSharingOptions;
  site: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  state: Maybe<Scalars["String"]["output"]>;
  stories: Maybe<IStories>;
  storiesCount: Maybe<Scalars["Int"]["output"]>;
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  verifiedProjects: IProjects;
  viewerCanInviteMembers: Maybe<Scalars["Boolean"]["output"]>;
  viewerCanRemoveMembers: Maybe<Scalars["Boolean"]["output"]>;
  viewerCanRequestAccess: Maybe<Scalars["Boolean"]["output"]>;
  viewerCanSeeProductStack: Scalars["Boolean"]["output"];
  viewerCanSeeTeam: Scalars["Boolean"]["output"];
  viewerIsMember: Maybe<Scalars["Boolean"]["output"]>;
  viewerIsOwner: Maybe<Scalars["Boolean"]["output"]>;
  viewerRequestedMembership: Maybe<Scalars["Boolean"]["output"]>;
  viewerRequestedOwnership: Maybe<Scalars["Boolean"]["output"]>;
};

export type IGovernmentMembersArgs = {
  fromSharingPage: InputMaybe<Scalars["Boolean"]["input"]>;
  token: InputMaybe<Scalars["String"]["input"]>;
};

export type IGovernmentPostsArgs = {
  audience: InputMaybe<IPostAudience>;
};

export type IGovernmentProductsArgs = {
  fromSharingPage: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IGovernmentProjectsArgs = {
  audience: InputMaybe<IProjectAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IGovernmentStoriesArgs = {
  audience?: InputMaybe<IStoryAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IGovernmentStoriesCountArgs = {
  audience?: InputMaybe<IStoryAudience>;
};

export type IGovernmentVerifiedProjectsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IGovernmentAction = IGovernmentGroupRequest | IProductStackRequest | IProjectGovernmentVerificationRequest;

export type IGovernmentCountriesBreakdownItem = {
  __typename: "GovernmentCountriesBreakdownItem";
  /** The ISO 3166-1 alpha-2 country code. */
  isoCountryCode: Scalars["String"]["output"];
  /** The number of Governments on that country that are Active in the system. */
  totalOfActiveGovernments: Scalars["Int"]["output"];
  /** The number of Governments on that country. */
  totalOfGovernments: Scalars["Int"]["output"];
  /** The number of Governments on that country that are Inactive in the system. */
  totalOfInactiveGovernments: Scalars["Int"]["output"];
};

export type IGovernmentGroupRequest = IGroupRequest & {
  __typename: "GovernmentGroupRequest";
  _id: Scalars["ObjectId"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  government: IGovernment;
  group: IGroup;
  inviter: IUser;
  possibleGovernments: Array<IGovernment>;
  respondedBy: Maybe<IUser>;
  status: IGroupRequestStatus;
};

export type IGovernmentPost = IPostInterface & {
  __typename: "GovernmentPost";
  _id: Scalars["ObjectId"]["output"];
  attachments: Array<IPostAttachment>;
  audience: Scalars["String"]["output"];
  author: IUser;
  body: Scalars["String"]["output"];
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedBy: Maybe<IUser>;
  featuredAt: Maybe<Scalars["DateTime"]["output"]>;
  government: IGovernment;
  links: Array<IPostLink>;
  upvotesCount: Scalars["Int"]["output"];
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
};

export type IGovernmentProject = IProject & {
  __typename: "GovernmentProject";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  attachments: Array<IProjectAttachmentItem>;
  audience: Scalars["String"]["output"];
  author: Maybe<IUser>;
  awards: Array<ITag>;
  collaborators: Array<IUser>;
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  countryCode: Maybe<Scalars["String"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  government: IGovernment;
  groups: Array<IGroup>;
  icon: Maybe<Scalars["String"]["output"]>;
  itemsCount: IProjectItemsCount;
  links: Array<IProjectLinkItem>;
  locations: Array<IGovernment>;
  locationsPendingVerification: Array<IGovernment>;
  moreFromGovernment: Array<IGovernmentProject>;
  newsworthy: Array<IProjectNewsworthyItem>;
  outcome: Maybe<Scalars["String"]["output"]>;
  outcomeStatement: Maybe<Scalars["String"]["output"]>;
  outsideProducts: Array<IOutsideProduct>;
  products: Array<IProduct>;
  relatedProjects: Array<IProject>;
  slug: Scalars["String"]["output"];
  status: Maybe<Scalars["String"]["output"]>;
  subtitle: Maybe<Scalars["String"]["output"]>;
  tags: Array<ITag>;
  title: Scalars["String"]["output"];
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  upvotesCount: Scalars["Int"]["output"];
  vendors: Array<ICompany>;
  verified: Scalars["Boolean"]["output"];
  verifiedBy: Maybe<IUser>;
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerCanInviteCollaborators: Scalars["Boolean"]["output"];
  viewerCanRead: Scalars["Boolean"]["output"];
  viewerCanRemoveCollaborators: Scalars["Boolean"]["output"];
  viewerCanView: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
};

export type IGovernmentProjectCollaboratorsArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

export type IGovernmentProjectDescriptionArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IGovernmentProjectNewsworthyArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IGovernmentProjectSubtitleArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IGovernmentProjectTitleArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export enum IGovernmentSearchScope {
  Innovator = "INNOVATOR",
}

export type IGovernmentSettings = {
  __typename: "GovernmentSettings";
  projectSharingWithGroups: Array<IGroup>;
};

export type IGovernmentSettingsInput = {
  projectSharingWithGroups: Array<Scalars["ObjectId"]["input"]>;
};

export type IGovernmentSharingInput = {
  awards: InputMaybe<Scalars["Boolean"]["input"]>;
  productStack: InputMaybe<Scalars["Boolean"]["input"]>;
  projects: InputMaybe<Scalars["Boolean"]["input"]>;
  resources: InputMaybe<Scalars["Boolean"]["input"]>;
  stories: InputMaybe<Scalars["Boolean"]["input"]>;
  team: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IGovernmentSharingOptions = {
  __typename: "GovernmentSharingOptions";
  awards: Maybe<Scalars["Boolean"]["output"]>;
  productStack: Maybe<Scalars["Boolean"]["output"]>;
  projects: Maybe<Scalars["Boolean"]["output"]>;
  resources: Maybe<Scalars["Boolean"]["output"]>;
  stories: Maybe<Scalars["Boolean"]["output"]>;
  team: Maybe<Scalars["Boolean"]["output"]>;
};

export type IGovernmentTuple = {
  __typename: "GovernmentTuple";
  governmentId: Scalars["ObjectId"]["output"];
  governmentName: Scalars["String"]["output"];
};

export type IGovernmentUser = IUserInterface &
  IUserProfile & {
    __typename: "GovernmentUser";
    _id: Scalars["ObjectId"]["output"];
    algoliaKeys: Maybe<IAlgoliaKeys>;
    avatar: Maybe<Scalars["String"]["output"]>;
    bannedAt: Maybe<Scalars["DateTime"]["output"]>;
    bookmarks: Array<IBookmarkTarget>;
    canSeeActiveGovernments: Scalars["Boolean"]["output"];
    collections: Array<ICollection>;
    country: Maybe<Scalars["String"]["output"]>;
    cover: Maybe<ICover>;
    createdAt: Maybe<Scalars["DateTime"]["output"]>;
    department: Maybe<ITag>;
    email: Maybe<Scalars["String"]["output"]>;
    enabledSharing: Scalars["Boolean"]["output"];
    feedCount: Scalars["Int"]["output"];
    firstName: Maybe<Scalars["String"]["output"]>;
    followers: Array<IUser>;
    following: Array<IFollowTarget>;
    fullName: Maybe<Scalars["String"]["output"]>;
    government: IGovernment;
    groups: Array<IGroup>;
    intercomId: Maybe<Scalars["ID"]["output"]>;
    intercomUserHash: Scalars["String"]["output"];
    interests: Array<ITag>;
    /** Pulls the Geo data from the request IP */
    ipLocation: Maybe<IIpLocation>;
    isFollowing: Scalars["Boolean"]["output"];
    isInnovator: Maybe<Scalars["Boolean"]["output"]>;
    isLimitedSiteAdmin: Maybe<Scalars["Boolean"]["output"]>;
    isSelfie: Maybe<Scalars["Boolean"]["output"]>;
    isSiteAdmin: Maybe<Scalars["Boolean"]["output"]>;
    isUnverifiable: Maybe<Scalars["Boolean"]["output"]>;
    jobTitle: Maybe<Scalars["String"]["output"]>;
    language: Maybe<Scalars["String"]["output"]>;
    lastName: Maybe<Scalars["String"]["output"]>;
    lastSeen: Maybe<Scalars["DateTime"]["output"]>;
    lastSignInAt: Maybe<Scalars["DateTime"]["output"]>;
    lastSignInProvider: Scalars["String"]["output"];
    latestNewsletterHtml: Maybe<Scalars["String"]["output"]>;
    linkedinId: Maybe<Scalars["String"]["output"]>;
    linkedinUrl: Maybe<Scalars["String"]["output"]>;
    newsletterFrequency: Maybe<INewsletterFrequency>;
    newsletterLastSentDate: Maybe<Scalars["Date"]["output"]>;
    notes: Scalars["String"]["output"];
    notificationEmail: Maybe<Scalars["String"]["output"]>;
    onboarding: Maybe<IOnboarding>;
    onboardingStatus: Maybe<IProcessStatusType>;
    posts: Array<IPost>;
    postsCount: Scalars["Int"]["output"];
    preferences: IUserPreferences;
    primaryGroup: Maybe<IGroup>;
    projects: Maybe<IProjects>;
    projectsCount: Scalars["Int"]["output"];
    projectsFromGovernment: Array<IProject>;
    relatedProjects: Array<IProject>;
    resources: Maybe<Array<IFlatResource>>;
    role: Maybe<Scalars["String"]["output"]>;
    savedCollectionsCount: Scalars["Int"]["output"];
    savedCount: Scalars["Int"]["output"];
    savedPostsCount: Scalars["Int"]["output"];
    savedProductsCount: Scalars["Int"]["output"];
    savedProjectsCount: Scalars["Int"]["output"];
    savedStoriesCount: Scalars["Int"]["output"];
    searchable: Maybe<Scalars["Boolean"]["output"]>;
    sharing: IUserSharingOptions;
    showActionCenterBanner: Scalars["Boolean"]["output"];
    showCompleteGovernmentProfileBanner: Scalars["Boolean"]["output"];
    showOnboardingBanner: Scalars["Boolean"]["output"];
    signInAttempts: Maybe<Array<ISignInAttempt>>;
    slug: Scalars["String"]["output"];
    socialMedia: Maybe<IUserSocialMediaLinks>;
    stories: Maybe<IStories>;
    storiesCount: Maybe<Scalars["Int"]["output"]>;
    subscribedToCampaign: Maybe<Scalars["Boolean"]["output"]>;
    subscribedToNewsletter: Maybe<Scalars["Boolean"]["output"]>;
    timeZone: Maybe<Scalars["String"]["output"]>;
    title: Maybe<Scalars["String"]["output"]>;
    upvotes: Maybe<IUpvotes>;
    upvotesCount: Maybe<Scalars["Int"]["output"]>;
    verified: Scalars["Boolean"]["output"];
  };

export type IGovernmentUserAvatarArgs = {
  height: InputMaybe<Scalars["Int"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export type IGovernmentUserPostsArgs = {
  audience: InputMaybe<IPostAudience>;
};

export type IGovernmentUserPostsCountArgs = {
  audience: InputMaybe<IPostAudience>;
};

export type IGovernmentUserProjectsArgs = {
  audience: InputMaybe<IProjectAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IGovernmentUserStoriesArgs = {
  audience: InputMaybe<IStoryAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IGovernmentUserStoriesCountArgs = {
  audience: InputMaybe<IStoryAudience>;
};

export type IGovernmentUserUpvotesArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IGovernmentVerificationRequest = {
  _id: Scalars["ObjectId"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  government: IGovernment;
  respondedAt: Maybe<Scalars["DateTime"]["output"]>;
  respondedBy: Maybe<IUser>;
  status: IGovernmentVerificationRequestStatus;
};

export enum IGovernmentVerificationRequestSearchTarget {
  Government = "GOVERNMENT",
  Group = "GROUP",
  Project = "PROJECT",
}

export enum IGovernmentVerificationRequestSortBy {
  Created = "CREATED",
  Government = "GOVERNMENT",
  Status = "STATUS",
}

export enum IGovernmentVerificationRequestSortByDirection {
  Ascending = "ASCENDING",
  Descending = "DESCENDING",
}

export enum IGovernmentVerificationRequestStatus {
  Cancelled = "CANCELLED",
  Declined = "DECLINED",
  Pending = "PENDING",
  Verified = "VERIFIED",
}

export type IGovernmentVerificationRequests = {
  __typename: "GovernmentVerificationRequests";
  items: Array<IGovernmentVerificationRequest>;
  metadata: IGovernmentVerificationRequestsMetadata;
  pageInfo: Maybe<IPageInfo>;
};

export type IGovernmentVerificationRequestsMetadata = {
  __typename: "GovernmentVerificationRequestsMetadata";
  cancelledCount: Scalars["Int"]["output"];
  declinedCount: Scalars["Int"]["output"];
  pendingCount: Scalars["Int"]["output"];
  totalCount: Scalars["Int"]["output"];
  verifiedCount: Scalars["Int"]["output"];
};

export type IGovernmentWhitelistInput = {
  email: InputMaybe<Scalars["String"]["input"]>;
  innovator: InputMaybe<Scalars["Boolean"]["input"]>;
  linkedinUrl: InputMaybe<Scalars["String"]["input"]>;
  owner: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IGovernments = {
  __typename: "Governments";
  items: Maybe<Array<IGovernment>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IGovernmentsBlockData = IBlockData & {
  __typename: "GovernmentsBlockData";
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  secondTitle: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
};

export type IGovernmentsCount = {
  __typename: "GovernmentsCount";
  activeCount: Maybe<Scalars["Int"]["output"]>;
  allCount: Maybe<Scalars["Int"]["output"]>;
  inactiveCount: Maybe<Scalars["Int"]["output"]>;
  innovatorsCount: Maybe<Scalars["Int"]["output"]>;
  referralCount: Maybe<Scalars["Int"]["output"]>;
  sharingCount: Maybe<Scalars["Int"]["output"]>;
};

export enum IGovlaunchEnvironment {
  Production = "PRODUCTION",
  Qa = "QA",
}

export type IGovlaunchStatsCountData = {
  __typename: "GovlaunchStatsCountData";
  governmentsCount: Scalars["Int"]["output"];
  productsCount: Scalars["Int"]["output"];
  projectsCount: Scalars["Int"]["output"];
  storiesCount: Scalars["Int"]["output"];
  vendorsCount: Scalars["Int"]["output"];
};

export type IGovlaunchStatsCountInput = {
  countGovernments: Scalars["Boolean"]["input"];
  countProducts: Scalars["Boolean"]["input"];
  countProjects: Scalars["Boolean"]["input"];
  countStories: Scalars["Boolean"]["input"];
  countVendors: Scalars["Boolean"]["input"];
};

export type IGroup = {
  __typename: "Group";
  _id: Scalars["ObjectId"]["output"];
  about: Scalars["String"]["output"];
  awards: Array<ITag>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedBy: Maybe<IUser>;
  feedCount: Scalars["Int"]["output"];
  governments: Array<IGovernment>;
  headedByAdmins: Scalars["Boolean"]["output"];
  isLockedForViewer: Scalars["Boolean"]["output"];
  kind: Maybe<IGroupKind>;
  location: Scalars["String"]["output"];
  logo: Maybe<Scalars["String"]["output"]>;
  members: IUsers;
  membersCount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  newsworthy: Array<IGroupNewsworthyItem>;
  outsideProducts: Maybe<Array<IOutsideProduct>>;
  owner: Maybe<ICompany>;
  pendingRequests: Array<IGroupRequest>;
  posts: Maybe<IGroupPosts>;
  previousOwner: Maybe<ICompany>;
  products: Array<IProduct>;
  productsCount: Scalars["Int"]["output"];
  projects: IProjects;
  projectsCount: Scalars["Int"]["output"];
  projectsFromGovernments: IProjects;
  projectsPendingVerification: IProjects;
  resources: Array<IFlatResource>;
  slug: Scalars["String"]["output"];
  socialMedia: Maybe<IGroupSocialMediaLinks>;
  tags: Array<ITag>;
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  vendors: Array<ICompany>;
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerCanHeadContent: Scalars["Boolean"]["output"];
  viewerCanRemoveMembers: Scalars["Boolean"]["output"];
  viewerIsMember: Scalars["Boolean"]["output"];
  viewerIsOwner: Scalars["Boolean"]["output"];
  visibility: Maybe<IGroupVisibility>;
  website: Scalars["String"]["output"];
};

export type IGroupMembersArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
};

export type IGroupPostsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IGroupProjectsArgs = {
  audience: InputMaybe<IProjectAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IGroupProjectsFromGovernmentsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IGroupProjectsPendingVerificationArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IGroupInput = {
  about: Scalars["String"]["input"];
  awards: Array<Scalars["ObjectId"]["input"]>;
  kind: InputMaybe<IGroupKind>;
  location: Scalars["String"]["input"];
  logo: InputMaybe<Scalars["String"]["input"]>;
  members: Array<Scalars["ObjectId"]["input"]>;
  name: Scalars["String"]["input"];
  newsworthy: Array<IGroupNewsworthyItemInput>;
  outsideProducts: InputMaybe<Array<IOutsideProductInput>>;
  products: Array<Scalars["ObjectId"]["input"]>;
  resources: Array<IResourceInput>;
  socialMedia: InputMaybe<IGroupSocialMediaLinksInput>;
  tags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  vendor: InputMaybe<Scalars["ObjectId"]["input"]>;
  visibility: IGroupVisibility;
  website: Scalars["String"]["input"];
};

export enum IGroupKind {
  /** Everything that doesn't fall in the above buckets will be "community" */
  Community = "COMMUNITY",
  /** A group will be considered a Discussion if there's a Collection for it */
  Discussion = "DISCUSSION",
  /** A group will be considered a Vendor if the owner is a Vendor */
  Vendor = "VENDOR",
}

export type IGroupNewsworthyItem = {
  __typename: "GroupNewsworthyItem";
  addedAt: Maybe<Scalars["Float"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  favicon: Maybe<Scalars["String"]["output"]>;
  siteName: Maybe<Scalars["String"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type IGroupNewsworthyItemInput = {
  addedAt: InputMaybe<Scalars["Float"]["input"]>;
  description: InputMaybe<Scalars["String"]["input"]>;
  favicon: InputMaybe<Scalars["String"]["input"]>;
  siteName: InputMaybe<Scalars["String"]["input"]>;
  title: InputMaybe<Scalars["String"]["input"]>;
  url: InputMaybe<Scalars["String"]["input"]>;
};

export type IGroupPost = IPostInterface & {
  __typename: "GroupPost";
  _id: Scalars["ObjectId"]["output"];
  attachments: Array<IPostAttachment>;
  audience: Scalars["String"]["output"];
  author: IUser;
  body: Scalars["String"]["output"];
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedBy: Maybe<IUser>;
  featuredAt: Maybe<Scalars["DateTime"]["output"]>;
  group: IGroup;
  links: Array<IPostLink>;
  upvotesCount: Scalars["Int"]["output"];
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
};

export type IGroupPosts = {
  __typename: "GroupPosts";
  items: Array<IGroupPost>;
  pageInfo: Maybe<IPageInfo>;
};

export type IGroupProject = IProject & {
  __typename: "GroupProject";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  attachments: Array<IProjectAttachmentItem>;
  audience: Scalars["String"]["output"];
  author: Maybe<IUser>;
  awards: Array<ITag>;
  collaborators: Array<IUser>;
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  countryCode: Maybe<Scalars["String"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  group: IGroup;
  groups: Array<IGroup>;
  icon: Maybe<Scalars["String"]["output"]>;
  itemsCount: IProjectItemsCount;
  links: Array<IProjectLinkItem>;
  locations: Array<IGovernment>;
  locationsPendingVerification: Array<IGovernment>;
  moreFromGovernment: Array<IGovernmentProject>;
  newsworthy: Array<IProjectNewsworthyItem>;
  outcome: Maybe<Scalars["String"]["output"]>;
  outcomeStatement: Maybe<Scalars["String"]["output"]>;
  outsideProducts: Array<IOutsideProduct>;
  products: Array<IProduct>;
  relatedProjects: Array<IProject>;
  slug: Scalars["String"]["output"];
  status: Maybe<Scalars["String"]["output"]>;
  subtitle: Maybe<Scalars["String"]["output"]>;
  tags: Array<ITag>;
  title: Scalars["String"]["output"];
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  upvotesCount: Scalars["Int"]["output"];
  vendors: Array<ICompany>;
  verified: Scalars["Boolean"]["output"];
  verifiedBy: Maybe<IUser>;
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerCanInviteCollaborators: Scalars["Boolean"]["output"];
  viewerCanRead: Scalars["Boolean"]["output"];
  viewerCanRemoveCollaborators: Scalars["Boolean"]["output"];
  viewerCanView: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
};

export type IGroupProjectCollaboratorsArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

export type IGroupProjectDescriptionArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IGroupProjectNewsworthyArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IGroupProjectSubtitleArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IGroupProjectTitleArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IGroupRequest = {
  _id: Scalars["ObjectId"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  group: IGroup;
  inviter: IUser;
  respondedBy: Maybe<IUser>;
  status: IGroupRequestStatus;
};

export enum IGroupRequestStatus {
  Accepted = "ACCEPTED",
  Canceled = "CANCELED",
  Declined = "DECLINED",
  Pending = "PENDING",
}

export type IGroupSocialMediaLinks = {
  __typename: "GroupSocialMediaLinks";
  facebook: Maybe<Scalars["URL"]["output"]>;
  instagram: Maybe<Scalars["URL"]["output"]>;
  linkedin: Maybe<Scalars["URL"]["output"]>;
  twitter: Maybe<Scalars["URL"]["output"]>;
  youtube: Maybe<Scalars["URL"]["output"]>;
};

export type IGroupSocialMediaLinksInput = {
  facebook: InputMaybe<Scalars["URL"]["input"]>;
  instagram: InputMaybe<Scalars["URL"]["input"]>;
  linkedin: InputMaybe<Scalars["URL"]["input"]>;
  twitter: InputMaybe<Scalars["URL"]["input"]>;
  youtube: InputMaybe<Scalars["URL"]["input"]>;
};

export enum IGroupVisibility {
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export type IGroups = {
  __typename: "Groups";
  items: Maybe<Array<IGroup>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IGroupsCount = {
  __typename: "GroupsCount";
  allCount: Maybe<Scalars["Int"]["output"]>;
  archivedCount: Maybe<Scalars["Int"]["output"]>;
  communityCount: Scalars["Int"]["output"];
  discussionCount: Scalars["Int"]["output"];
  vendorCount: Scalars["Int"]["output"];
};

export enum IGroupsFilter {
  All = "ALL",
  Archived = "ARCHIVED",
}

export type IHeaderBannerButton = {
  __typename: "HeaderBannerButton";
  buttonBackgroundColor: Maybe<Scalars["String"]["output"]>;
  buttonBorderColor: Maybe<Scalars["String"]["output"]>;
  buttonHoverColor: Maybe<Scalars["String"]["output"]>;
  buttonHref: Scalars["String"]["output"];
  buttonText: Scalars["String"]["output"];
  buttonTextColor: Maybe<Scalars["String"]["output"]>;
};

export type IHeaderBannerButtonInput = {
  buttonBackgroundColor: InputMaybe<Scalars["String"]["input"]>;
  buttonBorderColor: InputMaybe<Scalars["String"]["input"]>;
  buttonHoverColor: InputMaybe<Scalars["String"]["input"]>;
  buttonHref: Scalars["String"]["input"];
  buttonText: Scalars["String"]["input"];
  buttonTextColor: InputMaybe<Scalars["String"]["input"]>;
};

export type IHeaderBannerContent = {
  __typename: "HeaderBannerContent";
  backgroundImage: Maybe<IHeaderBannerImage>;
  foregroundImage: Maybe<IHeaderBannerImage>;
  leftButtonBackgroundColor: Maybe<Scalars["String"]["output"]>;
  leftButtonBorderColor: Maybe<Scalars["String"]["output"]>;
  leftButtonHoverColor: Maybe<Scalars["String"]["output"]>;
  leftButtonHref: Maybe<Scalars["String"]["output"]>;
  leftButtonText: Maybe<Scalars["String"]["output"]>;
  leftButtonTextColor: Maybe<Scalars["String"]["output"]>;
  rightButtonBackgroundColor: Maybe<Scalars["String"]["output"]>;
  rightButtonBorderColor: Maybe<Scalars["String"]["output"]>;
  rightButtonHoverColor: Maybe<Scalars["String"]["output"]>;
  rightButtonHref: Maybe<Scalars["String"]["output"]>;
  rightButtonText: Maybe<Scalars["String"]["output"]>;
  rightButtonTextColor: Maybe<Scalars["String"]["output"]>;
  subtitle: Maybe<Scalars["String"]["output"]>;
  subtitleColor: Maybe<Scalars["String"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  titleColor: Maybe<Scalars["String"]["output"]>;
};

export type IHeaderBannerContentInput = {
  backgroundImage: InputMaybe<IHeaderBannerImageInput>;
  foregroundImage: InputMaybe<IHeaderBannerImageInput>;
  leftButtonBackgroundColor: InputMaybe<Scalars["String"]["input"]>;
  leftButtonBorderColor: InputMaybe<Scalars["String"]["input"]>;
  leftButtonHoverColor: InputMaybe<Scalars["String"]["input"]>;
  leftButtonHref: InputMaybe<Scalars["String"]["input"]>;
  leftButtonText: InputMaybe<Scalars["String"]["input"]>;
  leftButtonTextColor: InputMaybe<Scalars["String"]["input"]>;
  rightButtonBackgroundColor: InputMaybe<Scalars["String"]["input"]>;
  rightButtonBorderColor: InputMaybe<Scalars["String"]["input"]>;
  rightButtonHoverColor: InputMaybe<Scalars["String"]["input"]>;
  rightButtonHref: InputMaybe<Scalars["String"]["input"]>;
  rightButtonText: InputMaybe<Scalars["String"]["input"]>;
  rightButtonTextColor: InputMaybe<Scalars["String"]["input"]>;
  subtitle: InputMaybe<Scalars["String"]["input"]>;
  subtitleColor: InputMaybe<Scalars["String"]["input"]>;
  title: InputMaybe<Scalars["String"]["input"]>;
  titleColor: InputMaybe<Scalars["String"]["input"]>;
};

export type IHeaderBannerImage = {
  __typename: "HeaderBannerImage";
  alt: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type IHeaderBannerImageInput = {
  alt: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type IImage = {
  __typename: "Image";
  _id: Scalars["ObjectId"]["output"];
  alt: Maybe<Scalars["String"]["output"]>;
  isPlceholder: Maybe<Scalars["Boolean"]["output"]>;
  source: Maybe<Scalars["String"]["output"]>;
  sourceType: Maybe<IImageSourceType>;
  url: Scalars["String"]["output"];
};

export type IImageBlockData = IBlockData & {
  __typename: "ImageBlockData";
  alt: Scalars["String"]["output"];
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
  url: Scalars["String"]["output"];
};

export type IImageInput = {
  alt: InputMaybe<Scalars["String"]["input"]>;
  isPlaceholder: InputMaybe<Scalars["Boolean"]["input"]>;
  url: Scalars["String"]["input"];
};

export type IImageLinkBlockData = IBlockData & {
  __typename: "ImageLinkBlockData";
  alt: Scalars["String"]["output"];
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  href: Scalars["String"]["output"];
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
  url: Scalars["String"]["output"];
};

export enum IImageSourceType {
  Product = "PRODUCT",
  Story = "STORY",
}

export type IImages = {
  __typename: "Images";
  items: Array<IImage>;
  pageInfo: Maybe<IPageInfo>;
};

export type IImagesCount = {
  __typename: "ImagesCount";
  allCount: Scalars["Int"]["output"];
  archivedCount: Scalars["Int"]["output"];
  noAltCount: Scalars["Int"]["output"];
  placeholderCount: Scalars["Int"]["output"];
  withAltCount: Scalars["Int"]["output"];
};

export type IImagesFilterInput = {
  search: InputMaybe<Scalars["String"]["input"]>;
  tab: InputMaybe<IImagesQueryTab>;
};

export enum IImagesQueryTab {
  All = "ALL",
  Archived = "ARCHIVED",
  NoAlt = "NO_ALT",
  Placeholder = "PLACEHOLDER",
  WithAlt = "WITH_ALT",
}

export type IInnovator = IGovernment | IGovernmentUser;

export type IInvoice = {
  __typename: "Invoice";
  amount: Scalars["Int"]["output"];
  amountRefunded: Scalars["Int"]["output"];
  card: Maybe<ICardSource>;
  currency: Scalars["String"]["output"];
  friendlyId: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  items: Array<IInvoiceItem>;
  paidAt: Maybe<Scalars["DateTime"]["output"]>;
  receiptUrl: Maybe<Scalars["String"]["output"]>;
  status: IInvoiceStatus;
};

export type IInvoiceItem = {
  __typename: "InvoiceItem";
  amount: Scalars["Int"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  id: Scalars["String"]["output"];
};

export enum IInvoiceStatus {
  Draft = "DRAFT",
  Open = "OPEN",
  Paid = "PAID",
  Uncollectible = "UNCOLLECTIBLE",
  Void = "VOID",
}

export type IIpLocation = {
  __typename: "IpLocation";
  /** ISO 2-digit country code. For example: US, BR, BG, etc */
  countryCode: Scalars["String"]["output"];
  /** Country name in English */
  countryName: Scalars["String"]["output"];
};

export type ILandingPageConfig = {
  __typename: "LandingPageConfig";
  _id: Scalars["ObjectId"]["output"];
  active: Scalars["Boolean"]["output"];
  allowOverlap: Maybe<Scalars["Boolean"]["output"]>;
  blocks: Array<ILandingPageConfigBlock>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  createdBy: Maybe<IUser>;
  deactivatedAt: Maybe<Scalars["DateTime"]["output"]>;
  deactivatedBy: Maybe<Scalars["ObjectId"]["output"]>;
  headerBanner: Maybe<IHeaderBannerContent>;
  name: Scalars["String"]["output"];
  updatedAt: Maybe<Scalars["Date"]["output"]>;
};

export type ILandingPageConfigBlock = {
  __typename: "LandingPageConfigBlock";
  blockData: IBlockData;
  h: Scalars["Int"]["output"];
  i: Scalars["String"]["output"];
  isBounded: Maybe<Scalars["Boolean"]["output"]>;
  isDraggable: Maybe<Scalars["Boolean"]["output"]>;
  isResizable: Maybe<Scalars["Boolean"]["output"]>;
  static: Maybe<Scalars["Boolean"]["output"]>;
  w: Scalars["Int"]["output"];
  x: Scalars["Int"]["output"];
  y: Scalars["Int"]["output"];
};

export type ILandingPageConfigBlockDataInput = {
  alt: InputMaybe<Scalars["String"]["input"]>;
  backgroundColor: InputMaybe<Scalars["String"]["input"]>;
  countersColor: InputMaybe<Scalars["String"]["input"]>;
  displayAsTags: InputMaybe<Scalars["Boolean"]["input"]>;
  href: InputMaybe<Scalars["String"]["input"]>;
  itemLimit: InputMaybe<Scalars["Int"]["input"]>;
  labelsColor: InputMaybe<Scalars["String"]["input"]>;
  paddingBottom: InputMaybe<Scalars["Int"]["input"]>;
  paddingLeft: InputMaybe<Scalars["Int"]["input"]>;
  paddingRight: InputMaybe<Scalars["Int"]["input"]>;
  paddingTop: InputMaybe<Scalars["Int"]["input"]>;
  podcastSrc: InputMaybe<Scalars["String"]["input"]>;
  secondTitle: InputMaybe<Scalars["String"]["input"]>;
  showGovernments: InputMaybe<Scalars["Boolean"]["input"]>;
  showProducts: InputMaybe<Scalars["Boolean"]["input"]>;
  showProjects: InputMaybe<Scalars["Boolean"]["input"]>;
  showStories: InputMaybe<Scalars["Boolean"]["input"]>;
  showVendors: InputMaybe<Scalars["Boolean"]["input"]>;
  storyIds: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  title: Scalars["String"]["input"];
  titleVisible: Scalars["Boolean"]["input"];
  type: IBlockLayoutType;
  url: InputMaybe<Scalars["String"]["input"]>;
  widgetColor: InputMaybe<Scalars["String"]["input"]>;
};

export type ILandingPageConfigBlockInput = {
  blockData: ILandingPageConfigBlockDataInput;
  h: Scalars["Int"]["input"];
  i: Scalars["String"]["input"];
  isBounded: InputMaybe<Scalars["Boolean"]["input"]>;
  isDraggable: InputMaybe<Scalars["Boolean"]["input"]>;
  isResizable: InputMaybe<Scalars["Boolean"]["input"]>;
  static: InputMaybe<Scalars["Boolean"]["input"]>;
  w: Scalars["Int"]["input"];
  x: Scalars["Int"]["input"];
  y: Scalars["Int"]["input"];
};

export type ILandingPageConfigInput = {
  active: Scalars["Boolean"]["input"];
  allowOverlap: InputMaybe<Scalars["Boolean"]["input"]>;
  blocks: Array<ILandingPageConfigBlockInput>;
  headerBanner: InputMaybe<IHeaderBannerContentInput>;
  name: Scalars["String"]["input"];
};

export type ILandingPageConfigs = {
  __typename: "LandingPageConfigs";
  items: Maybe<Array<ILandingPageConfig>>;
  pageInfo: Maybe<IPageInfo>;
};

export type ILandingPageEvent = {
  __typename: "LandingPageEvent";
  _id: Scalars["ObjectId"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  endDate: Maybe<Scalars["DateTime"]["output"]>;
  location: Scalars["String"]["output"];
  startDate: Scalars["DateTime"]["output"];
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type ILandingPageEventInput = {
  endDate: InputMaybe<Scalars["DateTime"]["input"]>;
  location: Scalars["String"]["input"];
  startDate: Scalars["DateTime"]["input"];
  title: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type ILandingPageEvents = {
  __typename: "LandingPageEvents";
  items: Maybe<Array<ILandingPageEvent>>;
  pageInfo: Maybe<IPageInfo>;
};

export type ILatestGovernmentsAboutPageSection = {
  __typename: "LatestGovernmentsAboutPageSection";
  governments: Array<IGovernment>;
};

export type ILimitsInput = {
  enrichedProducts: Scalars["Int"]["input"];
  enrichedProfile: Scalars["Boolean"]["input"];
  groupInvitations: Scalars["Int"]["input"];
  groups: Scalars["Int"]["input"];
  inviteGovernments: Scalars["Boolean"]["input"];
  productTags: Scalars["Int"]["input"];
  products: Scalars["Int"]["input"];
  projectsPerMonth: Scalars["Int"]["input"];
  searchAccess: Scalars["Boolean"]["input"];
  sharingPage: Scalars["Boolean"]["input"];
  teamMembers: Scalars["Int"]["input"];
};

export type ILinkResource = {
  __typename: "LinkResource";
  addedAt: Maybe<Scalars["DateTime"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  type: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type ILinkUnfurlMeta = {
  __typename: "LinkUnfurlMeta";
  description: Maybe<Scalars["String"]["output"]>;
  favicon: Maybe<Scalars["String"]["output"]>;
  siteName: Maybe<Scalars["String"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
};

export type ILumpSumCollectionSponsoringSale = ICollectionSponsoringSale & {
  __typename: "LumpSumCollectionSponsoringSale";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  createdAt: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  expirationDate: Scalars["Date"]["output"];
  includedCollections: Array<ICollection>;
  isActive: Scalars["Boolean"]["output"];
  paymentSchedule: ICollectionSponsoringPaymentSchedule;
  price: Scalars["Int"]["output"];
  sponsorshipLevel: ICollectionSponsoringSponsorshipLevel;
  stripeState: ICollectionSponsoringStripeState;
  type: ICollectionSponsoringType;
  updatedAt: Scalars["DateTime"]["output"];
  vendor: ICompany;
};

export type IMedia = {
  __typename: "Media";
  alt: Maybe<Scalars["String"]["output"]>;
  type: Maybe<IMediaType>;
  url: Maybe<Scalars["URL"]["output"]>;
};

export type IMediaInput = {
  alt: InputMaybe<Scalars["String"]["input"]>;
  type: IMediaType;
  url: Scalars["URL"]["input"];
};

export enum IMediaType {
  Image = "IMAGE",
  Video = "VIDEO",
  Youtube = "YOUTUBE",
}

export type IMetadataLink = {
  __typename: "MetadataLink";
  meta: Maybe<ILinkUnfurlMeta>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type IMostPopularProject = {
  __typename: "MostPopularProject";
  project: Maybe<IProject>;
};

export type IMutation = {
  __typename: "Mutation";
  acceptGroupRequest: Scalars["Boolean"]["output"];
  acceptProductStackRequest: Scalars["Boolean"]["output"];
  addCollection: ICollection;
  addCountryTimezone: Maybe<ICountryTimezone>;
  addGovernment: IGovernment;
  addPlan: Maybe<Scalars["Boolean"]["output"]>;
  addProduct: Maybe<IProduct>;
  addProductsToGovernments: Maybe<Scalars["Boolean"]["output"]>;
  addReport: Maybe<IReport>;
  addSolution: ISolution;
  addSponsorship: Maybe<ISponsorship>;
  addTag: ITag;
  addVendor: Maybe<ICompany>;
  adminSignIn: Maybe<Scalars["String"]["output"]>;
  approveSolution: ISolution;
  archiveCollectionSponsoringSale: ICollectionSponsoringSale;
  archiveNewsletterCampaign: INewsletterCampaign;
  archiveProduct: Maybe<Scalars["Boolean"]["output"]>;
  archiveProject: Scalars["Boolean"]["output"];
  archiveProjectsByIds: Scalars["Boolean"]["output"];
  archiveSponsorship: Maybe<Scalars["Boolean"]["output"]>;
  archiveStory: Maybe<IStory>;
  archiveVendor: Maybe<Scalars["Boolean"]["output"]>;
  assignUser: Maybe<IUser>;
  autopopulateInterests: Scalars["Int"]["output"];
  bulkTagByObjectIds: Maybe<Scalars["Boolean"]["output"]>;
  cancelGroupRequest: Scalars["Boolean"]["output"];
  cancelProductStackRequest: Scalars["Boolean"]["output"];
  cancelSubscription: ICompany;
  cancelVerificationRequestFromProjectByGovernmentId: IProject;
  changeCollectionPosition: ICollection;
  changeCreditCard: ICompany;
  changeGroupMembers: Maybe<IGroup>;
  /** This mutation is for changing the Onboarding process status */
  changeOnboardingStatus: IOnboarding;
  changeStoryAuthor: Maybe<IStory>;
  changeSubscriptionPlan: ICompany;
  createAboutPageConfig: IAboutPageConfig;
  createCollectionSponsoringSale: ICollectionSponsoringSale;
  createComment: IComment;
  createExternalLink: Maybe<IExternalLink>;
  createGroup: Maybe<IGroup>;
  createLandingPageConfig: Maybe<ILandingPageConfig>;
  createLandingPageEvent: Maybe<ILandingPageEvent>;
  createNewsletterCampaign: INewsletterCampaign;
  createProjectForGovernment: IProject;
  createProjectForGroup: IProject;
  createProjectForVendor: IProject;
  declineGroupRequest: Scalars["Boolean"]["output"];
  declineProductStackRequest: Scalars["Boolean"]["output"];
  declineProjectVerification: IProjectGovernmentVerificationRequest;
  deleteExternalLink: Maybe<Scalars["Boolean"]["output"]>;
  deleteLandingPageConfig: Maybe<Scalars["Boolean"]["output"]>;
  deleteLandingPageEvent: Maybe<Scalars["Boolean"]["output"]>;
  deletePost: Scalars["Boolean"]["output"];
  deleteProfile: Maybe<Scalars["Boolean"]["output"]>;
  deleteUser: Maybe<Scalars["Boolean"]["output"]>;
  denyOutsideProduct: Maybe<Scalars["Boolean"]["output"]>;
  dismissActionCenter: Scalars["Boolean"]["output"];
  dismissCompleteGovernmentProfileBanner: Scalars["Boolean"]["output"];
  dismissOnboardingBanner: Scalars["Boolean"]["output"];
  duplicateAboutPageConfig: Maybe<Scalars["Boolean"]["output"]>;
  duplicateLandingPageConfig: Maybe<Scalars["Boolean"]["output"]>;
  editCollectionSponsoringSale: ICollectionSponsoringSale;
  editComment: IComment;
  editCountryTimezone: Maybe<ICountryTimezone>;
  editExternalLink: Maybe<IExternalLink>;
  editGovernment: IGovernment;
  editGovernmentMembers: IGovernment;
  editGroupGovernments: IGroup;
  editGroupMembers: IGroup;
  editGroupVendors: IGroup;
  editLandingPageConfig: Maybe<ILandingPageConfig>;
  editLandingPageEvent: Maybe<ILandingPageEvent>;
  editNewsletterCampaign: INewsletterCampaign;
  /** This mutation is for allowing a Site admin to edit all onboarding details provided by an User */
  editOnboarding: Maybe<IOnboarding>;
  editPlan: IPlan;
  editPost: Maybe<IPost>;
  editProduct: Maybe<IProduct>;
  editProject: IProject;
  editReport: Maybe<IReport>;
  editSponsorship: Maybe<ISponsorship>;
  editStory: IStory;
  editTier: Maybe<Scalars["Boolean"]["output"]>;
  editVendor: Maybe<ICompany>;
  editVendorCustomLimits: ICompany;
  editVendorMembers: ICompany;
  enrichMakersVendorProducts: Maybe<Scalars["Boolean"]["output"]>;
  extendVendorCreditsEligibilityDate: ICompany;
  forceCancelSubscription: Scalars["Boolean"]["output"];
  /**
   * This allow for existing Users to be prompted to Onboard when the sign in again. This mutation will throw an error
   * if the provided User has already onboarded or is in the process of onboarding
   */
  forceOnboarding: IOnboarding;
  forceSendNewsletterToUser: Scalars["Boolean"]["output"];
  forceSubscribeToPlan: ICompany;
  genStorybookMockData: Array<IStorybookMockDataObject>;
  generateToken: Maybe<Scalars["String"]["output"]>;
  getInviteToken: Maybe<Scalars["String"]["output"]>;
  ignoreOutsideProduct: Maybe<Scalars["Boolean"]["output"]>;
  impersonate: Maybe<ITokens>;
  inviteGovernmentsToAddProduct: Array<IProductStackRequest>;
  inviteGovernmentsToGroup: Maybe<Array<Maybe<IGovernmentGroupRequest>>>;
  inviteVendorsToGroup: Maybe<Array<Maybe<IVendorGroupRequest>>>;
  joinGroup: IUser;
  leaveGroup: Maybe<IUser>;
  leaveGroupAsGovernment: Maybe<Scalars["Boolean"]["output"]>;
  leaveGroupAsVendor: Maybe<Scalars["Boolean"]["output"]>;
  ping: Maybe<Scalars["String"]["output"]>;
  postToGovernment: Maybe<IPost>;
  postToGroup: Maybe<IPost>;
  postToVendor: Maybe<IPost>;
  proposeStory: IStory;
  publishStory: IStory;
  reactivateSubscription: ICompany;
  reassembleGroupGovernments: Maybe<IGroup>;
  reassembleGroupVendors: Maybe<IGroup>;
  removeAboutPageConfig: Maybe<Scalars["Boolean"]["output"]>;
  removeCitizenVerification: Maybe<IUser>;
  removeComment: Scalars["Boolean"]["output"];
  removeGroupById: Maybe<Scalars["Boolean"]["output"]>;
  removeGroupGovernment: IGroup;
  removeGroupVendor: IGroup;
  removeInvitee: Maybe<Scalars["Boolean"]["output"]>;
  removeTagById: Scalars["Boolean"]["output"];
  removeVerification: Maybe<IUser>;
  renameTagById: ITag;
  replyComment: IComment;
  requestGovernmentOwnership: Maybe<Scalars["Boolean"]["output"]>;
  requestVendorOwnership: Maybe<Scalars["Boolean"]["output"]>;
  /**
   * This allow for a Site Admin to reset the whole onboarding state of a specific user. This mutation wipes all
   * onboarding data previously collected and prompt the User to provide it all again
   */
  resetOnboarding: Maybe<IOnboarding>;
  resetPodcastPageConfig: IPodcastPageConfig;
  resetVendorCustomLimits: ICompany;
  restoreGroupById: Maybe<Scalars["Boolean"]["output"]>;
  restoreProduct: Maybe<IProduct>;
  restoreProject: IProject;
  restoreSponsorship: Maybe<ISponsorship>;
  restoreStory: Maybe<IStory>;
  restoreTagById: Scalars["Boolean"]["output"];
  restoreVendor: Maybe<ICompany>;
  runCollectionContentBreakdownUpdate: Maybe<Scalars["Boolean"]["output"]>;
  runSetCountriesOnEntities: Maybe<Scalars["Boolean"]["output"]>;
  saveCompanySharing: ICompany;
  saveGovernmentSharing: Maybe<IGovernment>;
  saveUserSharing: Maybe<IUser>;
  sendInvites: Maybe<Scalars["Boolean"]["output"]>;
  setCompanyLogo: ICompany;
  setDynamicConfigByKey: IDynamicConfig;
  setGovernmentAwards: Maybe<IGovernment>;
  setGovernmentLogo: Maybe<IGovernment>;
  setGovernmentProductStack: Maybe<IGovernment>;
  setGovernmentProductStackAsAdmin: Maybe<IGovernment>;
  setGovernmentResources: IGovernment;
  setGroupAwards: Maybe<IGroup>;
  setGroupNewsworthy: Maybe<IGroup>;
  setGroupProducts: Maybe<IGroup>;
  setGroupResources: Maybe<IGroup>;
  setPodcastPageConfig: IPodcastPageConfig;
  setPrimaryGroup: Maybe<IUser>;
  setProductOnGovernmentStack: Maybe<IProduct>;
  setProfileCover: Maybe<IEntity>;
  setProfilePicture: Maybe<IUser>;
  setStoryCoverImages: IStory;
  setSubscriptionAsOverdue: ICompany;
  setUserResources: IUser;
  setVendorCreditAmount: ICompany;
  setVendorCreditsEligibilityDate: ICompany;
  signIn: Maybe<ISignInResult>;
  /**
   * This mutation is for allowing a logged User to submit its onboarding details. It is meant to be used only in the
   * frontend in the context of a logged user (viewer)
   */
  submitOnboardingDetails: IOnboarding;
  subscribeForNewsletter: Maybe<Scalars["Boolean"]["output"]>;
  subscribeForNewsletterFromStory: Maybe<Scalars["Boolean"]["output"]>;
  subscribeToPlan: ICompany;
  suggestProduct: Maybe<IOutsideProduct>;
  suggestSolution: ISolution;
  toggleAboutPageConfigActivation: IAboutPageConfig;
  toggleActivation: Maybe<Scalars["Boolean"]["output"]>;
  toggleArchiveOnCollection: ICollection;
  toggleArchiveOnSolution: ISolution;
  toggleBookmark: Maybe<IBookmarkTarget>;
  toggleCollectionFeatured: ICollection;
  toggleCollectionPublicContentAvailable: ICollection;
  toggleDisruptor: Maybe<IDisruptor>;
  toggleEnrichedProduct: IProduct;
  toggleFeatured: Maybe<IFeaturedTarget>;
  toggleFollow: Maybe<IFollowTarget>;
  toggleInnovator: Maybe<IInnovator>;
  /** This mutation is used to turn on/off the onboarding process */
  toggleIsOnboardingActive: Maybe<IGlobalSettings>;
  togglePauseCollectionMethod: Scalars["Boolean"]["output"];
  togglePostFeatured: Maybe<IPost>;
  toggleProductStack: Maybe<IProduct>;
  togglePublishedOnCollection: ICollection;
  toggleReportArchived: Maybe<IReport>;
  toggleReportPublished: Maybe<IReport>;
  toggleUpvote: Maybe<IUpvoteTarget>;
  toggleUserBan: Maybe<IUser>;
  toggleUsersCanAccessAccountPage: Maybe<Scalars["Boolean"]["output"]>;
  toggleUsersCanRequestContentTranslation: Maybe<Scalars["Boolean"]["output"]>;
  toggleVendorCreditsEligibility: ICompany;
  toggleVerified: IProject;
  trackLastVisitOnCollections: Maybe<Scalars["Boolean"]["output"]>;
  transferOwnership: ICompany;
  unflagDuplicatedUser: Maybe<Scalars["Boolean"]["output"]>;
  unpublishStory: IStory;
  unsubscribeFromNewsletter: Maybe<Scalars["Boolean"]["output"]>;
  unsubscribeFromNewsletterByUserId: Maybe<Scalars["Boolean"]["output"]>;
  updateAboutPageConfig: IAboutPageConfig;
  updateCollection: ICollection;
  updateCollectionMethod: Scalars["Boolean"]["output"];
  updateGovernmentProfile: Maybe<IGovernment>;
  updateGovernmentSettings: IGovernment;
  updateGroup: Maybe<IGroup>;
  updateImageAlt: IImage;
  updateNewsletterSettings: INewsletterSettings;
  updateProductSolutions: IProduct;
  updateProfile: IUser;
  updateProfileEmailSubscription: IUser;
  updateSolutionName: ISolution;
  updateTagById: ITag;
  updateTagTranslations: ITag;
  updateUserAdditionalInformation: IUser;
  uploadGovernments: IBatchGovernmentsUploadResult;
  uploadProductScreenshots: Maybe<IProduct>;
  verify: Maybe<IUser>;
  verifyCitizen: Maybe<IUser>;
  verifyProject: IProjectGovernmentVerificationRequest;
};

export type IMutationAcceptGroupRequestArgs = {
  requestId: Scalars["ObjectId"]["input"];
};

export type IMutationAcceptProductStackRequestArgs = {
  requestId: Scalars["ObjectId"]["input"];
};

export type IMutationAddCollectionArgs = {
  input: IAddCollectionInput;
};

export type IMutationAddCountryTimezoneArgs = {
  data: ICountryTimezoneInput;
};

export type IMutationAddGovernmentArgs = {
  payload: IAddGovernmentInput;
};

export type IMutationAddPlanArgs = {
  plan: IAddPlanInput;
};

export type IMutationAddProductArgs = {
  company: InputMaybe<Scalars["ObjectId"]["input"]>;
  product: IProductInput;
};

export type IMutationAddProductsToGovernmentsArgs = {
  governments: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
  products: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
};

export type IMutationAddReportArgs = {
  report: IReportInput;
};

export type IMutationAddSolutionArgs = {
  name: Scalars["String"]["input"];
};

export type IMutationAddSponsorshipArgs = {
  sponsorship: ISponsorshipInput;
};

export type IMutationAddTagArgs = {
  name: Scalars["String"]["input"];
  relatedTags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  types: Array<ITagType>;
};

export type IMutationAddVendorArgs = {
  vendor: IVendorInput;
};

export type IMutationAdminSignInArgs = {
  oauthToken: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationApproveSolutionArgs = {
  solutionId: Scalars["ObjectId"]["input"];
};

export type IMutationArchiveCollectionSponsoringSaleArgs = {
  saleId: Scalars["ObjectId"]["input"];
};

export type IMutationArchiveNewsletterCampaignArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationArchiveProductArgs = {
  productId: Scalars["ObjectId"]["input"];
};

export type IMutationArchiveProjectArgs = {
  projectId: Scalars["ObjectId"]["input"];
};

export type IMutationArchiveProjectsByIdsArgs = {
  projectIds: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationArchiveSponsorshipArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationArchiveStoryArgs = {
  storyId: Scalars["ObjectId"]["input"];
};

export type IMutationArchiveVendorArgs = {
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationAssignUserArgs = {
  governmentId: InputMaybe<Scalars["ObjectId"]["input"]>;
  type: Scalars["String"]["input"];
  userId: Scalars["ObjectId"]["input"];
  vendorId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationBulkTagByObjectIdsArgs = {
  entityIds: Array<Scalars["ObjectId"]["input"]>;
  entityType: InputMaybe<IBulkTaggingEntityType>;
  modifyStrategy: IBulkTaggingModifyStrategy;
  tagIds: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationCancelGroupRequestArgs = {
  requestId: Scalars["ObjectId"]["input"];
};

export type IMutationCancelProductStackRequestArgs = {
  requestId: Scalars["ObjectId"]["input"];
};

export type IMutationCancelVerificationRequestFromProjectByGovernmentIdArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  projectId: Scalars["ObjectId"]["input"];
};

export type IMutationChangeCollectionPositionArgs = {
  collectionId: Scalars["ObjectId"]["input"];
  position: Scalars["Int"]["input"];
};

export type IMutationChangeCreditCardArgs = {
  billingInformation: IBillingInformation;
  stripeSourceToken: Scalars["String"]["input"];
};

export type IMutationChangeGroupMembersArgs = {
  id: Scalars["ObjectId"]["input"];
  members: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationChangeOnboardingStatusArgs = {
  newStatus: IProcessStatusType;
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationChangeStoryAuthorArgs = {
  authorId: InputMaybe<Scalars["ObjectId"]["input"]>;
  storyId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationChangeSubscriptionPlanArgs = {
  stripePlanId: Scalars["String"]["input"];
};

export type IMutationCreateAboutPageConfigArgs = {
  active: Scalars["Boolean"]["input"];
  config: IAboutPageConfigInput;
};

export type IMutationCreateCollectionSponsoringSaleArgs = {
  input: ICreateSaleInput;
};

export type IMutationCreateCommentArgs = {
  body: Scalars["JSON"]["input"];
  targetId: Scalars["ObjectId"]["input"];
  targetType: ICommentTargetType;
};

export type IMutationCreateExternalLinkArgs = {
  data: IExternalLinkInput;
};

export type IMutationCreateGroupArgs = {
  group: IGroupInput;
};

export type IMutationCreateLandingPageConfigArgs = {
  landingPageConfig: ILandingPageConfigInput;
};

export type IMutationCreateLandingPageEventArgs = {
  data: ILandingPageEventInput;
};

export type IMutationCreateNewsletterCampaignArgs = {
  input: INewsletterCampaignInput;
};

export type IMutationCreateProjectForGovernmentArgs = {
  government: Scalars["ObjectId"]["input"];
  project: IProjectInput;
};

export type IMutationCreateProjectForGroupArgs = {
  group: Scalars["ObjectId"]["input"];
  project: IProjectInput;
};

export type IMutationCreateProjectForVendorArgs = {
  project: IProjectInput;
  vendor: Scalars["ObjectId"]["input"];
};

export type IMutationDeclineGroupRequestArgs = {
  requestId: Scalars["ObjectId"]["input"];
};

export type IMutationDeclineProductStackRequestArgs = {
  requestId: Scalars["ObjectId"]["input"];
};

export type IMutationDeclineProjectVerificationArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  projectId: Scalars["ObjectId"]["input"];
};

export type IMutationDeleteExternalLinkArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationDeleteLandingPageConfigArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationDeleteLandingPageEventArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationDeletePostArgs = {
  id: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationDeleteProfileArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationDeleteUserArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationDenyOutsideProductArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationDuplicateAboutPageConfigArgs = {
  configId: Scalars["ObjectId"]["input"];
};

export type IMutationDuplicateLandingPageConfigArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationEditCollectionSponsoringSaleArgs = {
  input: IEditSaleInput;
  saleId: Scalars["ObjectId"]["input"];
};

export type IMutationEditCommentArgs = {
  body: Scalars["JSON"]["input"];
  id: Scalars["ObjectId"]["input"];
};

export type IMutationEditCountryTimezoneArgs = {
  countryTimezoneId: Scalars["ObjectId"]["input"];
  data: ICountryTimezoneInput;
};

export type IMutationEditExternalLinkArgs = {
  data: IExternalLinkInput;
  id: Scalars["ObjectId"]["input"];
};

export type IMutationEditGovernmentArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  payload: IEditGovernmentInput;
};

export type IMutationEditGovernmentMembersArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  members: Array<IUserWithRoleInput>;
};

export type IMutationEditGroupGovernmentsArgs = {
  governments: Array<Scalars["ObjectId"]["input"]>;
  groupId: Scalars["ObjectId"]["input"];
};

export type IMutationEditGroupMembersArgs = {
  groupId: Scalars["ObjectId"]["input"];
  members: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationEditGroupVendorsArgs = {
  groupId: Scalars["ObjectId"]["input"];
  vendors: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationEditLandingPageConfigArgs = {
  id: Scalars["ObjectId"]["input"];
  landingPageConfig: ILandingPageConfigInput;
};

export type IMutationEditLandingPageEventArgs = {
  data: ILandingPageEventInput;
  id: Scalars["ObjectId"]["input"];
};

export type IMutationEditNewsletterCampaignArgs = {
  id: Scalars["ObjectId"]["input"];
  input: INewsletterCampaignInput;
};

export type IMutationEditOnboardingArgs = {
  data: IEditableOnboardingInput;
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationEditPlanArgs = {
  plan: IAddPlanInput;
  planId: Scalars["ObjectId"]["input"];
};

export type IMutationEditPostArgs = {
  id: Scalars["ObjectId"]["input"];
  post: IPostInput;
};

export type IMutationEditProductArgs = {
  company: InputMaybe<Scalars["ObjectId"]["input"]>;
  id: Scalars["ObjectId"]["input"];
  product: IProductInput;
};

export type IMutationEditProjectArgs = {
  project: IProjectInput;
  projectId: Scalars["ObjectId"]["input"];
  verified: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IMutationEditReportArgs = {
  id: InputMaybe<Scalars["ObjectId"]["input"]>;
  report: InputMaybe<IReportInput>;
};

export type IMutationEditSponsorshipArgs = {
  id: Scalars["ObjectId"]["input"];
  sponsorship: ISponsorshipInput;
};

export type IMutationEditStoryArgs = {
  audience: InputMaybe<Scalars["String"]["input"]>;
  author: InputMaybe<Scalars["ObjectId"]["input"]>;
  awards: Array<Scalars["ObjectId"]["input"]>;
  body: Scalars["JSON"]["input"];
  coauthors: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  collaborators: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  government: InputMaybe<Scalars["ObjectId"]["input"]>;
  highlights: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  introduction: Scalars["String"]["input"];
  locations: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
  medias: InputMaybe<Array<InputMaybe<IMediaInput>>>;
  newsworthy: InputMaybe<Array<InputMaybe<Scalars["JSON"]["input"]>>>;
  outsideProducts: InputMaybe<Array<InputMaybe<IOutsideProductInput>>>;
  products: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
  projectAwards: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  resources: InputMaybe<Array<InputMaybe<IResourceInput>>>;
  storyId: Scalars["ObjectId"]["input"];
  tags: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
  title: Scalars["String"]["input"];
  vendorCoauthors: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
};

export type IMutationEditTierArgs = {
  limits: ILimitsInput;
  tier: Scalars["String"]["input"];
};

export type IMutationEditVendorArgs = {
  id: Scalars["ObjectId"]["input"];
  vendor: IVendorInput;
};

export type IMutationEditVendorCustomLimitsArgs = {
  customLimits: IVendorCustomLimitsInput;
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationEditVendorMembersArgs = {
  members: Array<IUserWithRoleInput>;
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationExtendVendorCreditsEligibilityDateArgs = {
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationForceCancelSubscriptionArgs = {
  subscriptionId: Scalars["ObjectId"]["input"];
};

export type IMutationForceOnboardingArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationForceSendNewsletterToUserArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationForceSubscribeToPlanArgs = {
  data: IForceSubscribeToPlanInput;
};

export type IMutationGenStorybookMockDataArgs = {
  aggregateOn: Scalars["String"]["input"];
  aggregatePipeline: Scalars["String"]["input"];
};

export type IMutationGenerateTokenArgs = {
  slug: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationGetInviteTokenArgs = {
  targetId: Scalars["String"]["input"];
  targetType: Scalars["String"]["input"];
};

export type IMutationIgnoreOutsideProductArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationImpersonateArgs = {
  userId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationInviteGovernmentsToAddProductArgs = {
  governments: Array<Scalars["ObjectId"]["input"]>;
  productId: Scalars["ObjectId"]["input"];
};

export type IMutationInviteGovernmentsToGroupArgs = {
  governmentIds: Array<Scalars["ObjectId"]["input"]>;
  groupId: Scalars["ObjectId"]["input"];
};

export type IMutationInviteVendorsToGroupArgs = {
  groupId: Scalars["ObjectId"]["input"];
  vendorIds: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationJoinGroupArgs = {
  groupId: Scalars["ObjectId"]["input"];
};

export type IMutationLeaveGroupArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationLeaveGroupAsGovernmentArgs = {
  groupId: Scalars["ObjectId"]["input"];
};

export type IMutationLeaveGroupAsVendorArgs = {
  groupId: Scalars["ObjectId"]["input"];
};

export type IMutationPostToGovernmentArgs = {
  government: Scalars["ObjectId"]["input"];
  post: IPostInput;
};

export type IMutationPostToGroupArgs = {
  group: Scalars["ObjectId"]["input"];
  post: IPostInput;
};

export type IMutationPostToVendorArgs = {
  post: IPostInput;
  vendor: Scalars["ObjectId"]["input"];
};

export type IMutationProposeStoryArgs = {
  audience: InputMaybe<Scalars["String"]["input"]>;
  author: InputMaybe<Scalars["ObjectId"]["input"]>;
  awards: Array<Scalars["ObjectId"]["input"]>;
  body: Scalars["JSON"]["input"];
  coauthors: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  collaborators: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  government: InputMaybe<Scalars["ObjectId"]["input"]>;
  highlights: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  introduction: Scalars["String"]["input"];
  locations: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
  medias: InputMaybe<Array<InputMaybe<IMediaInput>>>;
  newsworthy: InputMaybe<Array<InputMaybe<Scalars["JSON"]["input"]>>>;
  outsideProducts: InputMaybe<Array<InputMaybe<IOutsideProductInput>>>;
  products: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
  projectAwards: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  resources: InputMaybe<Array<InputMaybe<IResourceInput>>>;
  tags: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
  title: Scalars["String"]["input"];
  vendorCoauthors: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
};

export type IMutationPublishStoryArgs = {
  storyId: Scalars["ObjectId"]["input"];
};

export type IMutationReassembleGroupGovernmentsArgs = {
  addedGovernments: Array<Scalars["ObjectId"]["input"]>;
  groupId: Scalars["ObjectId"]["input"];
  removedGovernments: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationReassembleGroupVendorsArgs = {
  addedVendors: Array<Scalars["ObjectId"]["input"]>;
  groupId: Scalars["ObjectId"]["input"];
  removedVendors: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationRemoveAboutPageConfigArgs = {
  configId: Scalars["ObjectId"]["input"];
};

export type IMutationRemoveCitizenVerificationArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationRemoveCommentArgs = {
  id: Scalars["ObjectId"]["input"];
  targetId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationRemoveGroupByIdArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationRemoveGroupGovernmentArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  groupId: Scalars["ObjectId"]["input"];
};

export type IMutationRemoveGroupVendorArgs = {
  groupId: Scalars["ObjectId"]["input"];
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationRemoveInviteeArgs = {
  inviteeId: InputMaybe<Scalars["ObjectId"]["input"]>;
  targetId: Scalars["String"]["input"];
  targetType: Scalars["String"]["input"];
};

export type IMutationRemoveTagByIdArgs = {
  tagId: Scalars["ObjectId"]["input"];
};

export type IMutationRemoveVerificationArgs = {
  attachments: InputMaybe<Array<IAttachmentInput>>;
  explanation: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationRenameTagByIdArgs = {
  name: Scalars["String"]["input"];
  tagId: Scalars["ObjectId"]["input"];
};

export type IMutationReplyCommentArgs = {
  body: Scalars["JSON"]["input"];
  replyTo: Scalars["ObjectId"]["input"];
};

export type IMutationRequestGovernmentOwnershipArgs = {
  government: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationRequestVendorOwnershipArgs = {
  vendor: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationResetOnboardingArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationResetVendorCustomLimitsArgs = {
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationRestoreGroupByIdArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationRestoreProductArgs = {
  slug: Scalars["String"]["input"];
};

export type IMutationRestoreProjectArgs = {
  projectId: Scalars["ObjectId"]["input"];
};

export type IMutationRestoreSponsorshipArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationRestoreStoryArgs = {
  storyId: Scalars["ObjectId"]["input"];
};

export type IMutationRestoreTagByIdArgs = {
  tagId: Scalars["ObjectId"]["input"];
};

export type IMutationRestoreVendorArgs = {
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationSaveCompanySharingArgs = {
  companyId: Scalars["ObjectId"]["input"];
  enabledSharing: Scalars["Boolean"]["input"];
  sharing: ICompanySharingInput;
};

export type IMutationSaveGovernmentSharingArgs = {
  enableSharing: Scalars["Boolean"]["input"];
  governmentSlug: Scalars["String"]["input"];
  sharing: InputMaybe<IGovernmentSharingInput>;
};

export type IMutationSaveUserSharingArgs = {
  enableSharing: Scalars["Boolean"]["input"];
  sharing: InputMaybe<IUserSharingInput>;
  userSlug: Scalars["String"]["input"];
};

export type IMutationSendInvitesArgs = {
  emails: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  targetId: Scalars["String"]["input"];
  targetType: Scalars["String"]["input"];
};

export type IMutationSetCompanyLogoArgs = {
  companyId: Scalars["ObjectId"]["input"];
  logo: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationSetDynamicConfigByKeyArgs = {
  key: Scalars["String"]["input"];
  value: Scalars["JSON"]["input"];
};

export type IMutationSetGovernmentAwardsArgs = {
  awards: Array<Scalars["ObjectId"]["input"]>;
  governmentId: Scalars["ObjectId"]["input"];
};

export type IMutationSetGovernmentLogoArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  logo: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationSetGovernmentProductStackArgs = {
  outsideProducts: InputMaybe<Array<InputMaybe<IOutsideProductInput>>>;
  productIds: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
};

export type IMutationSetGovernmentProductStackAsAdminArgs = {
  governmentId: InputMaybe<Scalars["ObjectId"]["input"]>;
  productIds: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
};

export type IMutationSetGovernmentResourcesArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  resources: InputMaybe<Array<InputMaybe<IResourceInput>>>;
};

export type IMutationSetGroupAwardsArgs = {
  awards: Array<Scalars["ObjectId"]["input"]>;
  groupId: Scalars["ObjectId"]["input"];
};

export type IMutationSetGroupNewsworthyArgs = {
  id: InputMaybe<Scalars["ObjectId"]["input"]>;
  newsworthy: Array<IGroupNewsworthyItemInput>;
};

export type IMutationSetGroupProductsArgs = {
  id: InputMaybe<Scalars["ObjectId"]["input"]>;
  outsideProducts: Array<IOutsideProductInput>;
  products: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationSetGroupResourcesArgs = {
  id: InputMaybe<Scalars["ObjectId"]["input"]>;
  resources: Array<IResourceInput>;
};

export type IMutationSetPodcastPageConfigArgs = {
  config: IPodcastPageConfigInput;
};

export type IMutationSetPrimaryGroupArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationSetProductOnGovernmentStackArgs = {
  addingGovernments: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
  productId: InputMaybe<Scalars["ObjectId"]["input"]>;
  removingGovernments: InputMaybe<Array<InputMaybe<Scalars["ObjectId"]["input"]>>>;
};

export type IMutationSetProfileCoverArgs = {
  cover: InputMaybe<ICoverInput>;
  targetId: Scalars["ObjectId"]["input"];
  targetType: IProfileCoverTarget;
};

export type IMutationSetProfilePictureArgs = {
  picture: Scalars["String"]["input"];
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationSetStoryCoverImagesArgs = {
  horizontalCover: InputMaybe<Scalars["String"]["input"]>;
  story: Scalars["ObjectId"]["input"];
  verticalCover: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationSetSubscriptionAsOverdueArgs = {
  vendorSlug: Scalars["String"]["input"];
};

export type IMutationSetUserResourcesArgs = {
  resources: Array<IResourceInput>;
};

export type IMutationSetVendorCreditAmountArgs = {
  amount: Scalars["Float"]["input"];
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationSetVendorCreditsEligibilityDateArgs = {
  canEarnCreditsUntil: Scalars["String"]["input"];
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationSignInArgs = {
  inviteToken: InputMaybe<Scalars["String"]["input"]>;
  oauthToken: InputMaybe<Scalars["String"]["input"]>;
  referralToken: InputMaybe<Scalars["String"]["input"]>;
  storyCollaboratorToken: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationSubmitOnboardingDetailsArgs = {
  data: IOnboardingDetailsInput;
};

export type IMutationSubscribeForNewsletterArgs = {
  email: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationSubscribeForNewsletterFromStoryArgs = {
  email: Scalars["String"]["input"];
};

export type IMutationSubscribeToPlanArgs = {
  billingInformation: IBillingInformation;
  stripePlanId: Scalars["String"]["input"];
  stripeSourceToken: Scalars["String"]["input"];
};

export type IMutationSuggestProductArgs = {
  name: Scalars["String"]["input"];
  url: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationSuggestSolutionArgs = {
  input: ISuggestSolutionInput;
};

export type IMutationToggleAboutPageConfigActivationArgs = {
  configId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleActivationArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationToggleArchiveOnCollectionArgs = {
  collectionId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleArchiveOnSolutionArgs = {
  solutionId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleBookmarkArgs = {
  targetId: Scalars["ObjectId"]["input"];
  targetType: IBookmarkType;
};

export type IMutationToggleCollectionFeaturedArgs = {
  collectionId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleCollectionPublicContentAvailableArgs = {
  collectionId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleDisruptorArgs = {
  entityId: Scalars["ObjectId"]["input"];
  entityType: Scalars["String"]["input"];
};

export type IMutationToggleEnrichedProductArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationToggleFeaturedArgs = {
  targetId: Scalars["ObjectId"]["input"];
  targetType: IFeaturedTargetType;
};

export type IMutationToggleFollowArgs = {
  targetId: Scalars["ObjectId"]["input"];
  targetType: IFollowType;
};

export type IMutationToggleInnovatorArgs = {
  entityId: InputMaybe<Scalars["ObjectId"]["input"]>;
  entityType: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationToggleIsOnboardingActiveArgs = {
  isActive: Scalars["Boolean"]["input"];
};

export type IMutationTogglePauseCollectionMethodArgs = {
  subscriptionId: Scalars["ObjectId"]["input"];
};

export type IMutationTogglePostFeaturedArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationToggleProductStackArgs = {
  governmentId: InputMaybe<Scalars["ObjectId"]["input"]>;
  productId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationTogglePublishedOnCollectionArgs = {
  collectionId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleReportArchivedArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationToggleReportPublishedArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IMutationToggleUpvoteArgs = {
  targetId: Scalars["ObjectId"]["input"];
  targetType: IUpvoteTargetType;
};

export type IMutationToggleUserBanArgs = {
  userId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IMutationToggleUsersCanAccessAccountPageArgs = {
  isAccessAllowed: Scalars["Boolean"]["input"];
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleUsersCanRequestContentTranslationArgs = {
  requestContentTranslationAllowed: Scalars["Boolean"]["input"];
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleVendorCreditsEligibilityArgs = {
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationToggleVerifiedArgs = {
  projectId: Scalars["ObjectId"]["input"];
};

export type IMutationTrackLastVisitOnCollectionsArgs = {
  collectionIds: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationTransferOwnershipArgs = {
  newOwnerId: Scalars["ObjectId"]["input"];
  vendorId: Scalars["ObjectId"]["input"];
};

export type IMutationUnflagDuplicatedUserArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationUnpublishStoryArgs = {
  storyId: Scalars["ObjectId"]["input"];
};

export type IMutationUnsubscribeFromNewsletterArgs = {
  email: InputMaybe<Scalars["String"]["input"]>;
};

export type IMutationUnsubscribeFromNewsletterByUserIdArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationUpdateAboutPageConfigArgs = {
  active: Scalars["Boolean"]["input"];
  config: IAboutPageConfigInput;
  configId: Scalars["ObjectId"]["input"];
};

export type IMutationUpdateCollectionArgs = {
  collectionId: Scalars["ObjectId"]["input"];
  input: IUpdateCollectionInput;
};

export type IMutationUpdateCollectionMethodArgs = {
  collectionMethod: InputMaybe<Scalars["String"]["input"]>;
  subscriptionId: Scalars["ObjectId"]["input"];
};

export type IMutationUpdateGovernmentProfileArgs = {
  government: IUpdateGovernmentProfileInput;
  governmentId: Scalars["ObjectId"]["input"];
};

export type IMutationUpdateGovernmentSettingsArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  settings: IGovernmentSettingsInput;
};

export type IMutationUpdateGroupArgs = {
  group: IGroupInput;
  id: Scalars["ObjectId"]["input"];
};

export type IMutationUpdateImageAltArgs = {
  alt: Scalars["String"]["input"];
  imageId: Scalars["ObjectId"]["input"];
};

export type IMutationUpdateNewsletterSettingsArgs = {
  input: INewsletterInput;
};

export type IMutationUpdateProductSolutionsArgs = {
  productId: Scalars["ObjectId"]["input"];
  solutionIds: Array<Scalars["ObjectId"]["input"]>;
};

export type IMutationUpdateProfileArgs = {
  user: IUserProfileInput;
};

export type IMutationUpdateProfileEmailSubscriptionArgs = {
  user: IUserProfileSubscriptionInput;
};

export type IMutationUpdateSolutionNameArgs = {
  name: Scalars["String"]["input"];
  solutionId: Scalars["ObjectId"]["input"];
};

export type IMutationUpdateTagByIdArgs = {
  name: Scalars["String"]["input"];
  relatedTags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  tagId: Scalars["ObjectId"]["input"];
  types: Array<ITagType>;
};

export type IMutationUpdateTagTranslationsArgs = {
  input: Array<ITagTranslationInput>;
  tagId: Scalars["ObjectId"]["input"];
};

export type IMutationUpdateUserAdditionalInformationArgs = {
  additionalInformation: IUserAdditionalInformationInput;
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationUploadGovernmentsArgs = {
  isoCountryCode: Scalars["String"]["input"];
  isoCurrencyCode: Scalars["String"]["input"];
  payload: Array<IUploadGovernmentInput>;
  uploadId: Scalars["ID"]["input"];
};

export type IMutationUploadProductScreenshotsArgs = {
  productId: Scalars["ObjectId"]["input"];
  screenshots: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type IMutationVerifyArgs = {
  attachments: InputMaybe<Array<IAttachmentInput>>;
  explanation: InputMaybe<Scalars["String"]["input"]>;
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationVerifyCitizenArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IMutationVerifyProjectArgs = {
  governmentId: Scalars["ObjectId"]["input"];
  projectId: Scalars["ObjectId"]["input"];
};

export type INewsletterCampaign = {
  __typename: "NewsletterCampaign";
  _id: Scalars["String"]["output"];
  archivedAt: Maybe<Scalars["Date"]["output"]>;
  countries: Array<INewsletterCampaignCountryAmount>;
  dynamicContent: INewsletterCampaignContent;
  name: Scalars["String"]["output"];
};

export type INewsletterCampaignContent = {
  __typename: "NewsletterCampaignContent";
  otherCollections: Scalars["Int"]["output"];
  projectsCount: Scalars["Int"]["output"];
  storiesCount: Scalars["Int"]["output"];
  topCollections: Scalars["Int"]["output"];
};

export type INewsletterCampaignContentInput = {
  otherCollections: Scalars["Int"]["input"];
  projectsCount: Scalars["Int"]["input"];
  storiesCount: Scalars["Int"]["input"];
  topCollections: Scalars["Int"]["input"];
};

export type INewsletterCampaignCountryAmount = {
  __typename: "NewsletterCampaignCountryAmount";
  amount: Scalars["Int"]["output"];
  countryCode: Scalars["String"]["output"];
};

export type INewsletterCampaignCountryAmountInput = {
  amount: Scalars["Int"]["input"];
  countryCode: Scalars["String"]["input"];
};

export type INewsletterCampaignData = {
  __typename: "NewsletterCampaignData";
  collections: Array<INewsletterCollection>;
  projects: Array<INewsletterProject>;
  stories: Array<INewsletterStory>;
  totalProjectsCount: Scalars["Int"]["output"];
  viewOnlineLink: Scalars["String"]["output"];
};

export enum INewsletterCampaignFrequency {
  Biweekly = "BIWEEKLY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export type INewsletterCampaignInput = {
  countriesAmount: Array<INewsletterCampaignCountryAmountInput>;
  dynamicContent: INewsletterCampaignContentInput;
  name: Scalars["String"]["input"];
};

export type INewsletterCollection = {
  __typename: "NewsletterCollection";
  itemsCount: Scalars["Int"]["output"];
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  tags: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export enum INewsletterFrequency {
  Biweekly = "BIWEEKLY",
  Monthly = "MONTHLY",
  Weekly = "WEEKLY",
}

export type INewsletterInput = {
  collections: Scalars["Int"]["input"];
  hourToSend: Scalars["Int"]["input"];
  maxProjects: Scalars["Int"]["input"];
  projectsPerCollection: Scalars["Int"]["input"];
  storiesPerCollection: Scalars["Int"]["input"];
  subject: Scalars["String"]["input"];
};

export type INewsletterProject = {
  __typename: "NewsletterProject";
  countryCode: Maybe<Scalars["String"]["output"]>;
  flag: Maybe<Scalars["String"]["output"]>;
  rawTitle: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type INewsletterSettings = {
  __typename: "NewsletterSettings";
  collections: Scalars["Int"]["output"];
  hourToSend: Scalars["Int"]["output"];
  maxProjects: Scalars["Int"]["output"];
  projectsPerCollection: Scalars["Int"]["output"];
  storiesPerCollection: Scalars["Int"]["output"];
  subject: Scalars["String"]["output"];
};

export type INewsletterStory = {
  __typename: "NewsletterStory";
  coverImage: Maybe<IStoryCoverImage>;
  introduction: Scalars["String"]["output"];
  podcastUrl: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  url: Maybe<Scalars["String"]["output"]>;
};

export type INewsworthyItem = {
  __typename: "NewsworthyItem";
  description: Maybe<Scalars["String"]["output"]>;
  favicon: Maybe<Scalars["String"]["output"]>;
  siteName: Scalars["String"]["output"];
  title: Maybe<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

export type IOnboarding = {
  __typename: "Onboarding";
  _id: Scalars["ObjectId"]["output"];
  city: Maybe<Scalars["String"]["output"]>;
  country: Maybe<Scalars["String"]["output"]>;
  facebookUrl: Maybe<Scalars["URL"]["output"]>;
  governmentId: Maybe<Scalars["ObjectId"]["output"]>;
  linkedInUrl: Maybe<Scalars["URL"]["output"]>;
  processStatus: IProcessStatusType;
  state: Maybe<Scalars["String"]["output"]>;
  twitterUrl: Maybe<Scalars["URL"]["output"]>;
  user: IUser;
  vendorName: Maybe<Scalars["String"]["output"]>;
  vendorWebsite: Maybe<Scalars["URL"]["output"]>;
  whyYouWantToJoin: Maybe<Scalars["String"]["output"]>;
  workingFor: Maybe<IWorkPlaceType>;
  workplaceName: Maybe<Scalars["String"]["output"]>;
  workplaceWebsite: Maybe<Scalars["URL"]["output"]>;
};

export type IOnboardingDetailsInput = {
  city: InputMaybe<Scalars["String"]["input"]>;
  country: InputMaybe<Scalars["String"]["input"]>;
  facebookUrl: InputMaybe<Scalars["String"]["input"]>;
  governmentId: InputMaybe<Scalars["ObjectId"]["input"]>;
  linkedInUrl: InputMaybe<Scalars["String"]["input"]>;
  state: InputMaybe<Scalars["String"]["input"]>;
  twitterUrl: InputMaybe<Scalars["String"]["input"]>;
  vendorName: InputMaybe<Scalars["String"]["input"]>;
  vendorWebsite: InputMaybe<Scalars["String"]["input"]>;
  whyYouWantToJoin: InputMaybe<Scalars["String"]["input"]>;
  workingFor: InputMaybe<IWorkPlaceType>;
  workplaceName: InputMaybe<Scalars["String"]["input"]>;
  workplaceWebsite: InputMaybe<Scalars["String"]["input"]>;
};

export type IOnboardingProcessStatusCounts = {
  __typename: "OnboardingProcessStatusCounts";
  additionalInformationRequiredCount: Scalars["Int"]["output"];
  pendingVerificationCount: Scalars["Int"]["output"];
  requiredCount: Scalars["Int"]["output"];
  verifiedCount: Scalars["Int"]["output"];
};

export type IOnboardings = {
  __typename: "Onboardings";
  items: Array<IOnboarding>;
  pageInfo: Maybe<IPageInfo>;
};

export type IOutsideCollaborator = {
  __typename: "OutsideCollaborator";
  email: Maybe<Scalars["String"]["output"]>;
  firstName: Maybe<Scalars["String"]["output"]>;
  lastName: Maybe<Scalars["String"]["output"]>;
  linkedinUrl: Maybe<Scalars["String"]["output"]>;
};

export type IOutsideProduct = {
  __typename: "OutsideProduct";
  _id: Scalars["ObjectId"]["output"];
  addedBy: Maybe<Array<IUser>>;
  addedOn: Maybe<Array<IOutsideProductAddedOn>>;
  createdAt: Scalars["Date"]["output"];
  logo: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  product: Maybe<IProduct>;
  status: Maybe<IOutsideProductStatus>;
  url: Maybe<Scalars["URL"]["output"]>;
};

export type IOutsideProductAddedOn = IGovernment | IProduct | IStory;

export type IOutsideProductInput = {
  _id: InputMaybe<Scalars["ObjectId"]["input"]>;
  name: Scalars["String"]["input"];
  url: InputMaybe<Scalars["URL"]["input"]>;
};

export enum IOutsideProductStatus {
  Added = "ADDED",
  Denied = "DENIED",
  Ignored = "IGNORED",
  Pending = "PENDING",
}

export type IOutsideProducts = {
  __typename: "OutsideProducts";
  items: Maybe<Array<IOutsideProduct>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IOutsideProductsCount = {
  __typename: "OutsideProductsCount";
  addedCount: Maybe<Scalars["Int"]["output"]>;
  deniedCount: Maybe<Scalars["Int"]["output"]>;
  ignoredCount: Maybe<Scalars["Int"]["output"]>;
  pendingCount: Maybe<Scalars["Int"]["output"]>;
};

export type IOverdueSubscription = {
  __typename: "OverdueSubscription";
  _id: Scalars["ObjectId"]["output"];
  freeSubscription: Maybe<Scalars["Boolean"]["output"]>;
  lastCharge: Maybe<ICharge>;
  nextPaymentAmount: Maybe<Scalars["Int"]["output"]>;
  nextPaymentAttempt: Maybe<Scalars["DateTime"]["output"]>;
  pausePaymentCollection: Maybe<Scalars["Boolean"]["output"]>;
  stripeStatus: Maybe<Scalars["String"]["output"]>;
  trialPeriod: Maybe<Scalars["Int"]["output"]>;
  willCancelAt: Scalars["DateTime"]["output"];
};

export type IPageInfo = {
  __typename: "PageInfo";
  endCursor: Maybe<Scalars["Cursor"]["output"]>;
  hasNextPage: Maybe<Scalars["Boolean"]["output"]>;
  hasPreviousPage: Maybe<Scalars["Boolean"]["output"]>;
  startCursor: Maybe<Scalars["Cursor"]["output"]>;
  totalCount: Maybe<Scalars["Int"]["output"]>;
};

export type IPendingUser = IUserInterface &
  IUserProfile & {
    __typename: "PendingUser";
    _id: Scalars["ObjectId"]["output"];
    algoliaKeys: Maybe<IAlgoliaKeys>;
    avatar: Maybe<Scalars["String"]["output"]>;
    bannedAt: Maybe<Scalars["DateTime"]["output"]>;
    bookmarks: Array<IBookmarkTarget>;
    canSeeActiveGovernments: Scalars["Boolean"]["output"];
    collections: Array<ICollection>;
    country: Maybe<Scalars["String"]["output"]>;
    cover: Maybe<ICover>;
    createdAt: Maybe<Scalars["DateTime"]["output"]>;
    department: Maybe<ITag>;
    email: Maybe<Scalars["String"]["output"]>;
    feedCount: Scalars["Int"]["output"];
    firstName: Maybe<Scalars["String"]["output"]>;
    followers: Array<IUser>;
    following: Array<IFollowTarget>;
    fullName: Maybe<Scalars["String"]["output"]>;
    groupRequest: Maybe<IGroupRequest>;
    groups: Array<IGroup>;
    intercomId: Maybe<Scalars["ID"]["output"]>;
    intercomUserHash: Scalars["String"]["output"];
    interests: Array<ITag>;
    /** Pulls the Geo data from the request IP */
    ipLocation: Maybe<IIpLocation>;
    isDuplicated: Maybe<Scalars["Boolean"]["output"]>;
    isFollowing: Scalars["Boolean"]["output"];
    isInnovator: Maybe<Scalars["Boolean"]["output"]>;
    isLimitedSiteAdmin: Maybe<Scalars["Boolean"]["output"]>;
    isSelfie: Maybe<Scalars["Boolean"]["output"]>;
    isSiteAdmin: Maybe<Scalars["Boolean"]["output"]>;
    isUnverifiable: Maybe<Scalars["Boolean"]["output"]>;
    jobTitle: Maybe<Scalars["String"]["output"]>;
    language: Maybe<Scalars["String"]["output"]>;
    lastName: Maybe<Scalars["String"]["output"]>;
    lastSeen: Maybe<Scalars["DateTime"]["output"]>;
    lastSignInAt: Maybe<Scalars["DateTime"]["output"]>;
    lastSignInProvider: Scalars["String"]["output"];
    latestNewsletterHtml: Maybe<Scalars["String"]["output"]>;
    linkedinId: Maybe<Scalars["String"]["output"]>;
    linkedinUrl: Maybe<Scalars["String"]["output"]>;
    newsletterFrequency: Maybe<INewsletterFrequency>;
    newsletterLastSentDate: Maybe<Scalars["Date"]["output"]>;
    notes: Scalars["String"]["output"];
    notificationEmail: Maybe<Scalars["String"]["output"]>;
    onboarding: Maybe<IOnboarding>;
    onboardingStatus: Maybe<IProcessStatusType>;
    posts: Array<IPost>;
    postsCount: Scalars["Int"]["output"];
    preferences: IUserPreferences;
    previousCompany: Maybe<ICompany>;
    primaryGroup: Maybe<IGroup>;
    productStackRequest: Maybe<IProductStackRequest>;
    projects: Maybe<IProjects>;
    projectsCount: Scalars["Int"]["output"];
    role: Maybe<Scalars["String"]["output"]>;
    savedCollectionsCount: Scalars["Int"]["output"];
    savedCount: Scalars["Int"]["output"];
    savedPostsCount: Scalars["Int"]["output"];
    savedProductsCount: Scalars["Int"]["output"];
    savedProjectsCount: Scalars["Int"]["output"];
    savedStoriesCount: Scalars["Int"]["output"];
    searchable: Maybe<Scalars["Boolean"]["output"]>;
    showOnboardingBanner: Scalars["Boolean"]["output"];
    signInAttempts: Maybe<Array<ISignInAttempt>>;
    slug: Scalars["String"]["output"];
    socialMedia: Maybe<IUserSocialMediaLinks>;
    stories: Maybe<IStories>;
    storiesCount: Maybe<Scalars["Int"]["output"]>;
    subscribedToCampaign: Maybe<Scalars["Boolean"]["output"]>;
    subscribedToNewsletter: Maybe<Scalars["Boolean"]["output"]>;
    timeZone: Maybe<Scalars["String"]["output"]>;
    upvotes: Maybe<IUpvotes>;
    upvotesCount: Maybe<Scalars["Int"]["output"]>;
    verification: Maybe<IVerification>;
    verified: Scalars["Boolean"]["output"];
    viewerCouldNotJoinReason: Maybe<Scalars["String"]["output"]>;
  };

export type IPendingUserAvatarArgs = {
  height: InputMaybe<Scalars["Int"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export type IPendingUserPostsArgs = {
  audience: InputMaybe<IPostAudience>;
};

export type IPendingUserPostsCountArgs = {
  audience: InputMaybe<IPostAudience>;
};

export type IPendingUserProjectsArgs = {
  audience: InputMaybe<IProjectAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IPendingUserStoriesArgs = {
  audience: InputMaybe<IStoryAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IPendingUserStoriesCountArgs = {
  audience: InputMaybe<IStoryAudience>;
};

export type IPendingUserUpvotesArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IPlan = {
  __typename: "Plan";
  _id: Scalars["ObjectId"]["output"];
  displayName: Scalars["String"]["output"];
  isSelectable: Scalars["Boolean"]["output"];
  limits: IPlanLimits;
  name: Scalars["String"]["output"];
  stripePlan: Maybe<IStripePlan>;
  stripePlanId: Maybe<Scalars["String"]["output"]>;
  tier: IPlanTier;
  vendorCount: Scalars["Int"]["output"];
};

export type IPlanLimits = {
  __typename: "PlanLimits";
  enrichedProducts: Scalars["Int"]["output"];
  enrichedProfile: Scalars["Boolean"]["output"];
  groupInvitations: Scalars["Int"]["output"];
  groups: Scalars["Int"]["output"];
  inviteGovernments: Scalars["Boolean"]["output"];
  productTags: Scalars["Int"]["output"];
  products: Scalars["Int"]["output"];
  projectsPerMonth: Scalars["Int"]["output"];
  searchAccess: Scalars["Boolean"]["output"];
  sharingPage: Scalars["Boolean"]["output"];
  teamMembers: Scalars["Int"]["output"];
};

export enum IPlanRecurrency {
  Monthly = "MONTHLY",
  Yearly = "YEARLY",
}

export enum IPlanTier {
  Basic = "BASIC",
  Disruptor = "DISRUPTOR",
  Makers = "MAKERS",
  Makerspro = "MAKERSPRO",
}

export type IPlanUsage = {
  __typename: "PlanUsage";
  enrichedProducts: Scalars["Int"]["output"];
  groupInvitations: Scalars["Int"]["output"];
  groups: Scalars["Int"]["output"];
  products: Scalars["Int"]["output"];
  productsWithMultipleTags: Scalars["Int"]["output"];
  projectsThisMonth: Scalars["Int"]["output"];
  sharingPage: Scalars["Boolean"]["output"];
  teamMembers: Scalars["Int"]["output"];
};

export type IPlayStoreProductDeployment = {
  __typename: "PlayStoreProductDeployment";
  linkHref: Scalars["String"]["output"];
};

export type IPodcastBlockData = IBlockData & {
  __typename: "PodcastBlockData";
  backgroundColor: Maybe<Scalars["String"]["output"]>;
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  podcastSrc: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
};

export type IPodcastPageConfig = {
  __typename: "PodcastPageConfig";
  amazonmusic: Maybe<Scalars["URL"]["output"]>;
  apple: Maybe<Scalars["URL"]["output"]>;
  backgroundColor: Scalars["String"]["output"];
  deezer: Maybe<Scalars["URL"]["output"]>;
  description: Scalars["String"]["output"];
  descriptionColor: Scalars["String"]["output"];
  facebook: Maybe<Scalars["URL"]["output"]>;
  googleplay: Maybe<Scalars["URL"]["output"]>;
  headerText: Scalars["String"]["output"];
  headerTextColor: Scalars["String"]["output"];
  iheartradio: Maybe<Scalars["URL"]["output"]>;
  instagram: Maybe<Scalars["URL"]["output"]>;
  overcast: Maybe<Scalars["URL"]["output"]>;
  pandora: Maybe<Scalars["URL"]["output"]>;
  podcastHeight: Scalars["Int"]["output"];
  podcastSrc: Scalars["URL"]["output"];
  soundcloud: Maybe<Scalars["URL"]["output"]>;
  spotify: Maybe<Scalars["URL"]["output"]>;
  stitcher: Maybe<Scalars["URL"]["output"]>;
  twitter: Maybe<Scalars["URL"]["output"]>;
  youtube: Maybe<Scalars["URL"]["output"]>;
};

export type IPodcastPageConfigInput = {
  amazonmusic: InputMaybe<Scalars["URL"]["input"]>;
  apple: InputMaybe<Scalars["URL"]["input"]>;
  backgroundColor: Scalars["String"]["input"];
  deezer: InputMaybe<Scalars["URL"]["input"]>;
  description: Scalars["String"]["input"];
  descriptionColor: Scalars["String"]["input"];
  facebook: InputMaybe<Scalars["URL"]["input"]>;
  googleplay: InputMaybe<Scalars["URL"]["input"]>;
  headerText: Scalars["String"]["input"];
  headerTextColor: Scalars["String"]["input"];
  iheartradio: InputMaybe<Scalars["URL"]["input"]>;
  instagram: InputMaybe<Scalars["URL"]["input"]>;
  overcast: InputMaybe<Scalars["URL"]["input"]>;
  pandora: InputMaybe<Scalars["URL"]["input"]>;
  podcastHeight: Scalars["Int"]["input"];
  podcastSrc: Scalars["URL"]["input"];
  soundcloud: InputMaybe<Scalars["URL"]["input"]>;
  spotify: InputMaybe<Scalars["URL"]["input"]>;
  stitcher: InputMaybe<Scalars["URL"]["input"]>;
  twitter: InputMaybe<Scalars["URL"]["input"]>;
  youtube: InputMaybe<Scalars["URL"]["input"]>;
};

export type IPost = IGovernmentPost | IGroupPost | IVendorPost;

export type IPostAttachment = {
  __typename: "PostAttachment";
  filename: Scalars["String"]["output"];
  mimeType: Scalars["String"]["output"];
  sizeInBytes: Scalars["Int"]["output"];
  url: Scalars["String"]["output"];
};

export type IPostAttachmentInput = {
  filename: Scalars["String"]["input"];
  mimeType: Scalars["String"]["input"];
  sizeInBytes: Scalars["Int"]["input"];
  url: Scalars["String"]["input"];
};

export enum IPostAudience {
  Community = "COMMUNITY",
  Public = "PUBLIC",
}

export type IPostInput = {
  attachments: Array<IPostAttachmentInput>;
  audience: Scalars["String"]["input"];
  body: Scalars["String"]["input"];
  links: Array<IPostLinkInput>;
};

export type IPostInterface = {
  _id: Scalars["ObjectId"]["output"];
  attachments: Array<IPostAttachment>;
  audience: Scalars["String"]["output"];
  author: IUser;
  body: Scalars["String"]["output"];
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedBy: Maybe<IUser>;
  featuredAt: Maybe<Scalars["DateTime"]["output"]>;
  links: Array<IPostLink>;
  upvotesCount: Scalars["Int"]["output"];
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
};

export type IPostLink = {
  __typename: "PostLink";
  addedAt: Maybe<Scalars["Float"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  favicon: Maybe<Scalars["String"]["output"]>;
  siteName: Maybe<Scalars["String"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type IPostLinkInput = {
  addedAt: InputMaybe<Scalars["Float"]["input"]>;
  description: InputMaybe<Scalars["String"]["input"]>;
  favicon: InputMaybe<Scalars["String"]["input"]>;
  siteName: InputMaybe<Scalars["String"]["input"]>;
  title: InputMaybe<Scalars["String"]["input"]>;
  url: InputMaybe<Scalars["String"]["input"]>;
};

export type IPosts = {
  __typename: "Posts";
  items: Maybe<Array<IPosts>>;
  pageInfo: Maybe<IPageInfo>;
};

export enum IProcessStatusType {
  AdditionalInformationRequired = "ADDITIONAL_INFORMATION_REQUIRED",
  PendingVerification = "PENDING_VERIFICATION",
  Required = "REQUIRED",
  Verified = "VERIFIED",
}

export type IProduct = {
  __typename: "Product";
  _id: Scalars["ObjectId"]["output"];
  about: Maybe<Scalars["String"]["output"]>;
  allowRequestTranslation: Maybe<Scalars["Boolean"]["output"]>;
  alternatives: Maybe<Array<IProduct>>;
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  assistiveTechnologiesCompatibility: Array<IAssistiveTechnology>;
  canBeDisruptor: Scalars["Boolean"]["output"];
  canBeEnrichedProduct: Scalars["Boolean"]["output"];
  certifications: Array<Scalars["String"]["output"]>;
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  company: Maybe<ICompany>;
  contactPage: Maybe<Scalars["URL"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  deployment: Array<IProductDeployment>;
  description: Maybe<Scalars["String"]["output"]>;
  enrichedProfile: Scalars["Boolean"]["output"];
  featuredAt: Maybe<Scalars["DateTime"]["output"]>;
  freeTrial: Maybe<IProductFreeTrial>;
  governments: Maybe<IGovernments>;
  governmentsUsingCount: Maybe<Scalars["Int"]["output"]>;
  highlights: Array<Scalars["String"]["output"]>;
  humanReadableReleasedYear: Maybe<Scalars["String"]["output"]>;
  inViewerStack: Maybe<Scalars["Boolean"]["output"]>;
  integrations: Maybe<Array<IProduct>>;
  isDisruptor: Maybe<Scalars["Boolean"]["output"]>;
  languagesOffered: Maybe<Scalars["String"]["output"]>;
  link: Maybe<Scalars["String"]["output"]>;
  logo: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  newsworthy: Array<INewsworthyItem>;
  openSource: Maybe<IProductOpenSource>;
  outsideIntegrations: Maybe<Array<IOutsideProduct>>;
  ownerless: Maybe<Scalars["Boolean"]["output"]>;
  pricingPage: Maybe<Scalars["URL"]["output"]>;
  projects: Array<IProject>;
  projectsCount: Scalars["Int"]["output"];
  projectsUsingCount: Maybe<Scalars["Int"]["output"]>;
  releasedYear: Maybe<Scalars["String"]["output"]>;
  releasedYearTimeAgo: Maybe<Scalars["String"]["output"]>;
  resources: Maybe<Array<IFlatResource>>;
  screenshots: Maybe<Array<IImage>>;
  siblings: Maybe<Array<IProduct>>;
  slug: Scalars["String"]["output"];
  socialMedia: Maybe<IProductSocialMediaLinks>;
  solutions: Array<ISolution>;
  specialDesignations: Maybe<Scalars["String"]["output"]>;
  status: Maybe<IProductStatus>;
  stories: Maybe<Array<IStory>>;
  storiesCount: Scalars["Int"]["output"];
  tags: Array<ITag>;
  thumbnail: Maybe<Scalars["String"]["output"]>;
  tier: Scalars["Int"]["output"];
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  upvotesCount: Scalars["Int"]["output"];
  user: Maybe<IVendorUser>;
  videos: Maybe<Array<Scalars["String"]["output"]>>;
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
};

export type IProductCompanyArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IProductGovernmentsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IProductThumbnailArgs = {
  height: InputMaybe<Scalars["Int"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export type IProductDeployment =
  | IAppStoreProductDeployment
  | IDesktopProductDeployment
  | IPlayStoreProductDeployment
  | IWebProductDeployment;

export type IProductDeploymentInput = {
  linkHref: InputMaybe<Scalars["String"]["input"]>;
  mobileResponsive: InputMaybe<Scalars["Boolean"]["input"]>;
  platforms: InputMaybe<Array<Scalars["String"]["input"]>>;
  supportedBrowsers: InputMaybe<Array<Scalars["String"]["input"]>>;
  type: Scalars["String"]["input"];
};

export enum IProductFilter {
  All = "ALL",
  Archived = "ARCHIVED",
  Disruptors = "DISRUPTORS",
  Regular = "REGULAR",
  Submitted = "SUBMITTED",
  Untagged = "UNTAGGED",
}

export type IProductFreeTrial = {
  __typename: "ProductFreeTrial";
  linkHref: Scalars["URL"]["output"];
};

export type IProductInput = {
  about: InputMaybe<Scalars["String"]["input"]>;
  allowRequestTranslation: Scalars["Boolean"]["input"];
  assistiveTechnologiesCompatibility: InputMaybe<Array<IAssistiveTechnology>>;
  certifications: InputMaybe<Array<Scalars["String"]["input"]>>;
  contactPage: InputMaybe<Scalars["URL"]["input"]>;
  deployment: InputMaybe<Array<IProductDeploymentInput>>;
  description: Scalars["String"]["input"];
  freeTrial: InputMaybe<Scalars["URL"]["input"]>;
  highlights: InputMaybe<Array<Scalars["String"]["input"]>>;
  integrations: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  languagesOffered: InputMaybe<Scalars["String"]["input"]>;
  link: Scalars["String"]["input"];
  logo: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  newsworthy: InputMaybe<Array<Scalars["JSON"]["input"]>>;
  openSource: InputMaybe<Scalars["URL"]["input"]>;
  outsideIntegrations: InputMaybe<Array<IOutsideProductInput>>;
  outsideProducts: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  pricingPage: InputMaybe<Scalars["URL"]["input"]>;
  releasedYear: InputMaybe<Scalars["String"]["input"]>;
  resources: InputMaybe<Array<IResourceInput>>;
  screenshots: InputMaybe<Array<IImageInput>>;
  socialMedia: InputMaybe<IProductSocialMediaLinksInput>;
  solutions: Array<Scalars["ObjectId"]["input"]>;
  tags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  videos: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type IProductOpenSource = {
  __typename: "ProductOpenSource";
  linkHref: Scalars["String"]["output"];
};

export enum IProductSearchScope {
  Basic = "BASIC",
  Disruptor = "DISRUPTOR",
  Makers = "MAKERS",
  VendorIsDisruptor = "VENDOR_IS_DISRUPTOR",
}

export type IProductSocialMediaLinks = {
  __typename: "ProductSocialMediaLinks";
  facebook: Maybe<Scalars["URL"]["output"]>;
  instagram: Maybe<Scalars["URL"]["output"]>;
  linkedin: Maybe<Scalars["URL"]["output"]>;
  twitter: Maybe<Scalars["URL"]["output"]>;
  youtube: Maybe<Scalars["URL"]["output"]>;
};

export type IProductSocialMediaLinksInput = {
  facebook: InputMaybe<Scalars["URL"]["input"]>;
  instagram: InputMaybe<Scalars["URL"]["input"]>;
  linkedin: InputMaybe<Scalars["URL"]["input"]>;
  twitter: InputMaybe<Scalars["URL"]["input"]>;
  youtube: InputMaybe<Scalars["URL"]["input"]>;
};

export type IProductStackRequest = {
  __typename: "ProductStackRequest";
  _id: Scalars["ObjectId"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  government: IGovernment;
  inviter: IUser;
  possibleGovernments: Array<IGovernment>;
  product: IProduct;
  respondedBy: Maybe<IUser>;
  status: IProductStackRequestStatus;
  vendor: ICompany;
};

export enum IProductStackRequestStatus {
  Accepted = "ACCEPTED",
  Canceled = "CANCELED",
  Declined = "DECLINED",
  Pending = "PENDING",
}

export enum IProductStatus {
  Approved = "APPROVED",
  Submitted = "SUBMITTED",
}

export enum IProductStatusFilter {
  All = "ALL",
  Approved = "APPROVED",
  Submitted = "SUBMITTED",
}

export type IProducts = {
  __typename: "Products";
  items: Maybe<Array<IProduct>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IProductsAboutPageSection = {
  __typename: "ProductsAboutPageSection";
  products: Array<IProduct>;
};

export type IProductsCount = {
  __typename: "ProductsCount";
  allCount: Maybe<Scalars["Int"]["output"]>;
  archivedCount: Maybe<Scalars["Int"]["output"]>;
  disruptorsCount: Maybe<Scalars["Int"]["output"]>;
  submittedCount: Maybe<Scalars["Int"]["output"]>;
  untaggedCount: Maybe<Scalars["Int"]["output"]>;
};

export enum IProfileCoverTarget {
  Company = "COMPANY",
  Government = "GOVERNMENT",
  User = "USER",
}

export type IProject = {
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  attachments: Array<IProjectAttachmentItem>;
  audience: Scalars["String"]["output"];
  author: Maybe<IUser>;
  awards: Array<ITag>;
  collaborators: Array<IUser>;
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  countryCode: Maybe<Scalars["String"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  groups: Array<IGroup>;
  icon: Maybe<Scalars["String"]["output"]>;
  itemsCount: IProjectItemsCount;
  links: Array<IProjectLinkItem>;
  locations: Array<IGovernment>;
  locationsPendingVerification: Array<IGovernment>;
  moreFromGovernment: Array<IGovernmentProject>;
  newsworthy: Array<IProjectNewsworthyItem>;
  outcome: Maybe<Scalars["String"]["output"]>;
  outcomeStatement: Maybe<Scalars["String"]["output"]>;
  outsideProducts: Array<IOutsideProduct>;
  products: Array<IProduct>;
  relatedProjects: Array<IProject>;
  slug: Scalars["String"]["output"];
  status: Maybe<Scalars["String"]["output"]>;
  subtitle: Maybe<Scalars["String"]["output"]>;
  tags: Array<ITag>;
  title: Scalars["String"]["output"];
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  upvotesCount: Scalars["Int"]["output"];
  vendors: Array<ICompany>;
  verified: Scalars["Boolean"]["output"];
  verifiedBy: Maybe<IUser>;
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerCanInviteCollaborators: Scalars["Boolean"]["output"];
  viewerCanRead: Scalars["Boolean"]["output"];
  viewerCanRemoveCollaborators: Scalars["Boolean"]["output"];
  viewerCanView: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
};

export type IProjectCollaboratorsArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

export type IProjectDescriptionArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IProjectNewsworthyArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IProjectSubtitleArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IProjectTitleArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IProjectAttachmentItem = {
  __typename: "ProjectAttachmentItem";
  addedAt: Maybe<Scalars["Float"]["output"]>;
  mimeType: Maybe<Scalars["String"]["output"]>;
  size: Maybe<Scalars["Float"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export enum IProjectAudience {
  Community = "COMMUNITY",
  Private = "PRIVATE",
  Public = "PUBLIC",
}

export type IProjectGovernmentVerificationRequest = IGovernmentVerificationRequest & {
  __typename: "ProjectGovernmentVerificationRequest";
  _id: Scalars["ObjectId"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  government: IGovernment;
  project: IProject;
  respondedAt: Maybe<Scalars["DateTime"]["output"]>;
  respondedBy: Maybe<IUser>;
  status: IGovernmentVerificationRequestStatus;
};

export type IProjectInput = {
  attachments: Array<Scalars["JSON"]["input"]>;
  audience: IProjectAudience;
  awards: Array<Scalars["ObjectId"]["input"]>;
  description: Scalars["String"]["input"];
  groups: Array<Scalars["ObjectId"]["input"]>;
  links: Array<Scalars["JSON"]["input"]>;
  locations: Array<Scalars["ObjectId"]["input"]>;
  newsworthy: Array<Scalars["JSON"]["input"]>;
  outcome: InputMaybe<Scalars["String"]["input"]>;
  outcomeStatement: InputMaybe<Scalars["String"]["input"]>;
  outsideProducts: Array<IOutsideProductInput>;
  products: Array<Scalars["JSON"]["input"]>;
  status: InputMaybe<Scalars["String"]["input"]>;
  subtitle: InputMaybe<Scalars["String"]["input"]>;
  tags: Array<Scalars["ObjectId"]["input"]>;
  title: Scalars["String"]["input"];
  vendors: Array<Scalars["JSON"]["input"]>;
};

export type IProjectItemsCount = {
  __typename: "ProjectItemsCount";
  attachments: Scalars["Int"]["output"];
  links: Scalars["Int"]["output"];
  locations: Scalars["Int"]["output"];
  newsworthy: Scalars["Int"]["output"];
  outsideProducts: Scalars["Int"]["output"];
  products: Scalars["Int"]["output"];
  vendors: Scalars["Int"]["output"];
};

export type IProjectLinkItem = {
  __typename: "ProjectLinkItem";
  addedAt: Maybe<Scalars["Float"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  displayTitle: Maybe<Scalars["String"]["output"]>;
  favicon: Maybe<Scalars["String"]["output"]>;
  siteName: Maybe<Scalars["String"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type IProjectNewsworthyItem = {
  __typename: "ProjectNewsworthyItem";
  addedAt: Maybe<Scalars["Float"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  favicon: Maybe<Scalars["String"]["output"]>;
  siteName: Maybe<Scalars["String"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export enum IProjectType {
  GovernmentProject = "GOVERNMENT_PROJECT",
  GroupProject = "GROUP_PROJECT",
  VendorProject = "VENDOR_PROJECT",
}

export type IProjects = {
  __typename: "Projects";
  items: Maybe<Array<IProject>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IProjectsAboutPageSection = {
  __typename: "ProjectsAboutPageSection";
  projects: Array<IProject>;
};

export type IProjectsCount = {
  __typename: "ProjectsCount";
  allCount: Scalars["Int"]["output"];
  archivedCount: Scalars["Int"]["output"];
  governmentProjectsCount: Scalars["Int"]["output"];
  groupProjectsCount: Scalars["Int"]["output"];
  userCreatedCount: Scalars["Int"]["output"];
  vendorProjectsCount: Scalars["Int"]["output"];
};

export type IQuery = {
  __typename: "Query";
  aboutPage: Maybe<IAboutPage>;
  activeProductsCount: Scalars["Int"]["output"];
  allAboutPageConfigs: Array<IAboutPageConfig>;
  allCollectionSponsoringSalesCounts: ICollectionSponsoringSaleCounts;
  allGovernmentVerificationRequests: Maybe<IGovernmentVerificationRequests>;
  allGovernments: Maybe<IGovernments>;
  allGroupRequests: Array<IGroupRequest>;
  allLandingPageConfigs: Maybe<ILandingPageConfigs>;
  allPlans: Array<IPlan>;
  allPosts: Array<IPost>;
  allProductStackRequests: Array<IProductStackRequest>;
  allProducts: Maybe<IProducts>;
  allReports: Maybe<IReports>;
  /** If `filterByStatus` is not specified, then only SUBMITTED and APPROVED solutions will be returned. */
  allSolutions: Array<ISolution>;
  allSponsorships: Maybe<ISponsorships>;
  allStories: Maybe<IStories>;
  allUsers: Maybe<IUsers>;
  allVendorCredits: Array<IVendorCredit>;
  allVendors: Maybe<IVendors>;
  autoCompleteAvailableGovernments: Array<IGovernmentTuple>;
  autoCompleteCollections: Array<ICollection>;
  autoCompleteGovernments: Array<IGovernment>;
  autoCompleteGroups: Array<IGroup>;
  autoCompletePaidOrDisruptorVendors: Array<ICompany>;
  autoCompleteProducts: Array<IProduct>;
  autoCompleteProjects: Array<IProject>;
  autoCompleteStories: Array<IStory>;
  autoCompleteUsers: Array<IUser>;
  autoCompleteVendors: Array<ICompany>;
  availablePlans: Array<IPlan>;
  availableStatesWithCountries: Array<ICountryStateTuple>;
  buildNewsletterCampaignData: Maybe<INewsletterCampaignData>;
  cities: Maybe<Array<ICity>>;
  collectionBySlug: Maybe<ICollection>;
  collectionsCounters: ICollectionsCounters;
  comments: Maybe<IComments>;
  company: Maybe<ICompany>;
  connect: IConnect;
  duplicatedUsers: IDuplicatedUsers;
  externalLinks: Maybe<IExternalLinks>;
  getAboutPageById: Maybe<IAboutPageConfig>;
  getActiveAboutPageConfig: IAboutPageConfig;
  getActiveLandingPageConfig: Maybe<ILandingPageConfig>;
  getAllTimezones: Maybe<ICountryTimezones>;
  getDepartmentRelatedTags: Array<ITag>;
  getDynamicConfigs: Array<IDynamicConfig>;
  getExternalLinkById: Maybe<IExternalLink>;
  getIsOnboardingActive: Scalars["Boolean"]["output"];
  getLandingPageEventById: Maybe<ILandingPageEvent>;
  getMissingTimezones: Maybe<Array<Scalars["String"]["output"]>>;
  getNewProjects: Maybe<IProjects>;
  getNewsletterCampaign: Maybe<INewsletterCampaign>;
  getNewsletterSettings: INewsletterSettings;
  getPlanById: Maybe<IPlan>;
  getTimezoneByCountryCode: Maybe<ICountryTimezone>;
  getUpcomingEvents: Array<ILandingPageEvent>;
  globalSettings: IGlobalSettings;
  government: Maybe<IGovernment>;
  governmentById: Maybe<IGovernment>;
  /** Is for retrieving a breakdown of the number of Governments by Country. */
  governmentCountriesBreakdown: Array<IGovernmentCountriesBreakdownItem>;
  governmentTypes: Array<Scalars["String"]["output"]>;
  governmentsCount: Maybe<IGovernmentsCount>;
  govlaunchStatsCount: IGovlaunchStatsCountData;
  groupBySlug: Maybe<IGroup>;
  groups: Maybe<IGroups>;
  groupsCount: Maybe<IGroupsCount>;
  images: Maybe<IImages>;
  imagesCount: Maybe<IImagesCount>;
  innovationProjectsCount: Scalars["Int"]["output"];
  isTranslationEnabled: Maybe<Scalars["Boolean"]["output"]>;
  landingPageConfig: Maybe<ILandingPageConfig>;
  landingPageEvents: Maybe<ILandingPageEvents>;
  listAllCollectionSponsoringSales: Array<ICollectionSponsoringSale>;
  listAllCollections: ICollectionsPagination;
  listAllTags: Array<ITag>;
  listNewsletterCampaigns: Array<INewsletterCampaign>;
  listOnboardings: Maybe<IOnboardings>;
  listTagsBySlugs: Array<ITag>;
  newsletterReceivers: Maybe<IUsers>;
  onboarding: Maybe<IOnboarding>;
  onboardingProcessStatusCounts: IOnboardingProcessStatusCounts;
  outsideProducts: Maybe<IOutsideProducts>;
  outsideProductsCount: Maybe<IOutsideProductsCount>;
  ping: Maybe<Scalars["String"]["output"]>;
  plan: IPlan;
  plans: Array<IPlan>;
  podcastBySlug: ISimplecast;
  podcastPage: IPodcastPageConfig;
  postById: Maybe<IPost>;
  postsByVendor: Maybe<IVendorPosts>;
  product: Maybe<IProduct>;
  products: Maybe<IProducts>;
  productsCount: Maybe<IProductsCount>;
  projectBySlug: Maybe<IProject>;
  projectsByGovernment: Maybe<IProjects>;
  projectsByIds: Maybe<IProjects>;
  projectsByVendor: Maybe<IProjects>;
  projectsCount: IProjectsCount;
  recentlyJoined: Array<IUser>;
  recentlyJoinedGovernments: Array<IGovernment>;
  reportById: Maybe<IReport>;
  reportBySlug: Maybe<IReport>;
  searchProducts: Maybe<IProducts>;
  searchProjects: Maybe<IProjects>;
  searchStories: Maybe<IStories>;
  selfie: Maybe<IUser>;
  sponsorship: Maybe<ISponsorship>;
  sponsorshipsCount: ISponsorshipsCount;
  storiesByIds: Maybe<Array<IStory>>;
  storiesByVendor: IStories;
  storiesCount: IStoriesCount;
  storyBySlug: Maybe<IStory>;
  stripePlans: Array<IStripePlan>;
  tag: Maybe<ITag>;
  tagsCount: Maybe<ITagsCount>;
  topCollections: Array<ICollection>;
  topInnovatorGovernments: Array<IGovernment>;
  trendingCollections: Array<ICollection>;
  trendingGovernments: Array<IGovernment>;
  user: Maybe<IUser>;
  usersCount: IUsersCount;
  vendorsCount: Maybe<IVendorsCount>;
};

export type IQueryAllGovernmentVerificationRequestsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filterByGovernment: InputMaybe<Scalars["ObjectId"]["input"]>;
  filterByStatus: InputMaybe<IGovernmentVerificationRequestStatus>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: InputMaybe<Scalars["String"]["input"]>;
  searchTarget: InputMaybe<IGovernmentVerificationRequestSearchTarget>;
  sortBy?: InputMaybe<IGovernmentVerificationRequestSortBy>;
  sortDirection?: InputMaybe<IGovernmentVerificationRequestSortByDirection>;
};

export type IQueryAllGovernmentsArgs = {
  country: InputMaybe<Scalars["String"]["input"]>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filter: InputMaybe<Scalars["String"]["input"]>;
  hasOwner: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sortBy: InputMaybe<Scalars["String"]["input"]>;
  state: InputMaybe<Array<Scalars["String"]["input"]>>;
  tags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  type: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type IQueryAllLandingPageConfigsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryAllProductsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<IProductFilter>;
  inTiers: InputMaybe<Array<Scalars["Int"]["input"]>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort: InputMaybe<Scalars["String"]["input"]>;
  tags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
};

export type IQueryAllReportsArgs = {
  filter: InputMaybe<Scalars["String"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IQueryAllSolutionsArgs = {
  filterByStatus: InputMaybe<ISolutionStatus>;
  searchText: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryAllSponsorshipsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<IAllSponsorshipsFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  multiSearch: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sortBy: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryAllStoriesArgs = {
  audience: InputMaybe<IStoryAudience>;
  country: InputMaybe<Scalars["String"]["input"]>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  featured: InputMaybe<Scalars["Boolean"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort: InputMaybe<Scalars["String"]["input"]>;
  status: InputMaybe<IStoryStatus>;
  tab: InputMaybe<Scalars["String"]["input"]>;
  tags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
};

export type IQueryAllUsersArgs = {
  company: InputMaybe<Scalars["ObjectId"]["input"]>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filter: InputMaybe<Scalars["String"]["input"]>;
  government: InputMaybe<Scalars["ObjectId"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  plan: InputMaybe<Scalars["String"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sortBy: InputMaybe<Scalars["String"]["input"]>;
  tags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
};

export type IQueryAllVendorsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filter: IAllVendorsFilterInput;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sortBy: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryAutoCompleteAvailableGovernmentsArgs = {
  country: Scalars["String"]["input"];
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: Scalars["String"]["input"];
  state: Scalars["String"]["input"];
};

export type IQueryAutoCompleteCollectionsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryAutoCompleteGovernmentsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  scopes: Array<IGovernmentSearchScope>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryAutoCompleteGroupsArgs = {
  groupKinds: InputMaybe<Array<Scalars["String"]["input"]>>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryAutoCompletePaidOrDisruptorVendorsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryAutoCompleteProductsArgs = {
  filterByVendor: InputMaybe<Scalars["ObjectId"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  scopes: Array<IProductSearchScope>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryAutoCompleteProjectsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryAutoCompleteStoriesArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryAutoCompleteUsersArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  scopes: Array<IUserSearchScope>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryAutoCompleteVendorsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  scopes: Array<IVendorSearchScope>;
  searchQuery: Scalars["String"]["input"];
};

export type IQueryBuildNewsletterCampaignDataArgs = {
  campaignId: Scalars["ObjectId"]["input"];
};

export type IQueryCitiesArgs = {
  state: Scalars["String"]["input"];
};

export type IQueryCollectionBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type IQueryCommentsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
  targetId: Scalars["ObjectId"]["input"];
  targetType: ICommentTargetType;
};

export type IQueryCompanyArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
  slug: Scalars["String"]["input"];
};

export type IQueryConnectArgs = {
  beforeThisId: InputMaybe<Scalars["ObjectId"]["input"]>;
  excludeUser: InputMaybe<Scalars["ObjectId"]["input"]>;
  limit?: Scalars["Int"]["input"];
  targetId: InputMaybe<Scalars["ObjectId"]["input"]>;
  targetType: InputMaybe<IConnectTargetType>;
};

export type IQueryDuplicatedUsersArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryExternalLinksArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryGetAboutPageByIdArgs = {
  configId: Scalars["ObjectId"]["input"];
};

export type IQueryGetActiveAboutPageConfigArgs = {
  configId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IQueryGetActiveLandingPageConfigArgs = {
  id: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IQueryGetAllTimezonesArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filters: IGetAllTimezonesInput;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryGetDepartmentRelatedTagsArgs = {
  departmentId: Scalars["ObjectId"]["input"];
};

export type IQueryGetExternalLinkByIdArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IQueryGetLandingPageEventByIdArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IQueryGetNewProjectsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryGetNewsletterCampaignArgs = {
  campaignId: Scalars["ObjectId"]["input"];
};

export type IQueryGetPlanByIdArgs = {
  planId: Scalars["ObjectId"]["input"];
};

export type IQueryGetTimezoneByCountryCodeArgs = {
  countryCode: Scalars["String"]["input"];
};

export type IQueryGetUpcomingEventsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryGovernmentArgs = {
  slug: Scalars["String"]["input"];
};

export type IQueryGovernmentByIdArgs = {
  governmentId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type IQueryGovernmentsCountArgs = {
  filterByCountry: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryGovlaunchStatsCountArgs = {
  settings: IGovlaunchStatsCountInput;
};

export type IQueryGroupBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type IQueryGroupsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<IGroupsFilter>;
  filterByKind: InputMaybe<IGroupKind>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort: InputMaybe<Scalars["String"]["input"]>;
  tags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
};

export type IQueryImagesArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filter: IImagesFilterInput;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sortBy: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryIsTranslationEnabledArgs = {
  slug: Scalars["String"]["input"];
};

export type IQueryLandingPageConfigArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IQueryLandingPageEventsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort: InputMaybe<IFieldOrderSortInput>;
};

export type IQueryListAllCollectionSponsoringSalesArgs = {
  description: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryListAllCollectionsArgs = {
  cursor: InputMaybe<Scalars["String"]["input"]>;
  filterByFeatured?: InputMaybe<ICollectionFeaturedStatus>;
  filterByPackaging: InputMaybe<ICollectionPackaging>;
  filterByPublishedStatus?: InputMaybe<ICollectionPublishedStatus>;
  filterBySponsoring: InputMaybe<ICollectionSponsoring>;
  filterByStatus?: InputMaybe<ICollectionStatus>;
  filterByViewerBookmarkStatus: InputMaybe<ICollectionBookmarkStatus>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  searchQuery: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryListAllTagsArgs = {
  archivedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  filterByTagType: InputMaybe<ITagType>;
  search: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryListOnboardingsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filterByProcessStatus: IProcessStatusType;
  search: InputMaybe<Scalars["String"]["input"]>;
  sortBy: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryListTagsBySlugsArgs = {
  slugs: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type IQueryNewsletterReceiversArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  mode?: InputMaybe<IGovlaunchEnvironment>;
  search: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryOnboardingArgs = {
  userId: Scalars["ObjectId"]["input"];
};

export type IQueryOutsideProductsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort: InputMaybe<Scalars["String"]["input"]>;
  status: InputMaybe<IOutsideProductStatus>;
};

export type IQueryPlanArgs = {
  name: Scalars["String"]["input"];
};

export type IQueryPodcastBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type IQueryPostByIdArgs = {
  id: Scalars["ObjectId"]["input"];
};

export type IQueryPostsByVendorArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort: InputMaybe<Scalars["String"]["input"]>;
  vendorId: Scalars["ObjectId"]["input"];
};

export type IQueryProductArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
  slug: Scalars["String"]["input"];
};

export type IQueryProductsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filter?: InputMaybe<IProductFilter>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  search: InputMaybe<Scalars["String"]["input"]>;
  sort: InputMaybe<Scalars["String"]["input"]>;
  tags: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
};

export type IQueryProjectBySlugArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
  slug: Scalars["String"]["input"];
};

export type IQueryProjectsByGovernmentArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  slug: Scalars["String"]["input"];
};

export type IQueryProjectsByIdsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  ids: Array<Scalars["ObjectId"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryProjectsByVendorArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  mentionedOnly: InputMaybe<Scalars["Boolean"]["input"]>;
  slug: Scalars["String"]["input"];
  sort: InputMaybe<IFieldOrderSortInput>;
  verification: InputMaybe<IVerificationInput>;
};

export type IQueryReportByIdArgs = {
  id: Scalars["String"]["input"];
};

export type IQueryReportBySlugArgs = {
  slug: Scalars["String"]["input"];
};

export type IQuerySearchProductsArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  name: InputMaybe<Scalars["String"]["input"]>;
  tags: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type IQuerySearchProjectsArgs = {
  archivedOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  audience: InputMaybe<Scalars["String"]["input"]>;
  country: InputMaybe<Scalars["String"]["input"]>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  filterByType: InputMaybe<IProjectType>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort: InputMaybe<IFieldOrderSortInput>;
  state: InputMaybe<Scalars["String"]["input"]>;
  status: InputMaybe<Array<Scalars["String"]["input"]>>;
  tags: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: InputMaybe<Scalars["String"]["input"]>;
  userCreated?: InputMaybe<Scalars["Boolean"]["input"]>;
  verified: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type IQuerySearchStoriesArgs = {
  country: InputMaybe<Scalars["String"]["input"]>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  state: InputMaybe<Scalars["String"]["input"]>;
  tags: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: InputMaybe<Scalars["String"]["input"]>;
};

export type IQuerySelfieArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

export type IQuerySponsorshipArgs = {
  slug: Scalars["String"]["input"];
};

export type IQueryStoriesByIdsArgs = {
  ids: Array<Scalars["ObjectId"]["input"]>;
};

export type IQueryStoriesByVendorArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
  vendorId: Scalars["ObjectId"]["input"];
};

export type IQueryStoryBySlugArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
  slug: Scalars["String"]["input"];
  token: InputMaybe<Scalars["String"]["input"]>;
};

export type IQueryTagArgs = {
  slug: Scalars["String"]["input"];
};

export type IQueryTopCollectionsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryTopInnovatorGovernmentsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryTrendingCollectionsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryTrendingGovernmentsArgs = {
  limit?: InputMaybe<Scalars["Int"]["input"]>;
};

export type IQueryUserArgs = {
  slug: Scalars["String"]["input"];
};

export type IRecurringCollectionSponsoringSale = ICollectionSponsoringSale & {
  __typename: "RecurringCollectionSponsoringSale";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  cancelsAt: Maybe<Scalars["Date"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  description: Scalars["String"]["output"];
  includedCollections: Array<ICollection>;
  isActive: Scalars["Boolean"]["output"];
  paymentSchedule: ICollectionSponsoringPaymentSchedule;
  price: Scalars["Int"]["output"];
  renewsAt: Maybe<Scalars["Date"]["output"]>;
  sponsorshipLevel: ICollectionSponsoringSponsorshipLevel;
  stripeState: ICollectionSponsoringStripeState;
  type: ICollectionSponsoringType;
  updatedAt: Scalars["DateTime"]["output"];
  vendor: ICompany;
};

export type IReport = {
  __typename: "Report";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  cover: Maybe<Scalars["String"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  details: Maybe<Scalars["JSON"]["output"]>;
  featured: Maybe<Scalars["Boolean"]["output"]>;
  governments: Maybe<Array<IGovernment>>;
  images: Maybe<Array<Scalars["String"]["output"]>>;
  locations: Maybe<Array<Scalars["String"]["output"]>>;
  slug: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  unpublishedAt: Maybe<Scalars["DateTime"]["output"]>;
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  viewerDidComment: Scalars["Boolean"]["output"];
};

export type IReportInput = {
  description: InputMaybe<Scalars["String"]["input"]>;
  details: InputMaybe<Scalars["JSON"]["input"]>;
  governments: InputMaybe<Array<Scalars["String"]["input"]>>;
  images: InputMaybe<Array<Scalars["String"]["input"]>>;
  locations: InputMaybe<Array<Scalars["String"]["input"]>>;
  title: InputMaybe<Scalars["String"]["input"]>;
};

export type IReports = {
  __typename: "Reports";
  items: Maybe<Array<IReport>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IReportsAboutPageSection = {
  __typename: "ReportsAboutPageSection";
  reports: Array<IReport>;
};

export type IRepositionState = {
  __typename: "RepositionState";
  original: Maybe<ICoverImageDimensions>;
  proportional: Maybe<ICoverImageDimensions>;
  rect: Maybe<ICoverImageDimensions>;
  x: Maybe<Scalars["Float"]["output"]>;
  y: Maybe<Scalars["Float"]["output"]>;
};

export type IResourceInput = {
  addedAt: InputMaybe<Scalars["DateTime"]["input"]>;
  body: InputMaybe<Scalars["String"]["input"]>;
  filename: InputMaybe<Scalars["String"]["input"]>;
  title: Scalars["String"]["input"];
  type: Scalars["String"]["input"];
  url: InputMaybe<Scalars["String"]["input"]>;
};

export type IScheduledToCancelSubscription = {
  __typename: "ScheduledToCancelSubscription";
  _id: Scalars["ObjectId"]["output"];
  freeSubscription: Maybe<Scalars["Boolean"]["output"]>;
  lastCharge: Maybe<ICharge>;
  pausePaymentCollection: Maybe<Scalars["Boolean"]["output"]>;
  requestedCancellationAt: Scalars["DateTime"]["output"];
  stripeStatus: Maybe<Scalars["String"]["output"]>;
  trialPeriod: Maybe<Scalars["Int"]["output"]>;
  willCancelAt: Scalars["DateTime"]["output"];
};

export type ISideContent = ICarouselSideContent | ITextSideContent;

export type ISideContentInput = {
  buttonBackgroundColor: InputMaybe<Scalars["String"]["input"]>;
  buttonFontColor: InputMaybe<Scalars["String"]["input"]>;
  buttonHref: InputMaybe<Scalars["String"]["input"]>;
  buttonText: InputMaybe<Scalars["String"]["input"]>;
  height: InputMaybe<Scalars["Int"]["input"]>;
  iconDescription: InputMaybe<Scalars["String"]["input"]>;
  iconSrc: InputMaybe<Scalars["String"]["input"]>;
  images: Array<ICarouselImageInput>;
  text: InputMaybe<Scalars["String"]["input"]>;
  textFontColor: InputMaybe<Scalars["String"]["input"]>;
  textHref: InputMaybe<Scalars["String"]["input"]>;
  textHrefHoverColor: InputMaybe<Scalars["String"]["input"]>;
  title: InputMaybe<Scalars["String"]["input"]>;
  titleFontColor: InputMaybe<Scalars["String"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export type ISignInAttempt = {
  __typename: "SignInAttempt";
  ip: Maybe<Scalars["String"]["output"]>;
  lookup: Maybe<Scalars["JSON"]["output"]>;
  outcome: Maybe<Scalars["String"]["output"]>;
  registeredAt: Maybe<Scalars["DateTime"]["output"]>;
  userAgent: Maybe<Scalars["JSON"]["output"]>;
  whitelisted: Maybe<Scalars["Boolean"]["output"]>;
};

export type ISignInResult = {
  __typename: "SignInResult";
  tokens: Maybe<ITokens>;
  user: Maybe<IUser>;
};

export type ISignedInUser = {
  __typename: "SignedInUser";
  _id: Scalars["String"]["output"];
  lastSeen: Maybe<Scalars["DateTime"]["output"]>;
  role: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
};

export type ISimplecast = {
  __typename: "Simplecast";
  description: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  title: Scalars["String"]["output"];
};

export type ISolution = {
  __typename: "Solution";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Scalars["DateTime"]["output"];
  name: Scalars["String"]["output"];
  originProduct: Maybe<IProduct>;
  slug: Scalars["String"]["output"];
  status: ISolutionStatus;
  submittedBy: IUser;
  updatedAt: Scalars["DateTime"]["output"];
};

export enum ISolutionStatus {
  Approved = "APPROVED",
  Archived = "ARCHIVED",
  Submitted = "SUBMITTED",
}

export enum ISortType {
  Newest = "NEWEST",
  Oldest = "OLDEST",
  Top = "TOP",
}

export type ISponsorship = {
  __typename: "Sponsorship";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  link: Maybe<Scalars["String"]["output"]>;
  logo: Maybe<Scalars["String"]["output"]>;
  modifiedAt: Maybe<Scalars["DateTime"]["output"]>;
  name: Scalars["String"]["output"];
  slug: Scalars["String"]["output"];
  vendorsCount: Maybe<Scalars["Int"]["output"]>;
};

export type ISponsorshipInput = {
  link: InputMaybe<Scalars["String"]["input"]>;
  logo: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
};

export type ISponsorships = {
  __typename: "Sponsorships";
  items: Array<ISponsorship>;
  pageInfo: Maybe<IPageInfo>;
};

export type ISponsorshipsCount = {
  __typename: "SponsorshipsCount";
  allCount: Maybe<Scalars["Int"]["output"]>;
  archivedCount: Maybe<Scalars["Int"]["output"]>;
};

export type IStatCountersBlockData = IBlockData & {
  __typename: "StatCountersBlockData";
  backgroundColor: Scalars["String"]["output"];
  countersColor: Scalars["String"]["output"];
  itemLimit: Maybe<Scalars["Int"]["output"]>;
  labelsColor: Scalars["String"]["output"];
  paddingBottom: Maybe<Scalars["Int"]["output"]>;
  paddingLeft: Maybe<Scalars["Int"]["output"]>;
  paddingRight: Maybe<Scalars["Int"]["output"]>;
  paddingTop: Maybe<Scalars["Int"]["output"]>;
  showGovernments: Scalars["Boolean"]["output"];
  showProducts: Scalars["Boolean"]["output"];
  showProjects: Scalars["Boolean"]["output"];
  showStories: Scalars["Boolean"]["output"];
  showVendors: Scalars["Boolean"]["output"];
  title: Scalars["String"]["output"];
  titleVisible: Scalars["Boolean"]["output"];
  type: IBlockLayoutType;
  widgetColor: Scalars["String"]["output"];
};

export type IStories = {
  __typename: "Stories";
  items: Maybe<Array<IStory>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IStoriesAboutPageSection = {
  __typename: "StoriesAboutPageSection";
  stories: Array<IStory>;
};

export type IStoriesCount = {
  __typename: "StoriesCount";
  allStories: Scalars["Int"]["output"];
  archivedStories: Scalars["Int"]["output"];
};

export type IStory = {
  __typename: "Story";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  audience: Scalars["String"]["output"];
  author: Maybe<IUser>;
  awards: Array<ITag>;
  body: Maybe<Scalars["JSON"]["output"]>;
  coauthors: Maybe<Array<IUser>>;
  collaborators: Array<IUser>;
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  featured: Maybe<Scalars["Boolean"]["output"]>;
  government: Maybe<IGovernment>;
  hasPodcast: Scalars["Boolean"]["output"];
  highlights: Maybe<Array<Scalars["String"]["output"]>>;
  horizontalCover: Maybe<Scalars["String"]["output"]>;
  introduction: Maybe<Scalars["String"]["output"]>;
  lastPublishedAt: Maybe<Scalars["DateTime"]["output"]>;
  lastUpvoters: Maybe<Array<IUser>>;
  locations: Maybe<Array<IGovernment>>;
  medias: Maybe<Array<IMedia>>;
  modifiedAt: Maybe<Scalars["DateTime"]["output"]>;
  newsworthy: Array<INewsworthyItem>;
  outsideProducts: Maybe<Array<IOutsideProduct>>;
  products: Maybe<Array<IProduct>>;
  /** @deprecated Not used anymore */
  projectAwards: Maybe<Array<IMetadataLink>>;
  relatedStories: Maybe<Array<IStory>>;
  resources: Maybe<Array<IFlatResource>>;
  slug: Scalars["String"]["output"];
  status: Maybe<IStoryStatus>;
  tags: Array<ITag>;
  title: Scalars["String"]["output"];
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  upvotesCount: Scalars["Int"]["output"];
  vendorCoauthors: Array<ICompany>;
  verticalCover: Maybe<Scalars["String"]["output"]>;
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerCanInviteCollaborators: Scalars["Boolean"]["output"];
  viewerCanRead: Scalars["Boolean"]["output"];
  viewerCanRemoveCollaborators: Scalars["Boolean"]["output"];
  viewerCanUnpublish: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
  viewerIsCollaborator: Maybe<Scalars["Boolean"]["output"]>;
};

export type IStoryCollaboratorsArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

export enum IStoryAudience {
  All = "ALL",
  Community = "COMMUNITY",
  Public = "PUBLIC",
}

export type IStoryCoverImage = {
  __typename: "StoryCoverImage";
  type: Maybe<Scalars["String"]["output"]>;
  url: Scalars["String"]["output"];
};

export enum IStoryFilter {
  All = "ALL",
  Featured = "FEATURED",
}

export enum IStoryStatus {
  Approved = "APPROVED",
  Proposed = "PROPOSED",
  Published = "PUBLISHED",
  Unpublished = "UNPUBLISHED",
}

export type IStorybookMockDataObject =
  | ICompany
  | IGovernment
  | IGovernmentProject
  | IGovernmentUser
  | IGroup
  | IGroupProject
  | IPendingUser
  | IProduct
  | IStory
  | IVendorProject
  | IVendorUser;

export type IStripePlan = {
  __typename: "StripePlan";
  changeDetails: IChangeDetails;
  displayName: Scalars["String"]["output"];
  limits: IPlanLimits;
  name: Scalars["String"]["output"];
  planId: Scalars["String"]["output"];
  price: Scalars["Int"]["output"];
  productId: Scalars["String"]["output"];
  recurrency: IPlanRecurrency;
  tier: IPlanTier;
  upgradeToPlan: Maybe<IStripePlan>;
  viewerIsSubscribed: Scalars["Boolean"]["output"];
};

export enum ISubscriptionStatus {
  Active = "ACTIVE",
  Cancelled = "CANCELLED",
}

export type ISuggestSolutionInput = {
  name: Scalars["String"]["input"];
  /** If `originProductId` is specified, it will track it as the root source for that suggestion. */
  originProductId: InputMaybe<Scalars["ObjectId"]["input"]>;
};

export type ITag = {
  __typename: "Tag";
  _id: Scalars["ObjectId"]["output"];
  aggregations: ITagAggregations;
  createdAt: Scalars["DateTime"]["output"];
  deletedAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedBy: Maybe<IUser>;
  description: Maybe<Scalars["String"]["output"]>;
  name: Scalars["String"]["output"];
  relatedTags: Array<ITag>;
  slug: Scalars["String"]["output"];
  translations: Array<ITranslatedTag>;
  types: Array<ITagType>;
};

export type ITagAggregations = {
  __typename: "TagAggregations";
  awardsCount: Scalars["Int"]["output"];
  groupsCount: Scalars["Int"]["output"];
  mentionsCount: Scalars["Int"]["output"];
  productsCount: Scalars["Int"]["output"];
  projectsCount: Scalars["Int"]["output"];
  storiesCount: Scalars["Int"]["output"];
  usersCount: Scalars["Int"]["output"];
  vendorsCount: Scalars["Int"]["output"];
};

export type ITagTranslationInput = {
  language: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
};

export enum ITagType {
  Award = "AWARD",
  Custom = "CUSTOM",
  Department = "DEPARTMENT",
  Product = "PRODUCT",
  Project = "PROJECT",
  Story = "STORY",
}

export type ITagsCount = {
  __typename: "TagsCount";
  allCount: Scalars["Int"]["output"];
  archivedCount: Scalars["Int"]["output"];
  awardsCount: Scalars["Int"]["output"];
  customCount: Scalars["Int"]["output"];
  departmentsCount: Scalars["Int"]["output"];
  productsCount: Scalars["Int"]["output"];
  projectsCount: Scalars["Int"]["output"];
  storiesCount: Scalars["Int"]["output"];
  vendorsCount: Scalars["Int"]["output"];
};

export type ITextResource = {
  __typename: "TextResource";
  addedAt: Maybe<Scalars["DateTime"]["output"]>;
  body: Maybe<Scalars["String"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  type: Maybe<Scalars["String"]["output"]>;
};

export type ITextSideContent = {
  __typename: "TextSideContent";
  height: Maybe<Scalars["Int"]["output"]>;
  iconDescription: Maybe<Scalars["String"]["output"]>;
  iconSrc: Maybe<Scalars["String"]["output"]>;
  text: Scalars["String"]["output"];
  textFontColor: Scalars["String"]["output"];
  textHref: Maybe<Scalars["String"]["output"]>;
  textHrefHoverColor: Maybe<Scalars["String"]["output"]>;
  title: Scalars["String"]["output"];
  titleFontColor: Scalars["String"]["output"];
  type: Scalars["String"]["output"];
  width: Maybe<Scalars["Int"]["output"]>;
};

export type ITokens = {
  __typename: "Tokens";
  token: Maybe<Scalars["String"]["output"]>;
};

export type ITopFeaturedReport = {
  __typename: "TopFeaturedReport";
  report: Maybe<IReport>;
};

export type ITopFeaturedStories = {
  __typename: "TopFeaturedStories";
  stories: Array<IStory>;
};

export type ITranslatedTag = {
  __typename: "TranslatedTag";
  language: Scalars["String"]["output"];
  name: Scalars["String"]["output"];
};

export type IUpdateCollectionInput = {
  description: Scalars["String"]["input"];
  displayOptions: InputMaybe<ICollectionDisplayOptionsInput>;
  isFeatured: Scalars["Boolean"]["input"];
  name: Scalars["String"]["input"];
  sponsoring: ICollectionSponsoring;
  sponsoringProducts: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  sponsoringVendors: Array<Scalars["ObjectId"]["input"]>;
  tags: Array<Scalars["ObjectId"]["input"]>;
};

export type IUpdateGovernmentProfileInput = {
  budget: InputMaybe<Scalars["Float"]["input"]>;
  logo: InputMaybe<Scalars["URL"]["input"]>;
  population: InputMaybe<Scalars["Int"]["input"]>;
  site: InputMaybe<Scalars["URL"]["input"]>;
};

export type IUploadGovernmentInput = {
  budget: InputMaybe<Scalars["Int"]["input"]>;
  county: InputMaybe<Scalars["String"]["input"]>;
  governmentName: Scalars["String"]["input"];
  governmentType: Scalars["String"]["input"];
  population: InputMaybe<Scalars["Int"]["input"]>;
  postalCode: InputMaybe<Scalars["String"]["input"]>;
  stateAbbreviation: InputMaybe<Scalars["String"]["input"]>;
  stateName: InputMaybe<Scalars["String"]["input"]>;
};

export type IUpvote = {
  __typename: "Upvote";
  _id: Scalars["ObjectId"]["output"];
  entity: Maybe<IUser>;
  target: Maybe<IUpvoteTarget>;
  upvotedAt: Maybe<Scalars["DateTime"]["output"]>;
};

export type IUpvoteTarget =
  | IComment
  | IGovernmentPost
  | IGovernmentProject
  | IGroupPost
  | IGroupProject
  | IProduct
  | IStory
  | IVendorPost
  | IVendorProject;

export enum IUpvoteTargetType {
  Comment = "COMMENT",
  Post = "POST",
  Product = "PRODUCT",
  Project = "PROJECT",
  Report = "REPORT",
  Story = "STORY",
}

export type IUpvotes = {
  __typename: "Upvotes";
  items: Maybe<Array<IUpvote>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IUser = IGovernmentUser | IPendingUser | IVendorUser;

export type IUserAdditionalInformationInput = {
  country: InputMaybe<Scalars["String"]["input"]>;
  department: InputMaybe<Scalars["ObjectId"]["input"]>;
  interests: Array<Scalars["ObjectId"]["input"]>;
  jobTitle: Scalars["String"]["input"];
  language: InputMaybe<Scalars["String"]["input"]>;
  newsletterFrequency: InputMaybe<INewsletterFrequency>;
  notes: Scalars["String"]["input"];
  notificationEmail: InputMaybe<Scalars["String"]["input"]>;
  searchable: InputMaybe<Scalars["Boolean"]["input"]>;
  showAsAuthorOnProjects: InputMaybe<Scalars["Boolean"]["input"]>;
  socialMedia: IUserSocialMediaLinksInput;
  subscribedToCampaign: InputMaybe<Scalars["Boolean"]["input"]>;
  subscribedToNewsletter: InputMaybe<Scalars["Boolean"]["input"]>;
  timeZone: InputMaybe<Scalars["String"]["input"]>;
};

export type IUserInterface = {
  collections: Array<ICollection>;
  lastSignInProvider: Scalars["String"]["output"];
  projectsCount: Scalars["Int"]["output"];
  savedCollectionsCount: Scalars["Int"]["output"];
  savedCount: Scalars["Int"]["output"];
  savedProductsCount: Scalars["Int"]["output"];
  savedProjectsCount: Scalars["Int"]["output"];
  savedStoriesCount: Scalars["Int"]["output"];
  upvotesCount: Maybe<Scalars["Int"]["output"]>;
};

export type IUserPreferences = {
  __typename: "UserPreferences";
  showAsAuthorOnProjects: Scalars["Boolean"]["output"];
};

export type IUserPreferencesInput = {
  showAsAuthorOnProjects: Scalars["Boolean"]["input"];
};

/** Defines an interface for a standard set of fields that should be available for a User profile. */
export type IUserProfile = {
  _id: Scalars["ObjectId"]["output"];
  avatar: Maybe<Scalars["String"]["output"]>;
  country: Maybe<Scalars["String"]["output"]>;
  email: Maybe<Scalars["String"]["output"]>;
  firstName: Maybe<Scalars["String"]["output"]>;
  fullName: Maybe<Scalars["String"]["output"]>;
  intercomUserHash: Scalars["String"]["output"];
  jobTitle: Maybe<Scalars["String"]["output"]>;
  language: Maybe<Scalars["String"]["output"]>;
  lastName: Maybe<Scalars["String"]["output"]>;
  notificationEmail: Maybe<Scalars["String"]["output"]>;
  slug: Scalars["String"]["output"];
  timeZone: Maybe<Scalars["String"]["output"]>;
};

/** Defines an interface for a standard set of fields that should be available for a User profile. */
export type IUserProfileAvatarArgs = {
  height: InputMaybe<Scalars["Int"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export type IUserProfileInput = {
  country: InputMaybe<Scalars["String"]["input"]>;
  department: InputMaybe<Scalars["ObjectId"]["input"]>;
  firstName: Scalars["String"]["input"];
  interests: Array<Scalars["ObjectId"]["input"]>;
  jobTitle: InputMaybe<Scalars["String"]["input"]>;
  language: InputMaybe<Scalars["String"]["input"]>;
  lastName: Scalars["String"]["input"];
  notificationEmail: InputMaybe<Scalars["String"]["input"]>;
  preferences: IUserPreferencesInput;
  searchable: InputMaybe<Scalars["Boolean"]["input"]>;
  socialMedia: IUserSocialMediaLinksInput;
  timeZone: InputMaybe<Scalars["String"]["input"]>;
};

export type IUserProfileSubscriptionInput = {
  newsletterFrequency: InputMaybe<INewsletterFrequency>;
  subscribedToCampaign: InputMaybe<Scalars["Boolean"]["input"]>;
  subscribedToNewsletter: InputMaybe<Scalars["Boolean"]["input"]>;
  userId: Scalars["ObjectId"]["input"];
};

export enum IUserRole {
  Owner = "OWNER",
  User = "USER",
}

export enum IUserSearchScope {
  Citizen = "CITIZEN",
  Community = "COMMUNITY",
  Disruptor = "DISRUPTOR",
  Government = "GOVERNMENT",
  Innovator = "INNOVATOR",
  Pending = "PENDING",
  Vendor = "VENDOR",
}

export type IUserSharingInput = {
  posts: Scalars["Boolean"]["input"];
  projects: Scalars["Boolean"]["input"];
  resources: Scalars["Boolean"]["input"];
  stories: Scalars["Boolean"]["input"];
};

export type IUserSharingOptions = {
  __typename: "UserSharingOptions";
  posts: Scalars["Boolean"]["output"];
  projects: Scalars["Boolean"]["output"];
  resources: Scalars["Boolean"]["output"];
  stories: Scalars["Boolean"]["output"];
};

export type IUserSocialMediaLinks = {
  __typename: "UserSocialMediaLinks";
  facebook: Maybe<Scalars["URL"]["output"]>;
  instagram: Maybe<Scalars["URL"]["output"]>;
  linkedin: Maybe<Scalars["URL"]["output"]>;
  twitter: Maybe<Scalars["URL"]["output"]>;
  youtube: Maybe<Scalars["URL"]["output"]>;
};

export type IUserSocialMediaLinksInput = {
  facebook: InputMaybe<Scalars["URL"]["input"]>;
  instagram: InputMaybe<Scalars["URL"]["input"]>;
  linkedin: InputMaybe<Scalars["URL"]["input"]>;
  twitter: InputMaybe<Scalars["URL"]["input"]>;
  youtube: InputMaybe<Scalars["URL"]["input"]>;
};

export enum IUserType {
  Disruptor = "DISRUPTOR",
  Innovator = "INNOVATOR",
  Regular = "REGULAR",
}

export type IUserWithRoleInput = {
  role: IUserRole;
  userId: Scalars["ObjectId"]["input"];
};

export type IUsers = {
  __typename: "Users";
  items: Maybe<Array<IUser>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IUsersCount = {
  __typename: "UsersCount";
  blockedCount: Scalars["Int"]["output"];
  citizensCount: Scalars["Int"]["output"];
  communityUsersCount: Scalars["Int"]["output"];
  disruptorsCount: Scalars["Int"]["output"];
  governmentUsersCount: Scalars["Int"]["output"];
  innovatorsCount: Scalars["Int"]["output"];
  onboardingCount: Scalars["Int"]["output"];
  pendingUsersCount: Scalars["Int"]["output"];
  sharingCount: Scalars["Int"]["output"];
  vendorUsersCount: Scalars["Int"]["output"];
  verifiedCommunityUsersCount: Scalars["Int"]["output"];
};

export type IUsersCountOnboardingCountArgs = {
  processStatus: InputMaybe<IProcessStatusType>;
};

export type IVendorBalanceTransaction = {
  __typename: "VendorBalanceTransaction";
  amount: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  description: Maybe<Scalars["String"]["output"]>;
  endingBalance: Scalars["Int"]["output"];
  government: Maybe<IGovernment>;
  inviter: Maybe<IVendorUser>;
  type: Scalars["String"]["output"];
};

export type IVendorCredit = {
  __typename: "VendorCredit";
  amount: Scalars["Int"]["output"];
  createdAt: Scalars["Date"]["output"];
  government: IGovernment;
  vendor: ICompany;
};

export type IVendorCustomLimits = {
  __typename: "VendorCustomLimits";
  enrichedProducts: Scalars["Int"]["output"];
  groups: Scalars["Int"]["output"];
  inviteGovernments: Scalars["Boolean"]["output"];
  products: Scalars["Int"]["output"];
  searchAccess: Scalars["Boolean"]["output"];
  sharingPage: Scalars["Boolean"]["output"];
  teamMembers: Scalars["Int"]["output"];
};

export type IVendorCustomLimitsInput = {
  enrichedProducts: Scalars["Int"]["input"];
  groups: Scalars["Int"]["input"];
  inviteGovernments: Scalars["Boolean"]["input"];
  products: Scalars["Int"]["input"];
  searchAccess: Scalars["Boolean"]["input"];
  teamMembers: Scalars["Int"]["input"];
};

export type IVendorGroupRequest = IGroupRequest & {
  __typename: "VendorGroupRequest";
  _id: Scalars["ObjectId"]["output"];
  createdAt: Scalars["DateTime"]["output"];
  group: IGroup;
  inviter: IUser;
  possibleVendors: Array<ICompany>;
  respondedBy: Maybe<IUser>;
  status: IGroupRequestStatus;
  vendor: ICompany;
};

export type IVendorInput = {
  address: InputMaybe<Scalars["String"]["input"]>;
  billingName: InputMaybe<Scalars["String"]["input"]>;
  businessEmail: InputMaybe<Scalars["String"]["input"]>;
  contactPage: InputMaybe<Scalars["URL"]["input"]>;
  cover: InputMaybe<ICoverInput>;
  description: InputMaybe<Scalars["String"]["input"]>;
  headquarters: InputMaybe<Scalars["String"]["input"]>;
  highlights: Array<Scalars["String"]["input"]>;
  logo: InputMaybe<Scalars["String"]["input"]>;
  name: Scalars["String"]["input"];
  newsworthy: Array<InputMaybe<IVendorNewsworthyItemInput>>;
  numberOfEmployees: InputMaybe<Scalars["String"]["input"]>;
  resources: InputMaybe<Array<IResourceInput>>;
  site: Scalars["String"]["input"];
  slogan: InputMaybe<Scalars["String"]["input"]>;
  socialMedia: InputMaybe<IVendorSocialMediaLinksInput>;
  sponsorships: InputMaybe<Array<Scalars["ObjectId"]["input"]>>;
  yearFounded: InputMaybe<Scalars["Int"]["input"]>;
};

export type IVendorNewsworthyItem = {
  __typename: "VendorNewsworthyItem";
  description: Maybe<Scalars["String"]["output"]>;
  favicon: Maybe<Scalars["String"]["output"]>;
  siteName: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
  url: Scalars["String"]["output"];
};

export type IVendorNewsworthyItemInput = {
  description: InputMaybe<Scalars["String"]["input"]>;
  favicon: InputMaybe<Scalars["String"]["input"]>;
  siteName: Scalars["String"]["input"];
  title: Scalars["String"]["input"];
  url: Scalars["String"]["input"];
};

export type IVendorPost = IPostInterface & {
  __typename: "VendorPost";
  _id: Scalars["ObjectId"]["output"];
  attachments: Array<IPostAttachment>;
  audience: Scalars["String"]["output"];
  author: IUser;
  body: Scalars["String"]["output"];
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedAt: Maybe<Scalars["DateTime"]["output"]>;
  deletedBy: Maybe<IUser>;
  featuredAt: Maybe<Scalars["DateTime"]["output"]>;
  links: Array<IPostLink>;
  upvotesCount: Scalars["Int"]["output"];
  vendor: ICompany;
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
};

export type IVendorPosts = {
  __typename: "VendorPosts";
  items: Maybe<Array<IVendorPost>>;
  pageInfo: Maybe<IPageInfo>;
};

export type IVendorProject = IProject & {
  __typename: "VendorProject";
  _id: Scalars["ObjectId"]["output"];
  archivedAt: Maybe<Scalars["DateTime"]["output"]>;
  archivedBy: Maybe<IUser>;
  attachments: Array<IProjectAttachmentItem>;
  audience: Scalars["String"]["output"];
  author: Maybe<IUser>;
  awards: Array<ITag>;
  collaborators: Array<IUser>;
  commentsCount: Maybe<Scalars["Int"]["output"]>;
  countryCode: Maybe<Scalars["String"]["output"]>;
  createdAt: Maybe<Scalars["DateTime"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  groups: Array<IGroup>;
  icon: Maybe<Scalars["String"]["output"]>;
  itemsCount: IProjectItemsCount;
  links: Array<IProjectLinkItem>;
  locations: Array<IGovernment>;
  locationsPendingVerification: Array<IGovernment>;
  moreFromGovernment: Array<IGovernmentProject>;
  moreFromVendor: Array<IVendorProject>;
  newsworthy: Array<IProjectNewsworthyItem>;
  outcome: Maybe<Scalars["String"]["output"]>;
  outcomeStatement: Maybe<Scalars["String"]["output"]>;
  outsideProducts: Array<IOutsideProduct>;
  products: Array<IProduct>;
  relatedProjects: Array<IProject>;
  slug: Scalars["String"]["output"];
  status: Maybe<Scalars["String"]["output"]>;
  subtitle: Maybe<Scalars["String"]["output"]>;
  tags: Array<ITag>;
  title: Scalars["String"]["output"];
  updatedAt: Maybe<Scalars["DateTime"]["output"]>;
  upvotesCount: Scalars["Int"]["output"];
  vendor: ICompany;
  vendors: Array<ICompany>;
  verified: Scalars["Boolean"]["output"];
  verifiedBy: Maybe<IUser>;
  viewerCanComment: Scalars["Boolean"]["output"];
  viewerCanDelete: Scalars["Boolean"]["output"];
  viewerCanEdit: Scalars["Boolean"]["output"];
  viewerCanInviteCollaborators: Scalars["Boolean"]["output"];
  viewerCanRead: Scalars["Boolean"]["output"];
  viewerCanRemoveCollaborators: Scalars["Boolean"]["output"];
  viewerCanView: Scalars["Boolean"]["output"];
  viewerDidBookmark: Scalars["Boolean"]["output"];
  viewerDidComment: Scalars["Boolean"]["output"];
  viewerDidUpvote: Scalars["Boolean"]["output"];
  viewerIsAuthor: Scalars["Boolean"]["output"];
};

export type IVendorProjectCollaboratorsArgs = {
  token: InputMaybe<Scalars["String"]["input"]>;
};

export type IVendorProjectDescriptionArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IVendorProjectNewsworthyArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IVendorProjectSubtitleArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export type IVendorProjectTitleArgs = {
  language: InputMaybe<Scalars["String"]["input"]>;
};

export enum IVendorSearchScope {
  Disruptor = "DISRUPTOR",
}

export type IVendorSocialMediaLinks = {
  __typename: "VendorSocialMediaLinks";
  facebook: Maybe<Scalars["URL"]["output"]>;
  instagram: Maybe<Scalars["URL"]["output"]>;
  linkedin: Maybe<Scalars["URL"]["output"]>;
  twitter: Maybe<Scalars["URL"]["output"]>;
  youtube: Maybe<Scalars["URL"]["output"]>;
};

export type IVendorSocialMediaLinksInput = {
  facebook: InputMaybe<Scalars["URL"]["input"]>;
  instagram: InputMaybe<Scalars["URL"]["input"]>;
  linkedin: InputMaybe<Scalars["URL"]["input"]>;
  twitter: InputMaybe<Scalars["URL"]["input"]>;
  youtube: InputMaybe<Scalars["URL"]["input"]>;
};

export type IVendorSubscription = IActiveSubscription | IOverdueSubscription | IScheduledToCancelSubscription;

export type IVendorUser = IUserInterface &
  IUserProfile & {
    __typename: "VendorUser";
    _id: Scalars["ObjectId"]["output"];
    algoliaKeys: Maybe<IAlgoliaKeys>;
    avatar: Maybe<Scalars["String"]["output"]>;
    bannedAt: Maybe<Scalars["DateTime"]["output"]>;
    bookmarks: Array<IBookmarkTarget>;
    canSeeActiveGovernments: Scalars["Boolean"]["output"];
    collections: Array<ICollection>;
    company: Maybe<ICompany>;
    country: Maybe<Scalars["String"]["output"]>;
    cover: Maybe<ICover>;
    createdAt: Maybe<Scalars["DateTime"]["output"]>;
    department: Maybe<ITag>;
    email: Maybe<Scalars["String"]["output"]>;
    feedCount: Scalars["Int"]["output"];
    firstName: Maybe<Scalars["String"]["output"]>;
    followers: Array<IUser>;
    following: Array<IFollowTarget>;
    fullName: Maybe<Scalars["String"]["output"]>;
    groups: Array<IGroup>;
    intercomId: Maybe<Scalars["ID"]["output"]>;
    intercomUserHash: Scalars["String"]["output"];
    interests: Array<ITag>;
    /** Pulls the Geo data from the request IP */
    ipLocation: Maybe<IIpLocation>;
    isDisruptor: Maybe<Scalars["Boolean"]["output"]>;
    isFollowing: Scalars["Boolean"]["output"];
    isLimitedSiteAdmin: Maybe<Scalars["Boolean"]["output"]>;
    isLocked: Scalars["Boolean"]["output"];
    isSelfie: Maybe<Scalars["Boolean"]["output"]>;
    isSiteAdmin: Maybe<Scalars["Boolean"]["output"]>;
    isUnverifiable: Maybe<Scalars["Boolean"]["output"]>;
    jobTitle: Maybe<Scalars["String"]["output"]>;
    language: Maybe<Scalars["String"]["output"]>;
    lastName: Maybe<Scalars["String"]["output"]>;
    lastSeen: Maybe<Scalars["DateTime"]["output"]>;
    lastSignInAt: Maybe<Scalars["DateTime"]["output"]>;
    lastSignInProvider: Scalars["String"]["output"];
    latestNewsletterHtml: Maybe<Scalars["String"]["output"]>;
    linkedinId: Maybe<Scalars["String"]["output"]>;
    linkedinUrl: Maybe<Scalars["String"]["output"]>;
    newsletterFrequency: Maybe<INewsletterFrequency>;
    newsletterLastSentDate: Maybe<Scalars["Date"]["output"]>;
    notes: Scalars["String"]["output"];
    notificationEmail: Maybe<Scalars["String"]["output"]>;
    onboarding: Maybe<IOnboarding>;
    onboardingStatus: Maybe<IProcessStatusType>;
    posts: Array<IPost>;
    postsCount: Scalars["Int"]["output"];
    preferences: IUserPreferences;
    primaryGroup: Maybe<IGroup>;
    projects: Maybe<IProjects>;
    projectsCount: Scalars["Int"]["output"];
    role: Maybe<Scalars["String"]["output"]>;
    savedCollectionsCount: Scalars["Int"]["output"];
    savedCount: Scalars["Int"]["output"];
    savedPostsCount: Scalars["Int"]["output"];
    savedProductsCount: Scalars["Int"]["output"];
    savedProjectsCount: Scalars["Int"]["output"];
    savedStoriesCount: Scalars["Int"]["output"];
    searchable: Maybe<Scalars["Boolean"]["output"]>;
    showActionCenterBanner: Scalars["Boolean"]["output"];
    showDeleteUserWarning: Maybe<Scalars["Boolean"]["output"]>;
    showOnboardingBanner: Scalars["Boolean"]["output"];
    signInAttempts: Maybe<Array<ISignInAttempt>>;
    slug: Scalars["String"]["output"];
    socialMedia: Maybe<IUserSocialMediaLinks>;
    stories: Maybe<IStories>;
    storiesCount: Maybe<Scalars["Int"]["output"]>;
    subscribedToCampaign: Maybe<Scalars["Boolean"]["output"]>;
    subscribedToNewsletter: Maybe<Scalars["Boolean"]["output"]>;
    subscription: Maybe<IVendorSubscription>;
    timeZone: Maybe<Scalars["String"]["output"]>;
    title: Maybe<Scalars["String"]["output"]>;
    upvotes: Maybe<IUpvotes>;
    upvotesCount: Maybe<Scalars["Int"]["output"]>;
    verified: Scalars["Boolean"]["output"];
  };

export type IVendorUserAvatarArgs = {
  height: InputMaybe<Scalars["Int"]["input"]>;
  width: InputMaybe<Scalars["Int"]["input"]>;
};

export type IVendorUserPostsArgs = {
  audience: InputMaybe<IPostAudience>;
};

export type IVendorUserPostsCountArgs = {
  audience: InputMaybe<IPostAudience>;
};

export type IVendorUserProjectsArgs = {
  audience: InputMaybe<IProjectAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IVendorUserStoriesArgs = {
  audience: InputMaybe<IStoryAudience>;
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IVendorUserStoriesCountArgs = {
  audience: InputMaybe<IStoryAudience>;
};

export type IVendorUserUpvotesArgs = {
  cursor: InputMaybe<Scalars["Cursor"]["input"]>;
  limit?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<ISortType>;
};

export type IVendors = {
  __typename: "Vendors";
  items: Array<ICompany>;
  pageInfo: Maybe<IPageInfo>;
};

export type IVendorsCount = {
  __typename: "VendorsCount";
  activeCount: Scalars["Int"]["output"];
  allCount: Scalars["Int"]["output"];
  archivedCount: Scalars["Int"]["output"];
  disruptorsCount: Scalars["Int"]["output"];
  inactiveCount: Scalars["Int"]["output"];
};

export type IVerification = {
  __typename: "Verification";
  attachments: Maybe<Array<Scalars["String"]["output"]>>;
  decision: Maybe<Scalars["String"]["output"]>;
  explanation: Maybe<Scalars["String"]["output"]>;
  renderedAt: Maybe<Scalars["DateTime"]["output"]>;
  renderedBy: Maybe<IUser>;
};

export enum IVerificationInput {
  None = "NONE",
  Unverified = "UNVERIFIED",
  Verified = "VERIFIED",
}

export type IWebProductDeployment = {
  __typename: "WebProductDeployment";
  mobileResponsive: Scalars["Boolean"]["output"];
  supportedBrowsers: Array<Scalars["String"]["output"]>;
};

export enum IWorkPlaceType {
  Government = "GOVERNMENT",
  None = "NONE",
  NonprofitOrNgo = "NONPROFIT_OR_NGO",
  Other = "OTHER",
  StateOrFederalAgency = "STATE_OR_FEDERAL_AGENCY",
  Vendor = "VENDOR",
}
